var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g15, _g16, _path10, _path11, _path12, _g17, _g18, _path13, _path14, _path15, _path16, _path17, _g19, _g20, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g21, _g22, _path26, _path27, _path28, _g23, _g24, _path29, _g25, _g26, _g27, _g28, _g29, _g30, _path30, _path31, _path32, _path33, _path34, _path35, _g31, _g32, _path36, _path37, _g33, _g34, _g35, _g36, _g37, _g38, _path38, _path39, _g39, _g40, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g41, _g42, _g43, _g44, _g45, _g46, _path52, _path53, _path54, _path55, _g47, _g48, _g49, _g50, _path56, _g51, _g52, _path57, _g53, _g54, _g55, _g56, _path58, _path59, _path60, _path61, _g57, _g58, _g59, _g60, _g61, _g62, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _path122, _path123, _g71, _g72, _g73, _g74, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _g75, _g76, _g77, _g78, _path160, _path161, _g79, _g80, _g81, _g82, _g83, _g84, _path162, _g85, _g86, _g87, _g88, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _g89, _g90, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _g101, _g102, _path185, _path186, _path187, _path188, _path189, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _path190, _path191, _path192, _path193, _g119, _g120, _path194, _path195, _path196, _path197, _g121, _g122, _path198, _path199, _g123, _g124, _path200, _path201, _path202, _path203, _g125, _g126, _path204, _path205, _g127, _g128, _path206, _path207, _path208, _path209, _g129, _g130, _path210, _path211, _path212, _g131, _g132, _g133, _g134, _g135, _g136, _path213, _g137, _g138, _g139, _g140, _path214, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _path215, _g153, _g154, _path216, _path217, _path218, _g155, _g156, _g157, _g158, _g159, _g160, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _g161, _g162, _g163, _g164, _path231, _g165, _g166, _g167, _g168, _path232, _path233, _path234, _g169, _g170, _g171, _g172, _path235, _path236, _path237, _g173, _g174, _path238, _path239, _path240, _path241, _path242, _g175, _g176, _path243, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _g187, _g188, _g189, _g190, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "homepage 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blueStain"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 90,
    width: 301,
    height: 292
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3e3fb1403c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.6667 90.6667H334.667V381.333H34.6667V90.6667Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: 31,
    width: 427,
    height: 420
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bc731d8847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M149.719 31.2656L404.714 227.896L233.12 450.422L-21.875 253.792L149.719 31.2656Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: 31,
    width: 427,
    height: 420
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "939f18dba1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M149.719 31.2656L404.714 227.896L233.12 450.422L-21.875 253.792L149.719 31.2656Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -22,
    y: 31,
    width: 427,
    height: 420
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "a9f575a2bc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M149.719 31.2656L404.714 227.896L233.12 450.422L-21.875 253.792L149.719 31.2656Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M147.188 105.422C139.635 99.5729 132.026 92.7604 122.333 91.8385C107.734 90.4531 94.0469 103.505 88.5104 117.818C82.9792 132.13 83.3594 147.594 82.2813 162.646C81.2083 177.703 78.0625 193.859 67.4636 205.068C60.5365 212.401 51.0313 216.891 44.5729 224.646C35.7031 235.292 34.1927 250.448 37.4115 263.302C40.6302 276.161 47.9115 287.266 55.0781 298.115C64.8698 312.943 75.4167 328.427 91.6146 335.599C119.313 347.859 154.63 332.12 182.781 343.396C201.797 351.016 214.385 369.849 233.589 377.036C254.286 384.786 279.552 376.917 296.922 361.052C314.297 345.188 324.521 322.552 329.328 299.807C334.135 277.057 334.005 253.901 333.854 230.969C333.729 211.844 333.344 191.719 323.766 175.906C312.313 156.979 290.073 147.406 269.609 141.385C256.083 137.406 241.599 138.495 227.552 137.286C212.495 135.995 197.443 131.88 183.661 126.307C170.594 121.021 158.281 114.01 147.188 105.422Z",
    fill: "#C3EBE3"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "redStain"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 68,
    width: 374,
    height: 355
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "a5e1cb1f1d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M97.3333 68H470.667V422.667H97.3333V68Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 37,
    width: 472,
    height: 432
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "0d0fe8eea5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M521.891 339.677L157.031 468.698L50.0104 166.068L414.87 37.0417L521.891 339.677Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 37,
    width: 472,
    height: 432
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "e5038ae724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M521.891 339.677L157.031 468.698L50.0104 166.068L414.87 37.0417L521.891 339.677Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 37,
    width: 472,
    height: 432
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "8ef1544eb7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M521.891 339.677L157.031 468.698L50.0104 166.068L414.87 37.0417L521.891 339.677Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M329.995 367.219C350.948 347.052 381.823 341.12 408.844 332.25C435.891 323.375 473.109 307.812 469.115 272.344C467.589 258.781 459.281 245.896 447.521 238.839C435.125 231.401 418.714 229.562 410.443 217.594C403.901 208.125 405.016 195.495 408.38 184.839C413.781 167.74 424.052 152.766 429.938 135.849C435.823 118.932 436.406 97.9323 424.214 84.0677C411.943 70.1146 391.51 68.2448 373.49 68.8646C335.344 70.1718 295.104 79.4062 270.286 107.792C255.589 124.594 247.208 147.135 229.542 160.708C206.693 178.26 174.198 176.562 147.839 188.333C116.437 202.359 95.8594 237.031 97.9896 272.349C100.109 307.667 124.807 341.484 157.823 354.286C173.271 360.281 190 361.953 205.229 368.552C217.198 373.74 227.984 381.937 236.302 392.172C245.109 403.005 252.312 416.932 265.38 421.229C278.76 425.635 292.781 417.609 301.563 407.078C310.339 396.542 315.844 383.479 324.641 372.958C326.339 370.922 328.125 369.016 329.995 367.219Z",
    fill: "#F97575"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "earth"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 130,
    width: 240,
    height: 241
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "b6815c6145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M145.333 130.339H384.974V370.667H145.333V130.339Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M384.797 250.083C384.797 250.589 384.797 251.094 384.776 251.594C384.734 256.031 384.443 260.448 383.891 264.849C383.641 266.823 383.344 268.792 383 270.75C382.656 272.708 382.266 274.656 381.823 276.599C381.38 278.536 380.891 280.464 380.354 282.38C379.812 284.297 379.229 286.198 378.594 288.083C377.964 289.969 377.286 291.839 376.557 293.688C375.833 295.542 375.062 297.375 374.245 299.188C373.427 301 372.568 302.792 371.661 304.563C370.755 306.333 369.802 308.083 368.807 309.802C367.818 311.526 366.781 313.224 365.703 314.896C364.625 316.568 363.505 318.214 362.344 319.828C361.187 321.443 359.984 323.031 358.745 324.583C357.51 326.141 356.229 327.667 354.917 329.156C353.599 330.651 352.25 332.109 350.865 333.531C349.474 334.958 348.052 336.349 346.594 337.698C345.141 339.052 343.651 340.37 342.125 341.651C340.604 342.927 339.052 344.172 337.469 345.37C335.88 346.573 334.271 347.734 332.625 348.859C330.984 349.979 329.318 351.057 327.62 352.099C325.922 353.135 324.203 354.13 322.458 355.083C320.714 356.036 318.943 356.943 317.151 357.807C315.365 358.672 313.552 359.49 311.719 360.266C309.891 361.036 308.036 361.766 306.172 362.448C304.302 363.13 302.417 363.76 300.521 364.349C298.62 364.938 296.708 365.479 294.781 365.969C292.854 366.464 290.917 366.906 288.969 367.302C287.021 367.698 285.062 368.042 283.099 368.339C281.13 368.635 279.161 368.885 277.182 369.083C275.203 369.286 273.219 369.432 271.234 369.536C269.25 369.635 267.266 369.688 265.276 369.688C263.286 369.688 261.302 369.641 259.312 369.542C257.328 369.443 255.349 369.297 253.37 369.099C251.391 368.906 249.417 368.656 247.453 368.365C245.484 368.068 243.526 367.724 241.578 367.333C239.63 366.938 237.693 366.495 235.766 366.005C233.839 365.516 231.922 364.979 230.026 364.396C228.125 363.813 226.24 363.177 224.37 362.5C222.5 361.823 220.651 361.094 218.818 360.323C216.984 359.552 215.172 358.734 213.38 357.875C211.589 357.01 209.818 356.104 208.073 355.156C206.328 354.208 204.604 353.214 202.906 352.177C201.208 351.141 199.542 350.063 197.896 348.943C196.25 347.823 194.635 346.667 193.052 345.464C191.464 344.266 189.911 343.026 188.385 341.75C186.865 340.474 185.37 339.156 183.911 337.807C182.453 336.453 181.031 335.068 179.641 333.641C178.25 332.219 176.901 330.76 175.583 329.271C174.266 327.781 172.984 326.26 171.745 324.703C170.505 323.151 169.302 321.568 168.141 319.953C166.979 318.339 165.859 316.698 164.776 315.026C163.698 313.354 162.661 311.661 161.661 309.938C160.667 308.214 159.714 306.469 158.807 304.698C157.901 302.932 157.036 301.141 156.214 299.328C155.396 297.516 154.62 295.682 153.896 293.833C153.167 291.979 152.484 290.115 151.849 288.229C151.214 286.344 150.625 284.443 150.089 282.526C149.547 280.615 149.052 278.688 148.609 276.745C148.167 274.807 147.771 272.859 147.422 270.901C147.073 268.943 146.776 266.974 146.526 265C146.276 263.026 146.078 261.047 145.927 259.068C145.776 257.083 145.677 255.094 145.625 253.104C145.573 251.12 145.568 249.13 145.62 247.141C145.667 245.151 145.76 243.167 145.906 241.182C146.052 239.198 146.25 237.219 146.495 235.245C146.74 233.271 147.036 231.302 147.375 229.344C147.437 228.995 147.495 228.646 147.573 228.297C148.198 224.891 148.974 221.521 149.891 218.182C150.812 214.844 151.875 211.552 153.078 208.302C154.286 205.057 155.63 201.87 157.115 198.74C158.594 195.615 160.214 192.552 161.958 189.563C163.708 186.578 165.583 183.667 167.583 180.844C169.583 178.016 171.703 175.281 173.943 172.641C176.182 170 178.526 167.458 180.984 165.021C183.443 162.583 186.005 160.26 188.667 158.047C191.328 155.828 194.078 153.734 196.922 151.76C199.76 149.781 202.687 147.932 205.687 146.214C208.693 144.49 211.766 142.901 214.906 141.448C218.047 139.995 221.245 138.677 224.5 137.5C227.755 136.328 231.052 135.292 234.396 134.401C237.745 133.516 241.12 132.771 244.531 132.177C247.937 131.578 251.365 131.13 254.818 130.833C258.266 130.536 261.719 130.391 265.177 130.391C268.312 130.391 271.406 130.505 274.479 130.74C276.333 130.885 278.187 131.073 280.031 131.302C281.88 131.536 283.719 131.807 285.552 132.125C287.385 132.443 289.208 132.802 291.026 133.208C292.844 133.609 294.651 134.052 296.448 134.542C298.24 135.026 300.026 135.557 301.797 136.125C303.568 136.698 305.323 137.307 307.068 137.958C308.812 138.615 310.536 139.302 312.245 140.036C313.958 140.771 315.651 141.542 317.323 142.354C319 143.167 320.656 144.016 322.286 144.906C323.922 145.797 325.536 146.724 327.13 147.688C328.719 148.651 330.286 149.651 331.833 150.688C333.38 151.729 334.896 152.802 336.391 153.906C337.891 155.016 339.354 156.161 340.797 157.339C342.24 158.516 343.651 159.724 345.036 160.969C346.422 162.208 347.781 163.484 349.104 164.792C350.432 166.099 351.724 167.432 352.99 168.802C354.25 170.167 355.484 171.563 356.682 172.99C357.88 174.411 359.042 175.865 360.177 177.344C361.307 178.823 362.401 180.323 363.464 181.854C364.521 183.385 365.547 184.938 366.536 186.516C367.521 188.094 368.474 189.693 369.385 191.318C370.302 192.938 371.177 194.578 372.01 196.245C372.849 197.906 373.646 199.589 374.406 201.286C375.167 202.99 375.88 204.703 376.562 206.438C377.24 208.172 377.875 209.922 378.474 211.682C379.073 213.448 379.625 215.224 380.141 217.016C380.656 218.802 381.125 220.604 381.557 222.417C381.99 224.229 382.375 226.047 382.719 227.875C383.068 229.708 383.37 231.542 383.625 233.385C383.885 235.229 384.104 237.078 384.276 238.932C384.448 240.786 384.578 242.641 384.667 244.505C384.755 246.365 384.797 248.224 384.797 250.083Z",
    fill: "#B3E5F8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 130,
    width: 140,
    height: 152
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "b4e0aff2e5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M146.667 130.339H285.333V281.333H146.667V130.339Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M283.068 159.802C280.901 162.125 277.479 162.667 274.323 163.052C269.917 163.615 264.849 164.542 262.703 168.432C261.271 171.063 261.021 175.031 258.12 175.708C256.677 175.859 255.349 175.536 254.135 174.74C249.901 172.609 244.911 168.995 246.073 164.37C246.536 163.078 247.12 161.844 247.833 160.672C248.141 159.984 248.38 159.271 248.552 158.531C248.724 157.797 248.823 157.052 248.854 156.297C248.885 155.542 248.849 154.792 248.74 154.047C248.625 153.297 248.448 152.568 248.198 151.854C247.953 151.141 247.635 150.458 247.26 149.802C246.885 149.151 246.448 148.536 245.953 147.964C245.464 147.391 244.922 146.875 244.328 146.401C243.74 145.932 243.109 145.526 242.437 145.172C241.745 144.875 241.026 144.646 240.292 144.484C239.552 144.318 238.807 144.229 238.052 144.208C237.297 144.188 236.547 144.234 235.797 144.359C235.052 144.479 234.328 144.672 233.615 144.927C232.906 145.188 232.229 145.51 231.578 145.901C230.932 146.286 230.323 146.734 229.76 147.234C229.198 147.74 228.682 148.292 228.224 148.891C227.766 149.49 227.365 150.13 227.026 150.802C226.656 151.453 226.568 152.135 226.755 152.854C227.047 153.63 227.875 154.016 228.573 154.479C231.646 156.531 232.443 160.651 232.964 164.349C233.182 165.297 233.141 166.229 232.849 167.156C232.323 168.182 231.531 168.927 230.469 169.38C226.661 171.469 221.052 172.109 218.75 168.432C217.714 166.172 217.516 163.844 218.172 161.448C218.818 159.063 218.693 156.724 217.802 154.422C216.661 152.313 213.318 151.344 211.906 153.26C210.375 155.349 212.391 158.271 211.865 160.807C211.401 163.109 209.005 164.385 206.937 165.51C200.885 168.797 195.646 173.083 191.214 178.359C190.25 179.5 189.281 181.026 189.917 182.38C190.443 183.464 191.755 183.891 192.646 184.703C194.635 186.542 194.135 190.063 196.109 191.922C198.391 194.089 202.448 192.307 203.781 189.464C205.12 186.62 204.672 183.313 204.5 180.177C204.354 179.443 204.385 178.714 204.609 178C204.828 177.281 205.203 176.661 205.734 176.13C206.906 175.563 208.104 175.495 209.333 175.922C214.943 177.12 220.531 178.339 226.135 179.536C229.062 179.875 231.641 181.005 233.87 182.922C235.224 184.604 236.151 186.495 236.656 188.594C237.333 190.74 238.01 192.87 238.687 195C239.458 197.417 240.042 200.552 238.01 202.099C234.875 204.5 230.932 199.818 226.969 199.641C220.547 199.37 219.542 209.953 213.625 212.432C212.021 213.109 210.182 213.089 208.62 213.823C202.469 216.708 204.672 227.833 198.542 230.719C197.583 231.021 196.672 231.443 195.818 231.974C193.458 233.911 195.255 237.74 194.635 240.74C193.922 244.182 189.937 245.984 186.417 245.964C182.901 245.943 179.495 244.63 175.995 244.339C172.495 244.047 168.396 245.25 167.005 248.479C166.854 248.938 166.76 249.406 166.724 249.885C166.682 250.365 166.708 250.844 166.786 251.318C166.865 251.792 167 252.25 167.193 252.693C167.385 253.13 167.63 253.542 167.922 253.927C168.214 254.307 168.547 254.646 168.927 254.948C169.302 255.245 169.708 255.495 170.146 255.698C170.583 255.896 171.036 256.042 171.51 256.13C171.984 256.219 172.464 256.25 172.943 256.219C175.958 255.776 179.786 253.219 181.432 255.813C182.109 256.875 181.797 258.271 182.068 259.51C182.88 263.396 188.37 264.193 190.458 267.578C192.047 270.151 191.599 274.078 194.214 275.589C195.062 276.089 196.167 276.245 196.745 277.021C197.792 278.432 196.047 280.521 194.292 280.464C192.484 280.156 191.021 279.281 189.901 277.833C188.786 276.38 187.328 275.474 185.531 275.125C184.12 275.026 182.745 275.781 181.333 275.682C178.781 275.51 177.271 272.88 175.453 271.078C171.297 267.016 164.354 266.995 160.161 262.953C153.682 256.724 157.411 245.443 153.469 237.375C151.885 234.12 149.12 231.531 147.573 228.297C148.198 224.891 148.974 221.521 149.891 218.182C150.812 214.844 151.875 211.552 153.078 208.307C154.286 205.057 155.63 201.87 157.115 198.74C158.594 195.615 160.214 192.552 161.958 189.563C163.708 186.578 165.583 183.667 167.583 180.844C169.583 178.016 171.703 175.281 173.943 172.641C176.182 170 178.526 167.458 180.984 165.021C183.443 162.583 186.005 160.26 188.667 158.047C191.328 155.828 194.078 153.734 196.922 151.76C199.76 149.781 202.687 147.932 205.687 146.214C208.693 144.49 211.766 142.901 214.906 141.448C218.047 139.995 221.245 138.677 224.5 137.5C227.755 136.328 231.052 135.292 234.396 134.401C237.745 133.516 241.12 132.771 244.531 132.177C247.937 131.578 251.365 131.13 254.818 130.833C258.266 130.536 261.719 130.391 265.177 130.391C268.312 130.391 271.406 130.505 274.479 130.74C275.708 134.297 277.312 137.677 279.297 140.88C281.333 143.714 283.042 146.74 284.417 149.953C284.75 150.76 284.969 151.599 285.078 152.464C285.182 153.328 285.177 154.193 285.062 155.057C284.943 155.922 284.714 156.755 284.375 157.563C284.036 158.365 283.599 159.115 283.068 159.802Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 150,
    width: 84,
    height: 197
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "9c5fc5906c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M301.333 150.667H384.974V346.667H301.333V150.667Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M374.182 245.984C373.562 251.229 376.578 256.182 380 260.167C381.375 261.661 382.672 263.224 383.891 264.849C383.401 268.792 382.724 272.703 381.844 276.578C380.969 280.453 379.901 284.276 378.646 288.047C377.385 291.818 375.943 295.51 374.318 299.135C372.693 302.76 370.891 306.297 368.911 309.745C366.932 313.188 364.786 316.526 362.474 319.755C360.161 322.984 357.693 326.094 355.068 329.078C352.448 332.063 349.682 334.906 346.776 337.615C343.87 340.323 340.833 342.88 337.672 345.286C334.234 345.719 330.812 345.63 327.406 345.016C326.146 344.802 324.698 344.339 324.292 343.115C324.094 342.38 324.151 341.667 324.464 340.969C326.417 335.552 332.625 332.224 333.615 326.552C333.714 325.021 333.917 323.495 334.214 321.99C335.604 317.635 341.849 315.62 341.964 311.057C342.026 308.365 339.781 305.87 340.417 303.255C341.01 301.865 341.818 300.604 342.839 299.484C343.344 298.698 343.714 297.854 343.948 296.948C344.182 296.047 344.271 295.125 344.208 294.193C344.146 293.26 343.937 292.359 343.583 291.495C343.229 290.63 342.75 289.844 342.141 289.13C339.005 285.63 333.615 285.359 328.99 286.229C324.37 287.099 319.844 288.901 315.167 288.589C307.141 288.047 300.141 279.922 301.667 272.01C302.75 266.495 305.417 260.438 305.63 254.828C305.698 253.438 305.932 252.078 306.328 250.745C306.729 249.417 307.281 248.151 307.984 246.953C308.693 245.76 309.531 244.661 310.505 243.672C311.474 242.677 312.552 241.818 313.734 241.089C314.807 240.609 315.672 239.88 316.323 238.901C316.615 237.932 316.802 236.948 316.885 235.943C317.833 232.302 322.802 232.109 326.344 230.776C330.693 229.151 333.901 224.797 338.505 224.156C343.995 223.385 348.521 228.083 352.464 231.974C353.51 233.24 354.833 234.063 356.432 234.432C360.219 234.917 363.198 229.807 366.948 230.641C369.25 231.141 371.646 233.792 373.427 232.224C374.609 231.182 374.005 229.266 373.328 227.833C372.542 225.833 371.37 224.094 369.812 222.609C369.417 222.255 368.974 221.969 368.49 221.755C368.005 221.542 367.495 221.406 366.969 221.354C366.437 221.302 365.917 221.333 365.396 221.448C364.875 221.563 364.391 221.755 363.932 222.031C363.276 222.531 362.734 223.286 361.943 223.5C359.812 224.063 358.536 220.677 356.354 220.542C354.922 220.443 353.781 221.797 352.349 221.932C350.646 222.089 349.297 220.479 348.693 218.896C348.307 217.214 347.682 215.63 346.818 214.135C344.208 210.729 338.62 212.411 335.448 215.333C332.276 218.255 329.63 222.224 325.432 223.151C324.875 223.25 324.307 223.286 323.74 223.271C323.172 223.25 322.615 223.177 322.062 223.042C321.51 222.906 320.974 222.719 320.464 222.479C319.948 222.234 319.464 221.943 319.01 221.604C318.557 221.26 318.141 220.875 317.766 220.448C317.391 220.021 317.062 219.563 316.781 219.068C316.505 218.573 316.276 218.057 316.099 217.516C315.927 216.974 315.807 216.422 315.745 215.854C315.672 215.161 315.786 214.495 316.094 213.865C317.734 210.943 323.578 213.786 325.083 210.786C326.344 208.313 322.646 206.005 322.474 203.24C322.547 202.234 322.891 201.328 323.495 200.526C324.099 199.719 324.875 199.141 325.818 198.792C327.682 198.13 329.443 197.26 331.099 196.177C332.995 194.573 333.823 191.943 335.854 190.526C339.104 188.266 345.078 189.172 345.932 185.286C346.078 183.927 345.823 182.646 345.156 181.453C343.609 177.833 342.042 174.234 340.495 170.62C340.281 169.953 339.901 169.406 339.354 168.974C337.807 167.948 335.818 170.094 336.047 171.932C336.573 173.734 337.427 175.365 338.599 176.828C339.547 178.438 339.896 180.813 338.406 181.917C336.26 180.156 333.359 179.729 330.75 178.802C328.141 177.875 325.453 175.901 325.396 173.115C325.354 170.734 327.328 168.703 327.484 166.302C327.318 164.469 326.937 162.682 326.344 160.943C326.224 160.229 326.208 159.516 326.286 158.797C326.365 158.078 326.542 157.385 326.807 156.714C327.078 156.047 327.432 155.422 327.875 154.849C328.312 154.276 328.818 153.771 329.396 153.339C330.656 152.438 332.062 151.958 333.615 151.906C337.552 154.651 341.312 157.625 344.891 160.823C348.469 164.021 351.849 167.427 355.016 171.031C358.187 174.635 361.13 178.422 363.844 182.38C366.562 186.344 369.026 190.453 371.25 194.708C373.469 198.969 375.427 203.344 377.12 207.839C378.812 212.333 380.229 216.911 381.37 221.578C382.51 226.245 383.37 230.958 383.943 235.729C384.516 240.495 384.802 245.281 384.797 250.083C384.797 250.589 384.797 251.094 384.776 251.594C383.406 251.328 382.172 250.766 381.068 249.911C379.984 249.063 379.094 247.974 378.01 247.104C377.49 246.635 376.896 246.302 376.224 246.104C375.552 245.906 374.87 245.87 374.182 245.984Z",
    fill: "white"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M205.448 274.229C209.188 273.792 212.802 274.281 216.292 275.703C226 279.052 234.859 283.953 242.859 290.396C245.844 292.776 248.948 295.448 252.745 295.813C255.917 296.12 259.021 294.755 262.203 294.734C262.661 294.734 263.12 294.76 263.573 294.813C264.031 294.87 264.479 294.948 264.927 295.057C265.37 295.172 265.807 295.307 266.24 295.469C266.667 295.635 267.083 295.823 267.49 296.036C267.896 296.25 268.286 296.49 268.661 296.755C269.036 297.016 269.396 297.302 269.734 297.609C270.078 297.917 270.401 298.245 270.698 298.589C271 298.938 271.281 299.302 271.536 299.682C271.792 300.063 272.021 300.458 272.229 300.865C272.438 301.276 272.62 301.698 272.776 302.13C272.932 302.563 273.057 303 273.161 303.448C273.26 303.896 273.333 304.349 273.38 304.807C273.427 305.26 273.448 305.719 273.438 306.177C273.427 306.635 273.385 307.094 273.318 307.547C273.255 308 273.161 308.453 273.036 308.896C272.917 309.339 272.766 309.771 272.594 310.193C271.052 313.245 268.922 315.813 266.214 317.896L261.599 322.021C260.339 322.964 259.391 324.161 258.766 325.609C258.349 326.865 258.51 328.245 258.161 329.521C257.37 332.453 254.276 333.995 251.755 335.693C248.172 338.115 245.083 342.052 245.542 346.349C246.292 353.37 255.896 357.958 254.505 364.885C250.948 364.245 248.151 361.563 245.594 359.01L236.698 350.13C230.719 344.495 225.271 338.396 220.339 331.823C217.995 328.5 215.932 324.979 213.536 321.693C209.849 316.635 205.49 312.25 200.458 308.536C197.531 306.375 194.078 303.88 194.031 300.24C193.969 294.656 198.984 291.479 198.328 285.536C197.708 279.99 199.073 275.396 205.448 274.229Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M190.266 255.094C190.359 254.609 190.552 254.161 190.839 253.755C191.125 253.349 191.479 253.021 191.901 252.766C192.328 252.51 192.786 252.349 193.276 252.286C193.771 252.224 194.25 252.266 194.724 252.406C196.661 253.073 197.677 255.271 199.526 256.156C201.266 256.729 203.021 256.797 204.802 256.365C207.125 256.099 209.437 256.141 211.75 256.49C212.682 256.568 213.531 256.875 214.297 257.411C214.672 257.693 214.922 258.063 215.047 258.516C215.172 258.974 215.135 259.417 214.953 259.849C214.505 260.469 213.906 260.839 213.156 260.969C208.161 262.375 203.026 261.307 198.135 260C195.568 259.318 189.698 259.203 190.266 255.094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M284.328 166.063C284.839 165.432 285.484 165.021 286.271 164.823C287.443 164.484 288.609 164.49 289.771 164.839C290.25 165.036 290.745 165.141 291.26 165.156C292.484 165.057 293.141 163.63 294.25 163.083C294.615 162.953 294.99 162.896 295.375 162.922C295.76 162.948 296.125 163.047 296.474 163.224C296.818 163.401 297.109 163.641 297.359 163.938C297.604 164.24 297.776 164.578 297.88 164.948C298.047 165.729 298 166.49 297.74 167.24C297.484 167.995 297.047 168.625 296.443 169.135C294.13 171.24 291.479 170.453 288.714 170.167C286.865 169.979 282.328 168.797 284.328 166.063Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M311.641 192.672C310.99 189.63 314.807 187.094 314.438 184.005C314.281 182.677 313.344 181.365 313.802 180.104C313.896 179.87 314.036 179.661 314.214 179.479C314.391 179.302 314.594 179.156 314.828 179.057C315.057 178.953 315.302 178.901 315.552 178.891C315.807 178.885 316.052 178.922 316.292 179.01C317.167 179.542 317.771 180.292 318.109 181.26C320.182 184.766 322.719 187.901 325.719 190.656C326.203 191.094 326.568 191.615 326.807 192.219C326.917 192.531 326.922 192.844 326.818 193.156C326.714 193.469 326.526 193.719 326.25 193.901C326.031 194 325.807 194.052 325.568 194.068C324.786 194.198 324.021 194.146 323.271 193.917C322.516 193.682 321.854 193.297 321.281 192.75C320.63 192.01 320.302 190.974 319.484 190.417C319.172 190.208 318.823 190.089 318.443 190.062C318.063 190.036 317.703 190.104 317.359 190.271C316.292 190.797 315.88 192.073 315.266 193.094C314.109 195.016 312.12 194.917 311.641 192.672Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M366.229 203.167C366.651 202.885 367.115 202.714 367.615 202.635C367.859 202.573 368.104 202.568 368.354 202.62C368.578 202.698 368.781 202.823 368.953 202.995C369.594 203.542 370.193 204.135 370.75 204.771C371.203 205.229 371.516 205.766 371.693 206.38C371.776 207.536 371.437 208.557 370.682 209.432C370.531 209.688 370.349 209.917 370.135 210.125C368.578 211.49 365.792 210.703 366.104 208.536C366.391 207.708 366.453 206.865 366.302 206C365.958 204.953 364.937 204.109 366.229 203.167Z",
    fill: "#B3E5F8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logoEasyVFC"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.344 246.057L171.359 292.813H188.021L204.005 246.057H188.021L179.698 276.115L171.359 246.057H155.344Z",
    fill: "#01ABE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.026 246.057V292.813H224V278.109H241.026V265.099H224V259.109H246.333V246.057H209.026Z",
    fill: "#01ABE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.781 244.734C275.74 244.734 275.703 244.734 275.661 244.734C268.24 244.734 262 247.156 256.927 252.016C251.854 256.87 249.323 262.677 249.323 269.448C249.323 276.203 251.854 282.01 256.927 286.865C259.109 288.984 261.651 290.693 264.427 291.922V291.911C264.37 291.833 264.339 291.75 264.328 291.661C263.844 290.438 263.833 288.984 263.865 287.703C263.943 286.328 264.125 284.958 264.406 283.615C264.76 281.552 265.438 279.547 266.573 277.849L267.219 277.042C265.469 275.021 264.297 272.286 264.297 269.458C264.297 266.25 265.411 263.552 267.635 261.365C269.859 259.182 272.646 258.094 275.984 258.094C277.24 258.094 278.49 258.292 279.682 258.667C280.745 258.969 281.766 259.396 282.719 259.938C283.536 260.406 284.302 260.948 285.021 261.563C285.526 261.969 286 262.411 286.448 262.875C286.688 263.12 286.859 263.302 286.984 263.443L295.979 254.083L295.255 253.135C294.719 252.49 293.87 251.703 292.724 250.792C291.443 249.792 290.109 248.875 288.714 248.057C287.188 247.146 285.276 246.359 282.958 245.703C280.62 245.057 278.203 244.734 275.781 244.734Z",
    fill: "#01ABE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.318 275.469L286.859 275.99C286.49 276.344 285.974 276.781 285.313 277.313C284.578 277.891 283.818 278.427 283.021 278.927C282.021 279.526 280.938 279.969 279.807 280.26C278.563 280.604 277.286 280.786 275.984 280.786C275.932 280.786 275.88 280.786 275.828 280.786C274.234 280.786 272.646 280.474 271.172 279.87C268.938 283.333 268.349 288.349 269.714 292.198C269.828 292.427 269.927 292.682 270 292.932C270.078 293.115 270.161 293.297 270.25 293.469C270.281 293.547 270.302 293.62 270.313 293.698C272.031 293.99 273.755 294.146 275.495 294.146C275.552 294.146 275.604 294.146 275.661 294.146C275.698 294.146 275.74 294.146 275.776 294.146C278.219 294.146 280.661 293.802 283.021 293.156C285.406 292.49 287.318 291.75 288.771 290.922C290.208 290.094 291.573 289.146 292.849 288.068C294.13 286.995 294.948 286.24 295.313 285.823C295.589 285.5 295.859 285.156 296.104 284.786L287.318 275.469Z",
    fill: "#01ABE9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.177 247.25L285.641 251.036L283.484 254.922L282.484 259.797C284.375 260.88 286.729 263.141 286.729 263.141L287.083 262.141L289.703 258.99L293.12 252.026L292.583 250.771C291.693 249.865 287.177 247.25 287.177 247.25Z",
    fill: "#01ABE9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.802 211.557C341.901 211.557 340.927 211.656 339.875 211.854L340.208 213.63C341.156 213.448 342.026 213.359 342.807 213.359C344.573 213.359 345.911 213.818 346.802 214.729C348.823 216.781 348.047 220.604 348.036 220.677L343.495 246.302L345.286 246.474L349.802 221.01C349.844 220.818 350.786 216.224 348.104 213.469C346.854 212.198 345.078 211.557 342.802 211.557Z",
    fill: "#76E297"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 176,
    width: 74,
    height: 107
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "58285d1af5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M304 176H377.188V282.667H304V176Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M343.494 246.302L348.036 220.677C348.046 220.604 348.822 216.781 346.802 214.729C345.515 213.417 343.302 213.036 340.208 213.63L339.875 211.854C343.599 211.156 346.359 211.693 348.104 213.469C350.786 216.224 349.843 220.818 349.802 221.01L345.286 246.474L343.494 246.302Z",
    stroke: "#76E297",
    strokeWidth: 1.75255,
    strokeMiterlimit: 14.299
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.781 216.76C307.031 217.313 304.594 218.729 303.542 220.979V220.99C301.906 224.464 304.292 228.5 304.401 228.672L317.495 252.188L319.063 251.297L305.948 227.766C305.917 227.703 303.938 224.344 305.172 221.745C305.958 220.073 307.932 219 311.052 218.536L310.781 216.76Z",
    fill: "#76E297"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M303.541 220.979C304.593 218.729 307.031 217.313 310.781 216.76L311.052 218.536C307.932 219 305.958 220.073 305.172 221.745C303.937 224.344 305.916 227.703 305.948 227.766L319.062 251.297L317.494 252.188L304.401 228.672C304.291 228.5 301.895 224.464 303.541 220.979Z",
    stroke: "#76E297",
    strokeWidth: 1.75255,
    strokeMiterlimit: 14.299
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.969 246.797C342.938 247.089 342.099 253.953 334.75 256.094C332.979 256.609 331.359 256.828 329.891 256.828C324.292 256.828 320.875 253.651 319.708 251.542L317.344 252.854C318.823 255.505 323.063 259.531 329.885 259.531C331.594 259.531 333.469 259.281 335.5 258.688C344.63 256.031 345.609 247.443 345.641 247.078L342.969 246.797Z",
    fill: "#01ABE9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 205,
    width: 102,
    height: 97
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "a31403a0d3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M276 205.333H377.188V301.333H276V205.333Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M345.64 247.078C345.609 247.443 344.63 256.031 335.5 258.688C325.359 261.635 319.192 256.172 317.343 252.854L319.708 251.542C321.182 254.203 326.239 258.568 334.75 256.094C342.099 253.953 342.937 247.089 342.968 246.797L345.64 247.078Z",
    stroke: "#01ABE9",
    strokeWidth: 2.02096,
    strokeMiterlimit: 14.299
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.089 211.438L334.729 211.49C334.729 211.49 334.719 211.49 334.708 211.49C334.51 211.49 332.797 211.557 333.182 213.911V213.943H333.172C333.448 215.526 334.281 215.813 334.854 215.813C335.182 215.813 335.427 215.719 335.427 215.719L339.573 214.339L339.328 212.911V212.865L339.089 211.438Z",
    fill: "#01ABE9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M333.182 213.943V213.911C332.77 211.417 334.729 211.49 334.729 211.49L339.088 211.438L339.328 212.865V212.911L339.572 214.339L335.427 215.719C335.427 215.719 333.619 216.427 333.182 213.943Z",
    stroke: "#01ABE9",
    strokeWidth: 1.07508,
    strokeMiterlimit: 14.299
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.104 214.635C315.781 214.635 315.542 214.729 315.542 214.729L311.396 216.104L311.641 217.536V217.578L311.875 219.01L316.25 218.958C316.25 218.958 316.255 218.958 316.266 218.958C316.464 218.958 318.161 218.891 317.786 216.536V216.505C317.505 214.922 316.672 214.635 316.104 214.635Z",
    fill: "#01ABE9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M317.786 216.536V216.505C317.343 214.016 315.541 214.729 315.541 214.729L311.395 216.104L311.64 217.536V217.578L311.875 219.01L316.25 218.958C316.25 218.958 318.182 219.031 317.786 216.536Z",
    stroke: "#01ABE9",
    strokeWidth: 1.07508,
    strokeMiterlimit: 14.299
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.661 271.943C349.302 271.943 352.995 272.714 356.656 274.526C364.026 278.161 366.333 284.99 365.365 290.156C364.354 295.557 360.047 299.234 354.141 299.755C353.792 299.781 353.448 299.797 353.115 299.797C342.068 299.797 338.792 283.49 338.26 280.354C338.208 280.042 338.187 279.859 338.187 279.839C338.187 279.818 337.542 276.042 337.078 273.276C339.875 272.438 342.75 271.943 345.661 271.943ZM334.521 258.083L331.568 258.578L333.698 271.234C327.766 273.448 321.641 277.255 315.411 282.667C313.682 284.172 312.026 285.755 310.417 287.286C303.281 294.094 296.536 300.526 282.839 300.99C282.562 301 282.292 301.005 282.021 301.005C274.49 301.005 270.875 297.401 269.151 293.589L268.927 293.536C267.875 293.297 266.755 293.052 265.682 292.729C267.312 297.974 271.458 303.995 282 303.995C282.307 303.995 282.62 303.99 282.937 303.979C297.771 303.495 305.25 296.354 312.49 289.448C314.068 287.953 315.693 286.391 317.375 284.927C322.073 280.849 327.885 276.729 334.203 274.255L335.219 280.292C335.234 280.375 335.266 280.656 335.339 281.109C336.026 285.208 339.771 302.802 353.026 302.802C353.474 302.802 353.932 302.786 354.396 302.745C361.703 302.109 367.031 297.495 368.307 290.714C369.49 284.432 366.75 276.172 357.984 271.833C354.062 269.896 349.932 268.943 345.635 268.943C342.687 268.943 339.661 269.391 336.573 270.286C335.568 264.271 334.521 258.083 334.521 258.083Z",
    fill: "#01ABE9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 216,
    width: 154,
    height: 125
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "5b2df58950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M224 216H377.188V340.068H224V216Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M357.984 271.833C351.369 268.563 344.151 268.089 336.573 270.286C335.567 264.271 334.52 258.083 334.52 258.083L331.567 258.578L333.698 271.234C327.765 273.448 321.64 277.255 315.411 282.667C313.682 284.172 312.026 285.755 310.416 287.286C303.281 294.094 296.536 300.526 282.838 300.99C275.51 301.229 271.698 298.203 269.724 294.708C268.442 294.448 267.166 294.01 265.974 293.599C267.833 298.776 272.302 304.339 282.937 303.979C297.77 303.495 305.25 296.354 312.489 289.458C314.067 287.953 315.692 286.391 317.375 284.938C322.073 280.849 327.885 276.74 334.203 274.266L335.218 280.292C335.234 280.375 335.265 280.667 335.338 281.109C336.046 285.349 340.026 304.016 354.395 302.755C361.703 302.109 367.031 297.495 368.307 290.714C369.489 284.432 366.75 276.172 357.984 271.833ZM365.364 290.156C364.354 295.557 360.046 299.234 354.14 299.755C342.27 300.797 338.807 283.583 338.26 280.354C338.208 280.042 338.187 279.859 338.187 279.839C338.187 279.818 337.541 276.042 337.078 273.276C343.375 271.38 350.067 271.266 356.656 274.526C364.026 278.161 366.333 284.99 365.364 290.156Z",
    stroke: "#01ABE9",
    strokeWidth: 2.02096,
    strokeMiterlimit: 14.299
  }))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.729 209.953C177.021 209.953 177.172 210.318 177.172 211.036C177.172 211.781 176.443 212.88 174.99 214.328C173.531 215.792 172.078 216.953 170.62 217.828C169.599 218.354 168.542 218.797 167.448 219.141C166.974 219.292 166.62 219.365 166.385 219.365C166.151 219.365 166.031 219.292 166.031 219.141C166.031 219 166.255 218.635 166.687 218.052C167.125 217.458 167.63 216.849 168.214 216.193C168.792 215.536 169.37 214.88 169.964 214.224C170.411 213.682 170.917 213.214 171.49 212.802V212.792C172.391 212.047 173.38 211.427 174.443 210.932C175.536 210.427 176.302 210.089 176.729 209.953ZM176.073 207.802C175.203 207.802 174.078 208.089 172.693 208.672C171.271 209.276 169.922 209.995 168.651 210.854C164.12 213.964 160.443 218.172 157.953 223.078C156.781 225.401 156.052 227.661 155.76 229.833C155.469 232.016 155.687 233.833 156.417 235.286C157.156 236.901 158.115 237.953 159.271 238.464C160.177 238.854 161.208 239.052 162.37 239.052C162.714 239.052 163.068 239.031 163.432 239C163.536 239 163.641 239.005 163.75 239.005C164.589 239.005 165.437 238.927 166.266 238.786C166.995 238.635 167.943 238.266 169.104 237.688C170.703 236.953 172.818 235.792 175.443 234.193C178.083 232.578 180.63 230.833 183.089 228.953C184.401 227.938 186 226.625 187.891 225.026C189.781 223.432 191.568 221.859 193.245 220.333C194.917 218.797 196.339 217.484 197.505 216.396C198.667 215.297 199.25 214.688 199.25 214.536C199.25 214.333 199.161 214.234 198.99 214.234C198.792 214.234 198.479 214.37 198.047 214.641C197.24 215.156 195.672 216.365 193.339 218.255C185.917 224.521 179.469 229.177 174 232.234C169.589 234.703 166.245 235.938 163.969 235.938C163.432 235.938 162.958 235.865 162.536 235.729C159.766 234.859 159.844 231.286 162.755 225.036L163.849 222.422L164.932 223.292C165.594 223.745 166.323 223.969 167.12 223.969C169.146 223.969 171.625 222.505 174.552 219.578C175.891 218.234 177.062 216.729 178.052 215.104C179.062 213.438 179.578 212.234 179.578 211.5C179.568 210.781 179.167 209.974 178.365 209.099C177.568 208.229 176.807 207.802 176.073 207.802Z",
    fill: "#76E297"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.958 212.766C209.078 212.766 209.187 212.781 209.281 212.802C209.714 212.802 210 213.167 210.151 213.901C210.302 214.63 210.12 215.427 209.604 216.297C209.099 217.172 207.745 218.922 205.562 221.547C203.469 224.219 201.245 226.766 198.906 229.208C196.635 231.542 194.854 233.146 193.552 234.031C191.953 235.042 190.932 235.557 190.495 235.557C188.891 235.557 189.109 233.51 191.146 229.422C192.75 226.37 194.974 223.302 197.807 220.234C200.646 217.182 203.448 214.995 206.219 213.682C207.437 213.073 208.349 212.766 208.958 212.766ZM208.411 209.276C206.51 209.276 204.406 209.932 202.073 211.24C199.786 212.479 197.625 213.953 195.625 215.62C193.589 217.302 191.76 219.203 190.172 221.313C188.687 223.271 187.443 225.401 186.453 227.651C185.505 229.844 185.036 231.813 185.036 233.557C185.036 236.042 185.766 237.719 187.214 238.589C187.703 238.979 188.292 239.177 188.974 239.177C189.312 239.177 189.677 239.13 190.062 239.031C191.802 238.88 193.693 238.01 195.734 236.406C197.776 234.802 200.474 231.953 203.823 227.875C204.255 227.292 204.693 226.745 205.135 226.24C205.562 225.724 205.932 225.313 206.219 225.026L207.318 223.927V224.583C207.318 224.875 207.281 225.057 207.208 225.13C207.135 225.208 207.099 225.391 207.099 225.682C206.812 226.995 206.734 228.703 206.875 230.813C207.026 232.932 207.318 234.427 207.755 235.297C208.781 237.281 210.323 238.266 212.365 238.266C213.786 238.266 215.453 237.792 217.359 236.839C219.693 235.667 222.719 233.448 226.427 230.156C230.146 226.875 233.969 223.057 237.901 218.677C241.24 215.182 242.411 213.427 241.391 213.427C241.24 213.427 240.479 214.083 239.094 215.396C237.708 216.708 236 218.313 233.958 220.214C229.307 224.875 225.437 228.411 222.391 230.823C219.328 233.234 216.781 234.802 214.74 235.526C214.214 235.76 213.667 235.943 213.104 236.073C213.031 236.089 212.953 236.094 212.875 236.094C212.573 236.094 212.245 235.979 211.901 235.75C210.885 235.458 210.302 234.651 210.151 233.339C209.859 231.74 209.969 229.844 210.484 227.651C210.99 225.464 212.042 222.474 213.656 218.688C214.812 216.203 215.365 214.536 215.286 213.651C215.214 212.781 214.589 212.339 213.427 212.339C212.849 212.339 212.333 211.974 211.901 211.24C211.464 209.932 210.302 209.276 208.411 209.276Z",
    fill: "#76E297"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.349 227.552C242.62 227.552 242.812 228.286 242.948 229.745C243.078 231.208 243.146 232.406 243.146 233.328C242.745 236.656 240.427 239.042 236.182 240.505C235.036 240.833 233.828 240.995 232.552 240.995C231.766 240.995 230.953 240.932 230.115 240.807C227.932 240.474 226.833 239.839 226.833 238.911C226.833 237.719 228.62 235.99 232.208 233.729C233 233.198 233.927 232.599 234.99 231.943L238.172 229.953C239.234 229.286 240.167 228.714 240.964 228.25C241.76 227.786 242.219 227.552 242.349 227.552ZM249.911 203C247.656 203.13 245.604 204.026 243.745 205.693C241.885 207.349 240.63 209.5 239.964 212.156C239.042 215.214 239.297 218.729 240.76 222.724L241.76 225.906L238.375 227.896C235.453 229.49 233.13 230.823 231.411 231.891C229.995 232.729 228.63 233.661 227.328 234.672C226.328 235.469 225.667 236.193 225.333 236.859C225 237.536 224.828 238.292 224.839 239.052C224.839 239.979 225.234 240.776 226.031 241.443C227.234 242.635 229.156 243.432 231.807 243.828C232.099 243.844 232.385 243.849 232.677 243.849C235.182 243.849 237.75 243.307 240.359 242.24C242.885 241.042 244.703 239.323 245.828 237.063C246.958 234.802 247.323 232.276 246.927 229.49C246.797 228.823 246.687 228.198 246.625 227.594C246.557 227.005 246.464 226.573 246.333 226.302C246.193 225.906 246.365 225.51 246.828 225.109C247.292 224.714 248.578 223.979 250.708 222.917C253.094 221.453 255.776 219.859 258.766 218.13C261.75 216.406 264.437 214.813 266.823 213.349C269.344 211.62 270.203 210.76 269.411 210.76C269.281 210.76 268.776 210.953 267.917 211.359C267.057 211.76 265.104 212.823 262.052 214.547C259.13 216.266 256.349 217.87 253.693 219.323C251.042 220.786 249.323 221.786 248.526 222.313L245.542 223.906L245.13 222.516C244.474 219.464 244.24 216.979 244.432 215.042C244.635 213.115 245.464 211.359 246.927 209.766C247.719 208.844 248.557 208.177 249.417 207.776C249.786 207.609 250.073 207.521 250.286 207.521C250.568 207.521 250.708 207.677 250.708 207.984C250.708 208.797 250.964 209.198 251.474 209.198C251.547 209.198 251.625 209.193 251.703 209.177C252.37 209.036 252.901 208.51 253.297 207.583C253.823 206.25 253.76 205.151 253.094 204.292C252.437 203.432 251.375 203 249.911 203Z",
    fill: "#76E297"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.495 239.708C280.635 239.708 280.38 240.323 279.724 241.573C279.068 242.807 278.167 244.333 276.995 246.167C275.833 247.984 274.557 250.026 273.172 252.286C271.786 254.547 270.365 256.771 268.917 258.958C261.781 269.896 255.219 278.281 249.255 284.109C243.281 289.953 237.234 293.891 231.125 295.922C229.604 296.385 228.344 296.615 227.339 296.615C226.115 296.615 225.266 296.276 224.781 295.599C223.911 294.365 224.344 292.063 226.094 288.703C227.115 286.521 228.651 284.188 230.682 281.708C232.724 279.234 235.417 276.323 238.771 272.964C241.974 269.76 245.464 266.51 249.255 263.229C253.036 259.948 257.401 256.417 262.365 252.62C263.521 251.75 265.047 250.62 266.948 249.229C268.839 247.844 270.698 246.5 272.516 245.188C274.328 243.875 275.974 242.698 277.432 241.688C278.885 240.667 279.833 240.01 280.271 239.708H280.495ZM293.818 207.26C292.797 207.26 291.995 207.573 291.411 208.198C291.12 208.5 290.068 209.479 288.245 211.156C286.427 212.844 284.354 214.771 282.021 216.953C277.802 221.182 274.448 224.359 271.979 226.474C269.495 228.583 267.453 230.156 265.854 231.177C264.63 231.964 263.771 232.365 263.281 232.365C262.953 232.365 262.792 232.188 262.792 231.833C262.792 231.115 263.568 229.068 265.094 225.714C266.672 222.26 268.464 218.891 270.443 215.651C270.969 214.729 271.443 213.781 271.859 212.802C272.224 211.932 272.406 211.349 272.406 211.057C272.406 209.599 271.677 208.875 270.229 208.875C269.635 208.875 268.948 209.276 268.151 210.078C267.349 210.885 266.219 212.38 264.76 214.568C262.729 217.922 261.115 221.099 259.958 224.078C258.797 227.068 258.281 229.661 258.432 231.844C258.432 233.016 258.505 233.781 258.646 234.146C258.797 234.516 259.161 234.911 259.74 235.354C260.474 236.083 261.125 236.438 261.708 236.438C262.286 236.438 263.156 236.224 264.328 235.781C265.297 235.286 266.208 234.708 267.057 234.042C268.005 233.307 269.203 232.255 270.667 230.865C272.115 229.479 273.87 227.724 275.901 225.615C277.943 223.505 280.411 220.917 283.323 217.849C285.802 215.224 287.911 213.115 289.661 211.51C291.411 209.906 292.495 209.099 292.937 209.099C293.667 209.099 293.38 210.885 292.068 214.458C290.755 218.031 288.135 223.979 284.203 232.286L282.453 236.224L273.052 243.01C258.344 253.651 247.099 262.583 239.307 269.813C231.521 277.031 226.307 283.25 223.698 288.49C223.109 289.651 222.755 290.568 222.604 291.219C222.453 291.875 222.312 292.792 222.161 293.953C222.161 295.266 222.193 296.141 222.271 296.578C222.344 297.021 222.604 297.448 223.042 297.891C223.182 298.182 223.474 298.474 223.911 298.776C224.266 299.01 224.625 299.224 225.01 299.432C225.74 299.76 226.63 299.922 227.687 299.922C228.953 299.922 230.464 299.688 232.208 299.203C237.75 297.75 243.057 295.052 248.161 291.115C253.255 287.177 258.495 281.635 263.885 274.49C267.38 269.964 270.917 264.755 274.479 258.849C278.047 252.943 281.219 247.219 283.99 241.667L286.062 237.516C286.167 237.297 286.276 237.104 286.375 236.911C286.406 236.849 286.427 236.781 286.458 236.719C286.547 236.172 286.802 235.688 287.083 235.224C287.771 233.51 288.49 231.823 289.187 230.115C289.219 230.036 289.266 229.964 289.318 229.896C289.51 229.422 289.781 228.823 290.109 228.109C290.693 226.646 291.302 225.047 291.958 223.302C292.615 221.547 293.193 219.87 293.708 218.266C294.214 216.667 294.656 215.245 295.021 213.995C295.385 212.76 295.568 211.844 295.557 211.266C295.708 209.661 295.635 208.594 295.344 208.057C295.052 207.531 294.536 207.26 293.818 207.26Z",
    fill: "#76E297"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.135 244.807C267.411 245.13 261.688 247.552 256.979 252.063C252.984 255.891 250.568 260.313 249.719 265.328H258.74V262.01H262.318V258.599H263.042V252.682H271.818V248.469H274.135V244.807Z",
    fill: "#01ABE9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.563 263.161C273.104 263.161 270.302 265.969 270.302 269.438C270.302 272.901 273.104 275.708 276.563 275.708C280.026 275.708 282.828 272.901 282.828 269.438C282.828 265.969 280.026 263.161 276.563 263.161Z",
    fill: "#76E297"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker13"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M153.214 141.797C158.88 154.677 156.609 167.88 149.714 174.99C142.812 182.099 123.266 196.062 107.089 170.661C90.9062 145.266 126.531 122.062 142.531 131.87C152.427 137.927 153.214 141.797 153.214 141.797Z",
    fill: "#04ACEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M120.453 137.172C120.453 137.172 113.51 154.302 126.448 157.438C126.448 157.438 145.51 161.688 137.932 137.682L120.453 137.172Z",
    fill: "#1A1210"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 146,
    width: 17,
    height: 31
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: 9.82398e+88
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M121.333 146.667H137.333V176.5H121.333V146.667Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M122.521 176.479L137.13 174.25V164.901C136.609 164.771 135.708 164.698 135.708 164.698C133.255 159.333 133.693 147.464 133.693 147.464C133.693 147.464 125.635 152.885 125.568 154.12C125.297 159.073 124.724 163.667 124.005 165.349C123.932 165.531 123.01 165.734 122.51 165.943V176.479H122.521Z",
    fill: "#F36647"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M125.568 154.12C125.453 156.203 125.286 158.219 125.078 159.984C127.214 161.807 131.505 164.802 135.172 163.281C134.302 160.568 133.927 156.922 133.766 153.818L126.901 152.526C126.12 153.224 125.589 153.807 125.568 154.12Z",
    fill: "#E35136"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M137.896 145.417C138 142.411 137.849 140.099 137.849 140.099C137.578 135.359 133.547 134.479 129.542 134.589C125.536 134.479 121.5 135.359 121.229 140.099C121.229 140.099 121.078 142.411 121.182 145.417C118.844 143.641 118.557 146.573 119.323 148.771C119.984 150.651 121.094 150.875 121.667 150.859C121.734 151.292 121.807 151.719 121.896 152.141C122.542 155.344 126.391 159.354 128.521 160.24C128.521 160.24 128.776 160.375 129.542 160.375C130.302 160.375 130.562 160.24 130.562 160.24C132.687 159.354 136.542 155.344 137.187 152.141C137.271 151.719 137.344 151.292 137.417 150.859C137.984 150.875 138.969 151.01 139.63 149.13C140.391 146.937 140.234 143.641 137.896 145.417Z",
    fill: "#F79375"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M120.443 145.026C120.443 145.026 121.297 146.234 121.651 146.193C122 146.146 121.901 143.854 122.568 138.932C122.568 138.932 130.125 140.776 135.818 138.88C135.818 138.88 136.437 145.641 136.865 146.464C137.406 147.5 138.13 145.099 138.13 145.099C138.13 145.099 140.073 131.776 129.531 132.198C129.531 132.198 118.172 131.443 120.443 145.026Z",
    fill: "#1A1210"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 125,
    width: 27,
    height: 13
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "dbea5d0124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M116 125.5H142.667V137.333H116V125.5Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M138.677 136.328C138.677 136.328 143.063 135.599 141.688 133.255C140.313 130.917 135.724 125.969 129.714 125.75C123.708 125.526 116.661 131.208 116.661 133.255C116.661 135.307 121.724 136.182 122.016 136.328H138.677Z",
    fill: "#1C2B4F"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M136.068 164.573C132.745 163.849 129.542 163.297 129.542 163.297C129.542 163.297 126.276 163.833 122.771 164.547V174.25H136.068V164.573Z",
    fill: "#F36647"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 164,
    width: 33,
    height: 13
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "bec16167d4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M113.516 164H145.333V176.5H113.516V164Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M145.005 176.479C144.208 171.828 143.026 166.224 143.026 166.224C142.344 165.682 138.318 164.849 135.51 164.229C134.057 167.901 131.073 171.313 129.818 171.313C128.573 171.313 125.828 167.88 124.365 164.229C122.12 164.464 115.901 165.677 115.234 166.214C115.234 166.214 114.198 171.896 113.526 176.479H145.005Z",
    fill: "#6789C3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 162,
    width: 14,
    height: 15
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: 7607439711
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M130.667 162.667H144V176.5H130.667V162.667Z",
    fill: "white"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M143.427 176.479C141.708 171.823 141.266 165.057 141.266 165.057C140.531 164.339 135.312 163.698 135.312 163.698C135.078 166.12 132.729 173.74 131.865 176.479H143.427Z",
    fill: "#DF5621"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 162,
    width: 14,
    height: 15
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "381a7ef558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M114.667 162.667H128V176.5H114.667V162.667Z",
    fill: "white"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M127.005 176.479C126.141 173.74 123.792 166.12 123.557 163.698C123.557 163.698 118.339 164.339 117.609 165.057C117.609 165.057 117.161 171.823 115.443 176.479H127.005Z",
    fill: "#DF5621"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M127.266 139.339C127.266 139.339 124.193 143.667 121.745 143.688C118.365 143.724 122.693 136.641 122.693 136.641L127.266 139.339Z",
    fill: "#1A1210"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M130.125 138.813C130.125 138.813 133.198 143.141 135.646 143.161C139.031 143.198 134.698 136.109 134.698 136.109L130.125 138.813Z",
    fill: "#1A1210"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M119.714 139.25C119.714 139.25 119.651 136.422 120.984 135.25C122.318 134.073 131.156 131.776 137.427 135.25C137.427 135.25 138.547 135.5 138.479 139.25H119.714Z",
    fill: "#A4C4D2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M138.479 139.25C138.484 138.927 138.479 138.63 138.469 138.359C129.396 134.094 122.151 136.984 119.776 138.208C119.703 138.813 119.714 139.25 119.714 139.25H138.479Z",
    fill: "#7695B3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M119.714 139.25C119.714 139.25 123.542 136.776 129 136.865C134.453 136.958 138.479 139.25 138.479 139.25C138.479 139.25 137.104 140.651 134.141 140.813C131.172 140.974 128.974 139.349 124.615 140.813C120.255 142.271 119.714 139.25 119.714 139.25Z",
    fill: "#1C2B4F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M138.193 136.391C137.88 135.349 137.427 135.25 137.427 135.25C131.156 131.776 122.318 134.073 120.984 135.25C120.714 135.49 120.495 135.802 120.328 136.146C123.26 134.807 130.443 132.411 138.193 136.391Z",
    fill: "#7695B3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 258,
    width: 69,
    height: 61
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "6e9bcc35fe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M71.349 258.703H139.349V318.667H71.349V258.703Z",
    fill: "white"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M80.4844 271.573C78.4687 271.568 76.3177 271.406 74.5781 272.516C71.9583 274.188 71.3542 278.177 72.2708 281.318C73.1927 284.464 75.25 287.026 77.0104 289.714C78.776 292.401 80.3333 295.542 80.0052 298.818C79.7917 300.964 78.7812 302.958 78.7031 305.115C78.5885 308.073 80.2917 310.828 82.4896 312.583C84.6875 314.339 87.3333 315.266 89.9323 316.167C93.4844 317.401 97.2448 318.641 100.875 317.745C107.089 316.203 110.964 308.938 117.13 307.172C121.292 305.984 125.823 307.526 129.964 306.24C134.422 304.849 137.635 300.224 138.495 295.276C139.354 290.328 138.146 285.167 136.016 280.693C133.885 276.219 130.875 272.323 127.896 268.464C125.406 265.245 122.745 261.891 119.104 260.464C114.75 258.76 109.797 260.042 105.599 261.693C102.823 262.781 100.542 264.854 98.0365 266.484C95.349 268.229 92.3021 269.495 89.2812 270.349C86.4115 271.156 83.4531 271.578 80.4844 271.573Z",
    fill: "#B3E5F8"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M112.062 289.438C111.609 289.323 111.109 289.068 111.109 289.068C108.755 284.391 109.172 274.047 109.172 274.047C109.172 274.047 101.443 278.771 101.38 279.849C101.115 284.167 100.568 288.172 99.875 289.635C99.8073 289.792 99.5104 289.969 99.0729 290.151V299.339L111.839 297.391L112.062 289.438Z",
    fill: "#F36647"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M101.38 279.849C101.224 282.375 100.974 284.797 100.651 286.667C103.161 288.781 107.057 290.964 110.948 288.724C108.771 283.901 109.172 274.047 109.172 274.047C109.172 274.047 101.443 278.771 101.38 279.849Z",
    fill: "#E35136"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 288,
    width: 32,
    height: 16
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "0bfb4e82de"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M90.0104 288H121.01V303.828H90.0104V288Z",
    fill: "white"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M121.005 303.802C120.536 296.901 119.344 291.13 119.344 291.13C118.708 290.568 110.729 288.198 110.729 288.198C110.531 294.682 105.74 298.323 105.74 298.323C101.339 295.714 100.344 288.198 100.344 288.198C99.151 289.089 92.6979 290.391 92.2031 290.828C92.2031 290.828 91.6041 292.141 90.0052 303.802H121.005Z",
    fill: "#254280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M121.005 303.802C120.536 296.901 119.344 291.13 119.344 291.13C118.708 290.568 112.062 288.599 112.062 288.599C111.865 295.089 105.599 301.323 105.599 301.323C101.193 298.719 98.4583 288.979 98.4583 288.979C96.3802 289.583 92.6979 290.391 92.2031 290.828C92.2031 290.828 90.6562 292.375 90.0052 303.802H121.005Z",
    fill: "#DF5621"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 288,
    width: 6,
    height: 16
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "aa7ce4a9a2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M93.3333 288H98.6667V303.828H93.3333V288Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M97.901 303.802V289.135C96.7917 289.443 95.4062 289.781 94.276 290.094V303.802H97.901Z",
    fill: "#E2E52C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 288,
    width: 6,
    height: 16
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "4fc9f65d80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M112 288H117.333V303.828H112V288Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M116.568 303.802V290.016C115.276 289.583 113.839 289.135 112.943 288.865V303.802H116.568Z",
    fill: "#E2E52C"
  }))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M113.432 274.219C113.526 271.464 113.385 269.349 113.385 269.349C113.135 265.005 109.432 264.198 105.755 264.302C102.078 264.198 98.375 265.005 98.1302 269.349C98.1302 269.349 97.9896 271.464 98.0833 274.219C95.9375 272.594 95.6198 275.073 96.3177 277.089C96.9271 278.807 98.0052 279.219 98.5312 279.208C98.5885 279.604 98.6615 279.995 98.7396 280.38C99.3333 283.313 102.865 286.984 104.823 287.797C104.823 287.797 105.057 287.922 105.755 287.922C106.458 287.922 106.693 287.797 106.693 287.797C108.646 286.984 112.182 283.313 112.776 280.38C112.854 279.995 112.922 279.604 112.984 279.208C113.51 279.219 114.146 279.214 114.75 277.495C115.453 275.479 115.573 272.594 113.432 274.219Z",
    fill: "#F5866C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M97.4062 273.865C97.4062 273.865 98.1875 274.969 98.5156 274.932C98.8385 274.885 98.7448 272.786 99.3542 268.281C99.3542 268.281 99.7344 266.026 103.516 266.766C103.516 266.766 105.802 268.323 110.839 268.151C110.839 268.151 112.089 274.427 112.479 275.177C112.979 276.13 113.641 273.927 113.641 273.927C113.641 273.927 116.656 262.516 107.578 260.922C107.578 260.922 93.2083 259.052 97.4062 273.865Z",
    fill: "#371D15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 253,
    width: 27,
    height: 13
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "2a329337c9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M92 253.828H118.667V265.333H92V253.828Z",
    fill: "white"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M114.49 264.349C114.49 264.349 118.76 263.641 117.422 261.365C116.078 259.089 111.609 254.281 105.76 254.068C99.9063 253.854 93.0469 259.37 93.0469 261.365C93.0469 263.354 97.9792 264.208 98.2604 264.349H114.49Z",
    fill: "#1C2B4F"
  }))))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M96.0208 267.193C96.0208 267.193 95.9583 264.438 97.2604 263.302C98.5573 262.161 107.161 259.922 113.271 263.302C113.271 263.302 114.365 263.547 114.292 267.193H96.0208Z",
    fill: "#A4C4D2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M114.292 267.193C114.302 266.875 114.297 266.589 114.286 266.323C105.448 262.177 98.3906 264.99 96.0781 266.177C96.0104 266.766 96.0208 267.193 96.0208 267.193H114.292Z",
    fill: "#7695B3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M96.0208 267.193C96.0208 267.193 99.75 264.786 105.062 264.87C110.375 264.958 114.292 267.193 114.292 267.193C114.292 267.193 112.958 268.547 110.068 268.708C107.182 268.865 105.036 267.286 100.792 268.708C96.5469 270.125 96.0208 267.193 96.0208 267.193Z",
    fill: "#1C2B4F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M114.016 264.411C113.714 263.401 113.271 263.302 113.271 263.302C107.161 259.922 98.5573 262.161 97.2604 263.302C96.9896 263.536 96.7812 263.839 96.6146 264.172C99.474 262.87 106.469 260.542 114.016 264.411Z",
    fill: "#7695B3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker11"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M79.9323 201.552C73.6302 209.406 71.3542 222.901 79.9323 231.688C88.5156 240.479 102.755 237.026 112.807 238.594C122.859 240.161 135.26 240.161 137.792 226.354C140.344 212.542 134.297 209.089 117.125 199.354C99.9479 189.615 92.0208 186.479 79.9323 201.552Z",
    fill: "#F97575"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M112.578 194.224C112.578 194.224 112.443 207.432 113.417 208.974L101.646 209.458C101.646 209.458 101.687 196.453 101.62 195.047L112.578 194.224Z",
    fill: "#1D1416"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M111.359 191.036C111.359 191.036 111.703 190.844 111.526 190.526C111.354 190.208 110.078 188.823 109.667 188.807C109.667 188.807 109.406 188.724 109.281 189.016L111.359 191.036Z",
    fill: "#41A0D6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M91.9427 223.635C91.9427 223.635 88.8385 221.974 87.9948 222.104C87.1562 222.234 84.4948 222.224 85.625 223.453C86.7552 224.682 91.1354 225.526 91.1354 225.526L91.9427 223.635Z",
    fill: "#F79375"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M102.005 225.87L100.932 208.536C100.932 208.536 99.2552 209.12 98.3333 210.51C97.6719 211.505 97.8594 220.698 98.0208 225.797L102.005 225.87Z",
    fill: "#2C4F73"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M90.8385 222.776C90.8385 222.776 89.9635 223.818 90.276 225.656C90.276 225.656 100.365 230.87 101.937 229.776C103.505 228.688 100.995 225.479 100.995 225.479L90.8385 222.776Z",
    fill: "#2C4F73"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M102.526 207.547C103.635 207.125 104.641 206.661 104.661 206.375C104.661 206.375 105.115 202.563 105.38 200.359C105.458 199.698 109.568 197.516 109.568 197.516C109.568 197.516 109.583 204.214 110.589 206.536C110.589 206.536 111.792 206.927 113.615 207.563L113.5 213.813L102.417 213.62L102.526 207.547Z",
    fill: "#E4846C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M109.583 198.604C109.604 199.396 109.651 200.542 109.745 201.74C108.807 203.536 106.359 207.76 104.604 206.495C104.641 206.448 104.661 206.411 104.661 206.375C104.661 206.375 104.969 203.807 105.224 201.667L109.245 198.479L109.583 198.604Z",
    fill: "#D26758"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 205,
    width: 23,
    height: 30
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "c6baa8e5ac"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M96 205.333H118.667V234.552H96V205.333Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M98.8594 223.5C98.8594 223.5 98.9844 229.63 99.2031 234.542H115.813C115.37 232.307 114.953 230.276 114.953 230.276C114.958 229.969 115.26 224.458 116.667 220.88C117.844 217.896 117.917 208.833 117.917 208.833C115.714 207.552 110.589 206.536 110.589 206.536C107.859 210.911 105.771 211.109 105.771 211.109C103.641 207.526 104.568 206.536 104.568 206.536C102.531 207.422 101.417 208.047 100.932 208.536C99.8177 209.641 97.3594 217.38 97.3594 217.38C97.3594 217.38 95.4271 221.859 98.8594 223.5Z",
    fill: "#3B5F8A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 205,
    width: 11,
    height: 30
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "4a6a4765c8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M100 205.333H110.667V234.552H100V205.333Z",
    fill: "white"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M106.073 234.542C105.594 229.667 105.307 223.927 105.307 223.927C105.88 220.156 110.589 206.536 110.589 206.536C107.859 210.911 105.771 211.109 105.771 211.109C104.156 208.391 104.302 207.167 104.464 206.734C102.219 211.021 101.083 222.448 101.083 222.448C100.833 225.641 101.464 230.672 102.083 234.542H106.073Z",
    fill: "#BBD8E4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 216,
    width: 15,
    height: 19
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "f817f324cf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M101.333 216H116V234.552H101.333V216Z",
    fill: "white"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M103.656 234.542H105.594L115.344 233.188C115.542 233.161 115.677 232.984 115.651 232.792L113.448 217.49C113.422 217.297 113.24 217.161 113.042 217.193L101.729 218.766C101.536 218.792 101.401 218.969 101.427 219.161L103.625 234.464C103.63 234.49 103.646 234.516 103.656 234.542Z",
    fill: "#42A3D0"
  }))))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M103.708 204.599C103.708 204.599 104.073 204.833 104.844 204.661C105.495 204.521 108.885 202.474 109.594 199.891C109.594 199.891 110.578 200.068 111.01 198.859C111.453 197.651 110.943 195.938 109.625 197.052C109.625 197.052 110.068 191.703 107.682 191.339C105.297 190.969 100.74 190.089 100.458 193.891C100.458 193.891 100.318 197.292 100.927 200.172C100.927 200.172 101.583 202.563 103.708 204.599Z",
    fill: "#F79375"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M100.448 194.224C100.182 193.385 100.328 191.943 101.089 190.922C102.672 188.812 108.276 186.505 111.37 190.755C113.625 193.849 112.391 198.87 110.99 200.177C109.854 201.234 110.255 201.646 110.115 202.37C110.031 202.786 109.99 202.969 109.854 202.943C109.75 201.953 109.562 200.849 109.542 200.057C109.557 200.005 109.578 199.948 109.594 199.891C109.594 199.891 110.578 200.068 111.01 198.859C111.443 197.667 110.958 195.99 109.682 197.005C109.573 197.156 109.443 197.302 109.328 197.37C109.057 197.526 107.875 196.344 108.198 195.214C108.198 195.214 104.911 195.469 102.339 191.854C102.339 191.854 100.859 193.286 100.448 194.224Z",
    fill: "#1D1416"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M106.474 225.516C106.474 225.516 104.797 224.688 104.495 224.677C104.193 224.661 103.885 224.891 103.885 224.891C103.885 224.891 102.193 224.594 101.906 224.719C101.62 224.844 101.365 226.698 102.057 227.589C102.75 228.479 103.974 228.495 106.75 227.703L106.474 225.516Z",
    fill: "#F79375"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M118.526 230.474L106.917 228.021C106.917 228.021 106.458 228.057 105.75 224.849L116.146 225.641L115.953 217.292C115.953 217.292 115.443 209.583 117.318 208.458C117.318 208.458 119.474 209.302 120.578 210.969C120.578 210.969 121.458 211.089 120.573 229.391C120.573 229.391 120.089 230.651 118.526 230.474Z",
    fill: "#3B5F8A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 185,
    width: 16,
    height: 9
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "b61c8b1460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M98.6667 185.552H113.333V193.333H98.6667V185.552Z",
    fill: "white"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M112.812 192.734C112.812 192.677 112.818 192.615 112.818 192.552C112.885 188.865 109.901 185.818 106.146 185.755C102.396 185.688 99.2969 188.625 99.2344 192.318C99.2291 192.375 99.2344 192.438 99.2344 192.5L112.812 192.734Z",
    fill: "#BBD8E4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 185,
    width: 4,
    height: 9
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "2b5d11eb3c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M104 185.552H108V193.333H104V185.552Z",
    fill: "white"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M107.479 192.167L104.583 192.12L104.906 185.547L107.391 185.594L107.479 192.167Z",
    fill: "#BDE1F7"
  }))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M112.547 191.901L99.4583 191.677C99.2083 191.672 99 191.87 98.9948 192.115L98.9792 192.839L96.5938 193.833V193.943L112.958 194.229L112.979 193.078L112.995 192.359C113 192.115 112.797 191.906 112.547 191.901Z",
    fill: "#BDE1F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 194,
    width: 11,
    height: 41
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "a03885f2f8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M84.4792 194.667H94.6667V234.552H84.4792V194.667Z",
    fill: "white"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M87.9375 234.542L94.1875 195.453C94.2135 195.297 93.5104 195.057 92.625 194.922C91.7344 194.781 90.9948 194.797 90.9687 194.958L84.6406 234.542H87.9375Z",
    fill: "#BDE1F7"
  }))))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M94.1875 195.453C94.1615 195.615 93.4219 195.63 92.5313 195.49C91.6406 195.354 90.9427 195.115 90.9688 194.958C90.9948 194.797 91.7344 194.781 92.625 194.922C93.5104 195.057 94.2135 195.297 94.1875 195.453Z",
    fill: "#91C5EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 220,
    width: 4,
    height: 6
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "6f27967f6f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M84.4792 220H88V225.333H84.4792V220Z",
    fill: "white"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M86.9792 221.13C86.9792 221.13 85.2604 221.724 85.2344 223.135C85.2083 224.542 85.8229 225.583 86.2969 224.969C86.7708 224.359 88.3646 221.198 86.9792 221.13Z",
    fill: "#F79375"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "worker10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 262,
    y: 379,
    width: 70,
    height: 52
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "eb3e09ff67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M262.667 379.484H331.536V430.484H262.667V379.484Z",
    fill: "white"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M263.76 388.844C262.734 391.24 262.547 393.906 263.646 396.479C266.5 403.156 273.234 401.667 278.792 404.016C282.021 405.38 284.292 408.328 285.953 411.391C287.615 414.448 288.828 417.755 290.781 420.646C294.422 426.047 300.63 429.672 307.167 430.219C309.823 430.443 312.557 430.167 314.99 429.089C317.417 428.016 319.516 426.078 320.453 423.615C321.333 421.318 321.214 418.635 321.688 416.214C322.62 411.432 325.047 407.422 327.313 403.177C329.609 398.875 331.547 393.984 330.474 389.234C329.375 384.365 324.875 380.443 319.854 379.974C314.74 379.505 309.969 382.234 305.052 383.708C299.422 385.391 293.297 385.411 287.656 383.766C283.313 382.5 279.036 380.245 274.536 380.745C269.969 381.255 265.563 384.63 263.76 388.844Z",
    fill: "#F97575"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M304.719 408.078C304.245 407.958 303.724 407.693 303.724 407.693C301.245 402.828 301.688 392.068 301.688 392.068C301.688 392.068 293.573 396.979 293.51 398.104C293.229 402.594 292.656 406.76 291.932 408.286C291.859 408.453 291.547 408.63 291.094 408.818V418.38L304.484 416.354L304.719 408.078Z",
    fill: "#F36647"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M293.51 398.104C293.344 400.734 293.083 403.25 292.745 405.193C295.38 407.396 299.469 409.667 303.547 407.339C301.266 402.318 301.687 392.068 301.687 392.068C301.687 392.068 293.573 396.979 293.51 398.104Z",
    fill: "#E35136"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M306.156 392.245C306.255 389.38 306.109 387.177 306.109 387.177C305.849 382.661 301.964 381.818 298.104 381.927C294.245 381.818 290.359 382.661 290.099 387.177C290.099 387.177 289.953 389.38 290.052 392.245C287.797 390.552 287.464 393.135 288.198 395.229C288.833 397.021 289.969 397.448 290.516 397.432C290.583 397.844 290.656 398.255 290.734 398.656C291.359 401.703 295.068 405.531 297.12 406.375C297.12 406.375 297.37 406.5 298.104 406.5C298.839 406.5 299.089 406.375 299.089 406.375C301.141 405.531 304.844 401.703 305.469 398.656C305.552 398.255 305.625 397.844 305.693 397.432C306.24 397.448 306.906 397.443 307.542 395.651C308.276 393.557 308.406 390.552 306.156 392.245Z",
    fill: "#F5866C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M306.38 391.943C306.38 391.943 305.682 394.234 305.156 393.24C304.745 392.458 304.719 386.109 304.719 386.109C303.193 384.042 300.292 386.573 297.609 386.682C292.469 386.88 291.385 386.068 291.385 386.068C290.745 390.755 290.839 392.938 290.505 392.984C290.161 393.026 289.339 391.875 289.339 391.875C289.339 391.875 287.536 384.182 289.339 381.318C291.625 377.688 298.151 377.323 300.599 377.786C303.047 378.25 309.979 381.026 306.38 391.943Z",
    fill: "#371D15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 406,
    width: 48,
    height: 17
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "491a675a97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M273.599 406.667H320.599V422.323H273.599V406.667Z",
    fill: "white"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M320.594 422.318C318.5 410.276 312.365 409.839 312.365 409.839C311.755 409.307 304.667 407.188 303.49 406.839C301.896 410.974 297.932 414.396 297.932 414.396C297.922 414.391 297.906 414.38 297.896 414.375C297.88 414.38 297.865 414.391 297.854 414.396C297.854 414.396 293.891 410.974 292.302 406.839C291.12 407.188 284.036 409.307 283.422 409.839C283.422 409.839 283.417 409.875 283.401 409.938C281.802 410.255 276.344 412.078 273.609 422.318H320.594Z",
    fill: "#C4C1C2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "worker9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 369,
    width: 69,
    height: 55
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "157e2173e6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M178.667 369.333H246.464V424H178.667V369.333Z",
    fill: "white"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M185.974 373.583C184.667 374.729 183.521 376.172 182.589 377.974C176.563 389.594 176.464 411.849 190.693 417.854C196.74 420.411 204.089 421.474 210.536 422.641C220.193 424.391 228.115 422.927 234.948 415.401C240.37 409.427 245.974 401.479 246.292 393.161C246.464 388.651 244.745 383.891 241.073 381.208C238.052 379 234.167 378.427 230.5 377.62C217.99 374.865 197.63 363.391 185.974 373.583Z",
    fill: "#76E297"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 368,
    width: 28,
    height: 47
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "f1e72e1d1c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M196 368.823H224V414.667H196V368.823Z",
    fill: "white"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M221.151 372.417C218.406 368.823 213.094 368.875 210.719 368.927C210.339 368.932 210.031 368.943 209.823 368.938C209.615 368.943 209.318 368.932 208.953 368.927C206.708 368.875 201.885 368.823 199.141 372.411C194.781 378.109 199.057 402.828 199.057 402.828C205.703 414.484 209.401 413.719 210.25 413.318V413.323C211.104 413.724 214.802 414.495 221.448 402.833C221.448 402.833 225.51 378.115 221.151 372.417Z",
    fill: "#F9AB26"
  }))))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M220.693 377.615C220.693 377.615 220.641 376.219 217.661 375.427C215.234 374.781 212.286 375.417 210.146 375.417C207.5 375.417 204.365 375.073 202.87 375.427C200.349 376.016 199.839 377.615 199.839 377.615C198.172 382.974 201.13 402.323 201.13 402.323C201.13 402.323 205.682 411.604 207.99 412.76C208.453 412.995 209.193 413.193 210.063 413.214C210.13 413.208 210.198 413.203 210.266 413.203C210.333 413.203 210.401 413.208 210.469 413.214C211.333 413.193 212.078 412.995 212.542 412.76C214.844 411.604 219.656 402.214 219.656 402.214C219.656 402.214 222.417 382.068 220.693 377.615Z",
    fill: "#C5801A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M216.135 402.87C215.448 401.432 214.474 397.115 214.214 392.88C214.146 391.823 206.406 387.193 206.406 387.193C206.406 387.193 206.516 398.302 204.156 402.885L216.135 402.87Z",
    fill: "#F49480"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M211.87 401.25C213.328 401.349 214.5 400.828 215.313 400.271C214.917 398.641 214.547 396.536 214.333 394.365L206.13 393.729C206.005 395.188 205.823 396.734 205.562 398.193C207.297 399.427 209.995 401.12 211.87 401.25Z",
    fill: "#E97378"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M206.391 377.068C202.823 379.37 203.568 386.167 203.568 386.167C201.536 384.391 201.255 387.01 201.906 388.917C202.552 390.818 203.542 390.609 203.542 390.609C204.021 394.917 208.062 397.76 209.948 398.099C210.146 398.135 210.307 398.161 210.49 398.182V398.161C210.672 398.141 210.828 398.115 211.026 398.078C212.911 397.74 216.932 394.766 217.437 390.589C217.437 390.589 218.354 390.948 218.995 389.047C219.646 387.141 219.443 384.37 217.411 386.146C217.411 386.146 218.156 379.349 214.589 377.047L206.391 377.068Z",
    fill: "#F49480"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M202.344 381.146C202.333 381.958 202.323 382.719 202.417 382.891C202.703 383.406 203.453 386.818 203.453 386.818C203.453 386.818 204.349 383.536 204.536 382.401C204.578 382.146 204.594 381.88 204.604 381.615L202.344 381.146Z",
    fill: "#1D2347"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M216.797 381.615C217.214 382.766 217.156 386.313 217.156 386.313L217.885 385.703C217.885 385.703 218.474 383.651 218.917 381.615H216.797Z",
    fill: "#1D2347"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M205.417 391.547C205.417 391.547 203.849 386.073 203.391 383.458L202.932 383.781C202.932 383.781 203.859 389.839 204.547 391.75L205.417 391.547Z",
    fill: "#212B3F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M215.526 392.516C215.526 392.516 217.385 386.505 217.849 383.896L218.365 384.036C218.365 384.036 217.089 390.807 216.401 392.714L215.526 392.516Z",
    fill: "#212B3F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M208.38 384.365C208.38 384.365 208.344 384.672 207.958 384.786C207.755 384.849 207.333 384.771 206.938 384.687C206.599 384.62 206.276 384.552 206.146 384.578C205.854 384.625 205.047 384.807 205.047 384.807C205.047 384.807 205.625 384.177 206.146 384.073C206.661 383.974 208.536 384.089 208.38 384.365Z",
    fill: "#1D2347"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M212.198 384.365C212.198 384.365 212.229 384.672 212.615 384.786C212.823 384.849 213.245 384.771 213.635 384.687C213.979 384.62 214.302 384.552 214.432 384.578C214.724 384.625 215.526 384.807 215.526 384.807C215.526 384.807 214.953 384.177 214.432 384.073C213.917 383.974 212.042 384.089 212.198 384.365Z",
    fill: "#1D2347"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M205.594 386.625C205.594 386.625 206.568 385.375 208.042 386.406C208.042 386.406 207.984 386.667 207.75 386.625C207.516 386.589 206.932 385.943 205.594 386.625Z",
    fill: "#1D2347"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M207.432 386.313C207.432 386.313 207.469 387.026 206.75 387.026C206.115 387.026 206.203 386.313 206.203 386.313C206.203 386.313 207.141 386.13 207.432 386.313Z",
    fill: "#1D2347"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M215.193 386.625C215.193 386.625 214.219 385.375 212.75 386.406C212.75 386.406 212.802 386.667 213.036 386.625C213.276 386.589 213.854 385.943 215.193 386.625Z",
    fill: "#1D2347"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M213.354 386.313C213.354 386.313 213.323 387.026 214.036 387.026C214.672 387.026 214.583 386.313 214.583 386.313C214.583 386.313 213.646 386.13 213.354 386.313Z",
    fill: "#1D2347"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M212.479 384.938C212.474 384.943 212.125 385.365 211.776 386.094C211.422 386.823 211.073 387.865 211.073 389.104C211.073 389.365 211.089 389.63 211.12 389.906L211.328 389.88C211.297 389.615 211.281 389.354 211.281 389.104C211.281 387.901 211.625 386.891 211.964 386.182C212.135 385.828 212.302 385.547 212.432 385.359C212.495 385.266 212.547 385.187 212.583 385.141C212.604 385.115 212.62 385.099 212.625 385.089C212.63 385.083 212.635 385.078 212.635 385.073H212.641V385.068L212.479 384.938Z",
    fill: "#B55642"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M202 387.708C202.005 387.672 202.047 387.344 202.125 387.026C202.161 386.865 202.208 386.703 202.255 386.589C202.281 386.531 202.307 386.484 202.333 386.453C202.344 386.438 202.354 386.427 202.359 386.422C202.365 386.417 202.37 386.417 202.37 386.417L202.365 386.385V386.417H202.37L202.365 386.385V386.417V386.411L202.359 386.417H202.365V386.411L202.359 386.417C202.365 386.417 202.37 386.417 202.385 386.427C202.406 386.443 202.443 386.479 202.484 386.531C202.552 386.62 202.635 386.755 202.714 386.906C202.828 387.13 202.943 387.396 203.026 387.62C203.068 387.734 203.099 387.839 203.125 387.917C203.135 387.958 203.146 387.995 203.151 388.026C203.156 388.052 203.156 388.078 203.156 388.083V388.089H203.182L203.156 388.083V388.089H203.182L203.156 388.083C203.156 388.089 203.151 388.104 203.135 388.125C203.115 388.156 203.068 388.203 203.01 388.255C202.927 388.333 202.823 388.417 202.74 388.495C202.698 388.536 202.661 388.578 202.63 388.625C202.615 388.646 202.599 388.667 202.589 388.693C202.578 388.719 202.573 388.745 202.573 388.776C202.573 388.813 202.583 388.854 202.604 388.885C202.63 388.917 202.656 388.938 202.693 388.953C202.75 388.979 202.812 388.995 202.875 389.005C202.937 389.016 203 389.016 203.057 389.016C203.115 389.016 203.172 389.016 203.219 389.016C203.255 389.016 203.292 389.016 203.323 389.021C203.344 389.021 203.359 389.026 203.375 389.026C203.401 389.036 203.411 389.042 203.422 389.052C203.432 389.057 203.437 389.068 203.443 389.094C203.448 389.115 203.453 389.151 203.453 389.193C203.453 389.255 203.443 389.328 203.427 389.401C203.406 389.516 203.37 389.625 203.328 389.703C203.307 389.745 203.292 389.771 203.276 389.786C203.271 389.792 203.271 389.797 203.266 389.797L203.276 389.818L203.271 389.797C203.266 389.797 203.266 389.797 203.266 389.797L203.276 389.818L203.271 389.797L203.286 389.844V389.792C203.276 389.792 203.271 389.797 203.271 389.797L203.286 389.844V389.792V389.849L203.312 389.802C203.302 389.797 203.292 389.792 203.286 389.792V389.849L203.312 389.802C203.26 389.776 203.193 389.797 203.167 389.844C203.141 389.896 203.161 389.958 203.214 389.984C203.234 389.995 203.26 390 203.286 390C203.307 390 203.328 389.995 203.349 389.99C203.38 389.974 203.406 389.953 203.427 389.932C203.464 389.891 203.495 389.844 203.521 389.786C203.562 389.703 203.599 389.604 203.625 389.5C203.646 389.401 203.667 389.292 203.667 389.193C203.667 389.141 203.661 389.089 203.646 389.042C203.635 388.99 203.609 388.948 203.578 388.911C203.552 388.885 203.526 388.87 203.495 388.854C203.453 388.833 203.406 388.823 203.359 388.813C203.312 388.807 203.266 388.807 203.219 388.807C203.167 388.807 203.109 388.807 203.057 388.807C203.005 388.807 202.953 388.807 202.906 388.802C202.859 388.797 202.818 388.781 202.786 388.766C202.781 388.766 202.776 388.76 202.776 388.76L202.76 388.776L202.781 388.766C202.776 388.766 202.776 388.76 202.776 388.76L202.76 388.776L202.781 388.766L202.755 388.776H202.781C202.781 388.776 202.781 388.771 202.781 388.766L202.755 388.776H202.781H202.771L202.781 388.781V388.776H202.771L202.781 388.781C202.781 388.781 202.781 388.776 202.786 388.771C202.792 388.76 202.802 388.74 202.818 388.719C202.849 388.682 202.891 388.635 202.948 388.589C203.026 388.516 203.12 388.443 203.198 388.365C203.234 388.328 203.271 388.292 203.302 388.25C203.318 388.234 203.328 388.214 203.344 388.193C203.354 388.167 203.365 388.146 203.365 388.12C203.37 388.104 203.37 388.094 203.37 388.083C203.37 388.057 203.365 388.031 203.359 388.005C203.349 387.948 203.333 387.885 203.312 387.807C203.229 387.547 203.078 387.161 202.911 386.839C202.828 386.677 202.745 386.526 202.661 386.417C202.615 386.359 202.573 386.313 202.531 386.276C202.505 386.26 202.484 386.245 202.458 386.229C202.432 386.219 202.401 386.208 202.365 386.208C202.349 386.208 202.333 386.208 202.323 386.214C202.286 386.224 202.255 386.24 202.229 386.26C202.177 386.302 202.146 386.349 202.109 386.406C202.057 386.51 202.01 386.635 201.974 386.776C201.911 386.979 201.87 387.208 201.839 387.38C201.807 387.557 201.792 387.682 201.792 387.688C201.786 387.74 201.828 387.792 201.885 387.802C201.943 387.807 201.995 387.766 202 387.708Z",
    fill: "#B55642"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M202.453 388.099C202.453 388.094 202.448 388.042 202.448 387.964C202.448 387.823 202.458 387.594 202.516 387.38C202.547 387.276 202.583 387.172 202.635 387.089C202.687 387.01 202.75 386.948 202.828 386.906C202.88 386.88 202.901 386.818 202.875 386.771C202.849 386.719 202.786 386.698 202.734 386.724C202.615 386.781 202.526 386.875 202.458 386.984C202.359 387.141 202.302 387.328 202.276 387.505C202.245 387.682 202.24 387.849 202.24 387.964C202.24 388.052 202.24 388.109 202.24 388.115C202.245 388.167 202.297 388.214 202.354 388.208C202.411 388.203 202.458 388.156 202.453 388.099Z",
    fill: "#B55642"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M219.182 387.688C219.182 387.682 219.141 387.354 219.063 387.01C219.026 386.839 218.974 386.661 218.917 386.521C218.885 386.448 218.854 386.385 218.813 386.333C218.797 386.307 218.771 386.281 218.745 386.26C218.719 386.24 218.693 386.224 218.656 386.214C218.641 386.208 218.625 386.208 218.609 386.208C218.568 386.208 218.531 386.224 218.5 386.24C218.474 386.255 218.448 386.276 218.422 386.297C218.375 386.344 218.328 386.396 218.281 386.458C218.203 386.573 218.125 386.714 218.047 386.87C217.932 387.099 217.823 387.354 217.74 387.578C217.703 387.688 217.667 387.786 217.646 387.875C217.635 387.917 217.625 387.953 217.615 387.99C217.609 388.026 217.604 388.052 217.604 388.083C217.604 388.094 217.604 388.104 217.609 388.12C217.615 388.161 217.635 388.198 217.656 388.234C217.698 388.292 217.755 388.344 217.813 388.396C217.901 388.479 218.005 388.563 218.083 388.641C218.12 388.677 218.151 388.714 218.172 388.74C218.182 388.75 218.188 388.766 218.193 388.771C218.193 388.776 218.193 388.776 218.193 388.776V388.781L218.203 388.776H218.193V388.781L218.203 388.776H218.193H218.219L218.198 388.76C218.198 388.766 218.193 388.776 218.193 388.776H218.219L218.198 388.76C218.198 388.76 218.198 388.766 218.188 388.766C218.156 388.781 218.115 388.797 218.068 388.802C218.021 388.807 217.969 388.807 217.917 388.807C217.865 388.807 217.807 388.807 217.755 388.807C217.714 388.807 217.672 388.807 217.63 388.813C217.599 388.818 217.568 388.823 217.536 388.828C217.495 388.844 217.448 388.865 217.406 388.901C217.37 388.938 217.339 388.984 217.328 389.042C217.318 389.089 217.312 389.141 217.312 389.193C217.312 389.276 217.323 389.359 217.339 389.443C217.365 389.573 217.406 389.698 217.458 389.797C217.484 389.844 217.51 389.891 217.542 389.927C217.557 389.943 217.578 389.958 217.599 389.974C217.625 389.99 217.656 390 217.693 390C217.714 390 217.74 389.995 217.76 389.984C217.813 389.958 217.833 389.896 217.807 389.844C217.781 389.797 217.719 389.776 217.667 389.802L217.693 389.849V389.792C217.682 389.792 217.672 389.797 217.667 389.802L217.693 389.849V389.792V389.839L217.708 389.797C217.703 389.797 217.698 389.792 217.693 389.792V389.839L217.708 389.797C217.708 389.797 217.703 389.792 217.693 389.781C217.677 389.76 217.656 389.724 217.635 389.682C217.604 389.615 217.573 389.531 217.552 389.443C217.531 389.354 217.521 389.266 217.521 389.193C217.521 389.151 217.526 389.115 217.531 389.089C217.536 389.073 217.542 389.063 217.552 389.052C217.557 389.047 217.562 389.042 217.573 389.036C217.589 389.031 217.609 389.026 217.646 389.021C217.677 389.016 217.714 389.016 217.755 389.016C217.807 389.016 217.859 389.016 217.917 389.016C217.974 389.016 218.036 389.016 218.099 389.005C218.161 388.995 218.224 388.979 218.281 388.953C218.318 388.938 218.344 388.917 218.37 388.885C218.391 388.854 218.406 388.813 218.401 388.776C218.401 388.755 218.401 388.729 218.391 388.714C218.38 388.672 218.359 388.641 218.333 388.609C218.292 388.552 218.24 388.5 218.182 388.448C218.099 388.37 218.005 388.292 217.932 388.224C217.896 388.188 217.865 388.156 217.844 388.13C217.833 388.115 217.823 388.104 217.823 388.099C217.818 388.094 217.818 388.089 217.818 388.089V388.083L217.792 388.089H217.818V388.083L217.792 388.089H217.818V388.083C217.818 388.078 217.818 388.063 217.823 388.036C217.828 388 217.844 387.938 217.865 387.87C217.943 387.62 218.094 387.24 218.25 386.932C218.328 386.776 218.411 386.635 218.484 386.542C218.521 386.495 218.552 386.458 218.578 386.438C218.594 386.427 218.604 386.422 218.609 386.417H218.615L218.609 386.396V386.417H218.615L218.609 386.396V386.417V386.385L218.604 386.417H218.609V386.385L218.604 386.417C218.609 386.417 218.615 386.422 218.625 386.432C218.646 386.453 218.672 386.49 218.693 386.536C218.734 386.62 218.776 386.74 218.813 386.865C218.865 387.057 218.906 387.271 218.932 387.432C218.948 387.516 218.958 387.583 218.964 387.635C218.969 387.656 218.969 387.677 218.969 387.693C218.974 387.698 218.974 387.703 218.974 387.703C218.974 387.708 218.974 387.708 218.974 387.708C218.979 387.766 219.031 387.807 219.089 387.802C219.151 387.792 219.187 387.74 219.182 387.688Z",
    fill: "#B55642"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M218.734 388.115C218.734 388.109 218.74 388.052 218.74 387.964C218.74 387.812 218.724 387.568 218.661 387.328C218.63 387.208 218.583 387.089 218.516 386.984C218.448 386.875 218.359 386.781 218.24 386.724C218.188 386.698 218.125 386.719 218.099 386.771C218.073 386.818 218.094 386.88 218.146 386.906C218.224 386.948 218.286 387.01 218.339 387.094C218.417 387.214 218.464 387.38 218.495 387.542C218.521 387.703 218.526 387.859 218.526 387.964C218.526 388.005 218.526 388.042 218.526 388.062C218.526 388.073 218.526 388.083 218.526 388.089C218.526 388.094 218.521 388.094 218.521 388.094V388.099C218.521 388.156 218.563 388.203 218.62 388.208C218.677 388.214 218.729 388.167 218.734 388.115Z",
    fill: "#B55642"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M204.234 380.057L204.229 380.052C204.193 380.031 203.859 379.818 203.531 379.573C203.365 379.448 203.198 379.313 203.068 379.193C203 379.13 202.943 379.073 202.901 379.021C202.88 378.995 202.865 378.974 202.854 378.953C202.839 378.932 202.833 378.911 202.828 378.901C202.812 378.849 202.75 378.818 202.693 378.833C202.641 378.854 202.609 378.911 202.63 378.964C202.641 379 202.656 379.031 202.672 379.063C202.714 379.12 202.76 379.182 202.818 379.24C202.922 379.349 203.052 379.464 203.193 379.573C203.401 379.745 203.635 379.906 203.812 380.026C203.99 380.151 204.12 380.229 204.12 380.229C204.167 380.26 204.234 380.245 204.266 380.198C204.297 380.151 204.281 380.089 204.234 380.057Z",
    fill: "#86401B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M204.141 381.047C204.125 381.052 203.979 381.104 203.781 381.151C203.589 381.203 203.339 381.245 203.12 381.245C203.01 381.245 202.906 381.234 202.823 381.208C202.786 381.193 202.75 381.177 202.719 381.156C202.693 381.135 202.667 381.115 202.651 381.089C202.62 381.042 202.552 381.026 202.505 381.057C202.453 381.089 202.443 381.156 202.474 381.203C202.51 381.25 202.552 381.292 202.599 381.328C202.672 381.375 202.755 381.406 202.844 381.427C202.932 381.448 203.026 381.453 203.12 381.453C203.375 381.453 203.646 381.401 203.854 381.349C204.062 381.297 204.208 381.24 204.214 381.24C204.266 381.224 204.297 381.161 204.276 381.109C204.255 381.057 204.193 381.026 204.141 381.047Z",
    fill: "#86401B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M204.151 382.078C204.151 382.078 204.151 382.078 204.141 382.078C204.078 382.094 203.781 382.151 203.453 382.208C203.286 382.24 203.109 382.266 202.948 382.286C202.786 382.307 202.641 382.318 202.536 382.318C202.49 382.318 202.453 382.318 202.427 382.313C202.417 382.313 202.411 382.307 202.411 382.307L202.401 382.333L202.417 382.313C202.411 382.307 202.411 382.307 202.411 382.307L202.401 382.333L202.417 382.313L202.38 382.359L202.427 382.323C202.422 382.318 202.417 382.313 202.417 382.313L202.38 382.359L202.427 382.323C202.396 382.276 202.328 382.266 202.281 382.297C202.234 382.333 202.224 382.396 202.255 382.443C202.266 382.458 202.276 382.469 202.286 382.474C202.307 382.49 202.328 382.5 202.349 382.505C202.375 382.516 202.406 382.521 202.438 382.521C202.469 382.526 202.5 382.526 202.536 382.526C202.667 382.526 202.833 382.51 203.01 382.49C203.542 382.417 204.198 382.276 204.198 382.276C204.255 382.266 204.292 382.208 204.276 382.156C204.266 382.099 204.208 382.063 204.151 382.078Z",
    fill: "#86401B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M209.938 378.568C209.958 378.547 210.385 378.182 210.979 377.823C211.276 377.646 211.615 377.469 211.964 377.339C212.313 377.208 212.672 377.12 213.01 377.12C213.12 377.12 213.229 377.13 213.339 377.151C214.193 377.307 215.406 377.453 216.406 377.453C216.792 377.453 217.151 377.432 217.443 377.38C217.594 377.349 217.724 377.318 217.839 377.271C217.953 377.224 218.047 377.167 218.12 377.089C218.161 377.047 218.161 376.984 218.12 376.943C218.073 376.906 218.01 376.906 217.969 376.948C217.927 376.995 217.854 377.036 217.755 377.078C217.615 377.135 217.417 377.182 217.188 377.208C216.958 377.234 216.688 377.25 216.406 377.25C215.427 377.25 214.219 377.099 213.375 376.948C213.255 376.927 213.135 376.917 213.01 376.917C212.63 376.917 212.24 377.01 211.87 377.151C211.313 377.365 210.797 377.677 210.417 377.938C210.042 378.203 209.797 378.411 209.797 378.411C209.75 378.448 209.75 378.516 209.786 378.557C209.823 378.599 209.891 378.604 209.938 378.568Z",
    fill: "#86401B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M213.057 378C213.068 377.995 213.542 377.823 214.208 377.823C214.547 377.823 214.932 377.87 215.333 378C215.781 378.146 216.25 378.344 216.703 378.51C216.927 378.594 217.146 378.667 217.359 378.719C217.573 378.771 217.776 378.807 217.969 378.807C218.104 378.807 218.234 378.792 218.359 378.75C218.479 378.714 218.599 378.651 218.698 378.568C218.745 378.531 218.75 378.469 218.714 378.422C218.677 378.38 218.609 378.375 218.562 378.411C218.484 378.479 218.396 378.526 218.297 378.552C218.198 378.583 218.089 378.599 217.969 378.599C217.802 378.599 217.609 378.568 217.411 378.521C217.109 378.443 216.781 378.323 216.437 378.193C216.099 378.057 215.745 377.917 215.396 377.802C214.974 377.667 214.568 377.62 214.208 377.62C213.495 377.62 212.995 377.802 212.984 377.802C212.932 377.823 212.901 377.885 212.922 377.938C212.943 377.99 213.005 378.016 213.057 378Z",
    fill: "#86401B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M215.745 379C215.75 379 216.042 379.365 216.474 379.729C216.688 379.911 216.932 380.094 217.198 380.234C217.328 380.307 217.464 380.365 217.599 380.406C217.734 380.448 217.875 380.474 218.016 380.474C218.135 380.474 218.255 380.453 218.37 380.411C218.484 380.37 218.599 380.307 218.703 380.219C218.745 380.182 218.75 380.12 218.714 380.073C218.672 380.031 218.609 380.026 218.563 380.063C218.479 380.135 218.391 380.188 218.297 380.219C218.208 380.25 218.115 380.266 218.016 380.266C217.901 380.266 217.781 380.245 217.661 380.208C217.448 380.146 217.234 380.031 217.026 379.891C216.719 379.682 216.438 379.427 216.234 379.224C216.135 379.12 216.052 379.031 215.995 378.969C215.969 378.938 215.948 378.911 215.932 378.896C215.922 378.885 215.917 378.88 215.917 378.875L215.911 378.87C215.875 378.823 215.807 378.818 215.76 378.854C215.714 378.891 215.708 378.953 215.745 379Z",
    fill: "#86401B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M217.01 381.438C217.01 381.438 217.188 381.542 217.427 381.646C217.547 381.698 217.682 381.75 217.823 381.792C217.964 381.833 218.109 381.859 218.245 381.859C218.333 381.859 218.422 381.849 218.5 381.818C218.578 381.792 218.656 381.745 218.714 381.677C218.75 381.63 218.745 381.568 218.698 381.531C218.656 381.495 218.589 381.5 218.552 381.542C218.521 381.583 218.479 381.609 218.427 381.625C218.375 381.646 218.313 381.651 218.245 381.651C218.135 381.651 218.01 381.63 217.88 381.594C217.688 381.542 217.495 381.458 217.354 381.385C217.281 381.349 217.224 381.318 217.182 381.297C217.161 381.286 217.146 381.276 217.135 381.271C217.13 381.266 217.125 381.266 217.125 381.266L217.12 381.26C217.068 381.234 217.005 381.245 216.974 381.297C216.943 381.344 216.958 381.406 217.01 381.438Z",
    fill: "#86401B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M217.292 391.042C217.031 391.089 214.146 390.792 213.073 389.896C212.281 389.24 211.047 389.125 210.437 389.109C209.833 389.125 208.599 389.24 207.807 389.896C206.734 390.792 203.849 391.089 203.583 391.042C203.583 391.042 203.193 391.396 203.26 391.901C203.323 392.401 206.297 398.182 209.74 398.531C209.74 398.531 210.005 398.609 210.437 398.599C210.875 398.609 211.135 398.531 211.135 398.531C214.583 398.182 217.557 392.401 217.62 391.901C217.687 391.396 217.292 391.042 217.292 391.042Z",
    fill: "#212B3F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M219.031 375.219H202.589C202.354 375.599 201.901 376.51 201.896 377.901C201.891 379.771 202.344 383.224 202.344 383.224C202.344 383.224 202.307 384.198 203.26 384.036C204.214 383.875 207.302 382.234 210.813 382.177C214.318 382.234 217.411 383.875 218.365 384.036C219.318 384.198 219.281 383.224 219.281 383.224C219.281 383.224 219.729 379.771 219.724 377.901C219.724 376.51 219.266 375.599 219.031 375.219Z",
    fill: "#FAFCFE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M201.13 402.323C201.13 402.323 199.328 390.542 199.328 382.818C199.328 380.646 199.474 378.792 199.839 377.615C199.839 377.615 200.281 376.214 202.406 375.552C202.172 376.026 201.901 376.823 201.896 377.901C201.896 379.188 202.104 381.224 202.24 382.37C202.234 382.385 202.24 382.406 202.245 382.422C202.302 382.911 202.344 383.224 202.344 383.224C202.344 383.224 202.318 383.833 202.781 384.01C202.943 384.62 203.115 385.349 203.245 385.911C202.917 385.677 202.646 385.573 202.422 385.573C201.703 385.573 201.495 386.615 201.635 387.75L199.708 389.641C199.818 390.995 199.943 392.349 200.083 393.635L200.88 392.849C200.807 393.198 200.766 393.578 200.766 393.979C200.766 395.599 201.437 396.911 202.266 396.911C202.312 396.911 202.359 396.911 202.401 396.901L204.547 396.714C204.979 396.714 205.37 396.354 205.641 395.786C205.719 395.885 205.802 395.979 205.885 396.073C205.797 396.766 205.693 397.458 205.568 398.135C205.464 398.74 205.339 399.328 205.203 399.891C204.531 400.141 203.234 400.771 201.13 402.323Z",
    fill: "#855F34"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M206.302 399.901C206.12 399.844 205.938 399.786 205.76 399.724C205.76 399.724 205.589 399.745 205.203 399.891C205.339 399.328 205.464 398.74 205.568 398.135C205.568 398.156 205.563 398.177 205.563 398.193C206 398.505 206.5 398.849 207.031 399.182L206.302 399.901Z",
    fill: "#A1696C"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M207.031 399.182C206.5 398.849 206 398.505 205.562 398.193C205.562 398.177 205.568 398.156 205.568 398.135C205.693 397.458 205.797 396.766 205.885 396.073C206.573 396.854 207.359 397.573 208.208 398.031L207.031 399.182Z",
    fill: "#9B5867"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M201.635 387.75C201.495 386.615 201.703 385.573 202.422 385.573C202.646 385.573 202.917 385.677 203.245 385.911C203.266 385.984 203.281 386.052 203.297 386.12L202.792 386.615C202.745 386.542 202.703 386.474 202.661 386.417C202.615 386.359 202.573 386.313 202.531 386.276C202.505 386.26 202.484 386.245 202.458 386.229C202.432 386.219 202.401 386.208 202.365 386.208C202.349 386.208 202.333 386.208 202.323 386.214C202.286 386.224 202.255 386.24 202.229 386.26C202.177 386.302 202.146 386.349 202.109 386.406C202.057 386.51 202.01 386.635 201.974 386.776C201.911 386.979 201.87 387.208 201.839 387.38C201.823 387.464 201.813 387.531 201.807 387.583L201.635 387.75ZM202.063 387.333C202.078 387.24 202.099 387.13 202.125 387.026C202.161 386.865 202.208 386.703 202.255 386.589C202.281 386.531 202.307 386.484 202.333 386.453C202.344 386.438 202.354 386.427 202.359 386.422C202.365 386.422 202.365 386.417 202.365 386.417C202.37 386.417 202.375 386.422 202.385 386.427C202.406 386.443 202.443 386.479 202.484 386.531C202.531 386.594 202.583 386.677 202.635 386.766L202.063 387.333ZM203.844 385.583C203.833 385.542 203.823 385.5 203.813 385.458C203.953 384.917 204.115 384.292 204.25 383.724C204.854 383.5 205.646 383.193 206.563 382.911L203.844 385.583Z",
    fill: "#A1696C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M203.297 386.12C203.281 386.052 203.266 385.984 203.245 385.911C203.115 385.349 202.943 384.62 202.781 384.01C202.839 384.031 202.901 384.047 202.974 384.052C203.036 384.438 203.156 385.198 203.313 386.104L203.297 386.12ZM203.813 385.458C203.688 384.932 203.578 384.432 203.49 383.984C203.693 383.927 203.948 383.833 204.25 383.724C204.115 384.292 203.953 384.917 203.813 385.458Z",
    fill: "#1E2645"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M203.312 386.104C203.156 385.198 203.036 384.438 202.974 384.052C203 384.052 203.026 384.057 203.057 384.057C203.12 384.057 203.187 384.052 203.26 384.036C203.323 384.026 203.401 384.005 203.49 383.984C203.578 384.432 203.687 384.932 203.812 385.458C203.823 385.5 203.833 385.542 203.844 385.583L203.312 386.104Z",
    fill: "#202B3F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M201.807 387.583C201.813 387.531 201.823 387.464 201.839 387.38C201.87 387.208 201.911 386.979 201.974 386.776C202.01 386.635 202.057 386.51 202.109 386.406C202.146 386.349 202.177 386.302 202.229 386.26C202.255 386.24 202.286 386.224 202.323 386.214C202.333 386.208 202.349 386.208 202.365 386.208C202.401 386.208 202.432 386.219 202.458 386.229C202.484 386.245 202.505 386.26 202.531 386.276C202.573 386.313 202.615 386.359 202.661 386.417C202.703 386.474 202.745 386.542 202.792 386.615L202.635 386.766C202.583 386.677 202.531 386.594 202.484 386.531C202.443 386.479 202.406 386.443 202.385 386.427C202.375 386.422 202.37 386.417 202.365 386.417C202.365 386.417 202.365 386.422 202.359 386.422C202.354 386.427 202.344 386.438 202.333 386.453C202.307 386.484 202.281 386.531 202.255 386.589C202.208 386.703 202.161 386.865 202.125 387.026C202.099 387.13 202.078 387.24 202.063 387.333L201.807 387.583Z",
    fill: "#7E4747"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M219.667 402.156C219.25 401.849 217.891 400.854 216.943 400.26L220.292 396.974C220.406 395.938 220.526 394.797 220.641 393.599L220.156 394.078C220.156 394.047 220.156 394.01 220.156 393.979C220.156 393.339 220.052 392.75 219.875 392.266L220.844 391.318C221.016 389.292 221.151 387.203 221.219 385.266L219.328 387.12C219.328 386.255 219.089 385.573 218.521 385.573C218.38 385.573 218.219 385.615 218.036 385.708C218.234 384.719 218.365 384.036 218.365 384.036C218.438 384.052 218.505 384.057 218.568 384.057C219.313 384.057 219.281 383.224 219.281 383.224C219.281 383.224 219.729 379.771 219.724 377.901C219.724 377.182 219.604 376.594 219.453 376.135C219.745 376.307 219.969 376.484 220.141 376.651C220.677 377.177 220.693 377.615 220.693 377.615C221.979 380.932 220.776 392.958 220.078 398.88C220.047 399.13 220.021 399.37 219.99 399.599C219.99 399.599 219.99 399.604 219.99 399.609C219.974 399.755 219.953 399.896 219.938 400.031C219.932 400.078 219.927 400.13 219.922 400.177C219.786 401.245 219.693 401.958 219.667 402.156ZM202.76 391.005L203.198 390.573C203.302 390.609 203.391 390.615 203.453 390.615C203.51 390.615 203.542 390.609 203.542 390.609C203.552 390.719 203.568 390.823 203.583 390.932L202.76 391.005Z",
    fill: "#855F34"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M203.583 390.932C203.568 390.823 203.552 390.719 203.542 390.609C203.542 390.609 203.51 390.615 203.453 390.615C203.391 390.615 203.302 390.609 203.198 390.573L204.021 389.771C204.104 390.167 204.193 390.536 204.281 390.87L203.583 390.932ZM205.224 390.854C205.099 390.411 204.927 389.786 204.734 389.068L206.818 387.026C207.26 386.995 207.385 386.672 207.417 386.474C207.573 386.542 207.677 386.615 207.75 386.625C207.766 386.63 207.781 386.63 207.797 386.63C207.995 386.63 208.042 386.406 208.042 386.406C207.911 386.318 207.786 386.245 207.667 386.188L211.708 382.224C213.875 382.422 215.818 383.146 217.094 383.62C217.182 384.938 217.156 386.313 217.156 386.313L217.339 386.161C217 387.484 216.583 388.958 216.234 390.156L215.542 390.833C214.641 390.656 213.62 390.354 213.073 389.896C212.568 389.474 211.875 389.276 211.286 389.188C211.286 389.156 211.281 389.13 211.281 389.104C211.281 387.901 211.625 386.891 211.964 386.182C212.135 385.828 212.302 385.547 212.432 385.359C212.495 385.266 212.547 385.188 212.583 385.141C212.604 385.115 212.62 385.099 212.625 385.089C212.63 385.083 212.635 385.078 212.635 385.073H212.641V385.068L212.479 384.938C212.474 384.943 212.125 385.365 211.776 386.094C211.422 386.823 211.073 387.865 211.073 389.104C211.073 389.12 211.073 389.141 211.073 389.156C210.828 389.125 210.609 389.115 210.438 389.109C209.833 389.125 208.599 389.24 207.807 389.896C207.24 390.375 206.151 390.682 205.224 390.854ZM213.37 386.474C213.406 386.682 213.536 387.026 214.036 387.026C214.547 387.026 214.589 386.568 214.589 386.385C214.771 386.438 214.974 386.51 215.193 386.625C215.193 386.625 214.708 386 213.901 386C213.568 386 213.177 386.104 212.75 386.406C212.75 386.406 212.792 386.63 212.99 386.63C213.005 386.63 213.021 386.63 213.036 386.625C213.109 386.615 213.219 386.542 213.37 386.474ZM214.37 384.573C214.396 384.573 214.417 384.573 214.432 384.578C214.724 384.625 215.526 384.807 215.526 384.807C215.526 384.807 214.953 384.177 214.432 384.073C214.307 384.052 214.099 384.036 213.859 384.036C213.12 384.036 212.078 384.156 212.198 384.365C212.198 384.365 212.229 384.672 212.615 384.786C212.667 384.802 212.734 384.807 212.807 384.807C213.031 384.807 213.344 384.75 213.635 384.688C213.932 384.63 214.214 384.573 214.37 384.573ZM217.365 388.958C217.615 387.802 217.859 386.62 218.036 385.708C218.219 385.615 218.38 385.573 218.521 385.573C219.089 385.573 219.328 386.255 219.328 387.12L219.125 387.318C219.109 387.224 219.089 387.115 219.063 387.01C219.026 386.839 218.974 386.661 218.917 386.521C218.885 386.448 218.854 386.385 218.813 386.333C218.797 386.307 218.771 386.281 218.745 386.26C218.719 386.24 218.693 386.224 218.656 386.214C218.641 386.208 218.625 386.208 218.609 386.208C218.568 386.208 218.531 386.224 218.5 386.24C218.474 386.255 218.448 386.276 218.422 386.297C218.375 386.344 218.328 386.396 218.281 386.458C218.203 386.573 218.125 386.714 218.047 386.87C217.932 387.099 217.823 387.354 217.74 387.578C217.703 387.688 217.667 387.786 217.646 387.875C217.635 387.917 217.625 387.953 217.615 387.99C217.609 388.026 217.604 388.052 217.604 388.083C217.604 388.094 217.604 388.104 217.609 388.12C217.615 388.161 217.635 388.198 217.656 388.234C217.698 388.292 217.755 388.344 217.813 388.396C217.849 388.432 217.885 388.464 217.922 388.495L217.599 388.818C217.578 388.823 217.557 388.823 217.536 388.828C217.495 388.844 217.448 388.865 217.406 388.901C217.391 388.917 217.375 388.938 217.365 388.958ZM218.073 388.349C218.021 388.307 217.974 388.26 217.932 388.224C217.896 388.188 217.865 388.156 217.844 388.13C217.833 388.115 217.823 388.104 217.823 388.099C217.818 388.094 217.818 388.089 217.818 388.089V388.083C217.818 388.078 217.818 388.063 217.823 388.036C217.828 388 217.844 387.938 217.865 387.87C217.938 387.63 218.078 387.271 218.234 386.969C218.271 387 218.307 387.042 218.339 387.094C218.417 387.214 218.464 387.38 218.495 387.542C218.516 387.677 218.526 387.807 218.526 387.906L218.073 388.349ZM218.729 387.708C218.719 387.594 218.698 387.458 218.661 387.328C218.63 387.208 218.583 387.089 218.516 386.984C218.469 386.906 218.406 386.833 218.333 386.781C218.385 386.688 218.438 386.604 218.484 386.542C218.521 386.495 218.552 386.458 218.578 386.438C218.594 386.427 218.604 386.422 218.609 386.417C218.615 386.422 218.62 386.427 218.625 386.432C218.646 386.453 218.672 386.49 218.693 386.536C218.734 386.62 218.776 386.74 218.813 386.865C218.865 387.057 218.906 387.271 218.932 387.432C218.938 387.453 218.938 387.479 218.943 387.5L218.729 387.708Z",
    fill: "#A1696C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M217.156 386.313C217.156 386.313 217.182 384.938 217.094 383.62C217.38 383.729 217.635 383.823 217.849 383.896C217.74 384.505 217.557 385.302 217.339 386.161L217.156 386.313Z",
    fill: "#1E2645"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M204.88 390.917C204.771 390.87 204.661 390.844 204.547 390.844L204.281 390.87C204.193 390.536 204.104 390.167 204.021 389.771L204.734 389.068C204.927 389.786 205.099 390.411 205.224 390.854C205.104 390.88 204.99 390.901 204.88 390.917Z",
    fill: "#202B3F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M216.234 390.156C216.583 388.958 217 387.484 217.339 386.161C217.557 385.302 217.74 384.505 217.849 383.896C218.057 383.964 218.229 384.016 218.365 384.036C218.365 384.036 218.234 384.719 218.036 385.708C217.859 386.62 217.615 387.802 217.365 388.958C217.349 388.984 217.333 389.01 217.328 389.042C217.323 389.057 217.318 389.073 217.318 389.094L216.234 390.156Z",
    fill: "#202B3F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M215.526 384.807C215.526 384.807 214.724 384.625 214.432 384.578C214.417 384.573 214.396 384.573 214.37 384.573C214.214 384.573 213.932 384.63 213.635 384.688C213.344 384.75 213.031 384.807 212.807 384.807C212.734 384.807 212.667 384.802 212.615 384.786C212.229 384.672 212.198 384.365 212.198 384.365C212.078 384.156 213.12 384.036 213.859 384.036C214.099 384.036 214.307 384.052 214.432 384.073C214.953 384.177 215.526 384.807 215.526 384.807Z",
    fill: "#1E2645"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M207.797 386.63C207.781 386.63 207.766 386.63 207.75 386.625C207.677 386.615 207.573 386.542 207.417 386.474C207.422 386.458 207.422 386.443 207.427 386.427L207.667 386.188C207.786 386.245 207.911 386.318 208.042 386.406C208.042 386.406 207.995 386.63 207.797 386.63Z",
    fill: "#1E2645"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M206.818 387.026L207.427 386.427C207.422 386.443 207.422 386.458 207.417 386.474C207.385 386.672 207.26 386.995 206.818 387.026Z",
    fill: "#1E2645"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M212.99 386.63C212.792 386.63 212.75 386.406 212.75 386.406C213.177 386.104 213.568 386 213.901 386C214.708 386 215.193 386.625 215.193 386.625C214.974 386.51 214.771 386.438 214.589 386.385C214.589 386.344 214.583 386.313 214.583 386.313C214.583 386.313 214.167 386.234 213.802 386.234C213.62 386.234 213.453 386.255 213.354 386.313C213.354 386.313 213.354 386.38 213.37 386.474C213.219 386.542 213.109 386.615 213.036 386.625C213.021 386.63 213.005 386.63 212.99 386.63Z",
    fill: "#1E2645"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M214.036 387.026C213.536 387.026 213.406 386.682 213.37 386.474C213.354 386.38 213.354 386.313 213.354 386.313C213.453 386.255 213.62 386.234 213.802 386.234C214.167 386.234 214.583 386.313 214.583 386.313C214.583 386.313 214.589 386.344 214.589 386.385C214.589 386.568 214.547 387.026 214.036 387.026Z",
    fill: "#1E2645"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M211.286 389.188C211.214 389.172 211.141 389.167 211.073 389.156C211.073 389.141 211.073 389.12 211.073 389.104C211.073 387.865 211.422 386.823 211.776 386.094C212.125 385.365 212.474 384.943 212.479 384.938L212.641 385.068V385.073H212.635C212.635 385.078 212.63 385.083 212.625 385.089C212.62 385.099 212.604 385.115 212.583 385.141C212.547 385.187 212.495 385.266 212.432 385.359C212.302 385.547 212.135 385.828 211.964 386.182C211.625 386.891 211.281 387.901 211.281 389.104C211.281 389.13 211.286 389.156 211.286 389.188Z",
    fill: "#7E4747"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M217.318 389.094C217.318 389.073 217.323 389.057 217.328 389.042C217.333 389.01 217.349 388.984 217.365 388.958C217.375 388.938 217.391 388.917 217.406 388.901C217.448 388.865 217.495 388.844 217.536 388.828C217.557 388.823 217.578 388.823 217.599 388.818L217.318 389.094ZM217.922 388.495C217.885 388.464 217.849 388.432 217.812 388.396C217.755 388.344 217.698 388.292 217.656 388.234C217.635 388.198 217.615 388.161 217.609 388.12C217.604 388.104 217.604 388.094 217.604 388.083C217.604 388.052 217.609 388.026 217.615 387.99C217.625 387.953 217.635 387.917 217.646 387.875C217.667 387.786 217.703 387.688 217.74 387.578C217.823 387.354 217.932 387.099 218.047 386.87C218.125 386.714 218.203 386.573 218.281 386.458C218.328 386.396 218.375 386.344 218.422 386.297C218.448 386.276 218.474 386.255 218.5 386.24C218.531 386.224 218.568 386.208 218.609 386.208C218.625 386.208 218.641 386.208 218.656 386.214C218.693 386.224 218.719 386.24 218.745 386.26C218.771 386.281 218.797 386.307 218.812 386.333C218.854 386.385 218.885 386.448 218.917 386.521C218.974 386.661 219.026 386.839 219.062 387.01C219.089 387.115 219.109 387.224 219.125 387.318L218.943 387.5C218.937 387.479 218.937 387.453 218.932 387.432C218.906 387.271 218.865 387.057 218.812 386.865C218.776 386.74 218.734 386.62 218.693 386.536C218.672 386.49 218.646 386.453 218.625 386.432C218.62 386.427 218.615 386.422 218.609 386.417C218.604 386.422 218.594 386.427 218.578 386.438C218.552 386.458 218.521 386.495 218.484 386.542C218.437 386.604 218.385 386.688 218.333 386.781C218.302 386.76 218.271 386.74 218.24 386.724C218.224 386.714 218.208 386.714 218.193 386.714C218.156 386.714 218.12 386.734 218.099 386.771C218.073 386.818 218.094 386.88 218.146 386.906C218.177 386.922 218.203 386.943 218.234 386.969C218.078 387.271 217.937 387.63 217.865 387.87C217.844 387.938 217.828 388 217.823 388.036C217.818 388.063 217.818 388.078 217.818 388.083V388.089C217.818 388.089 217.818 388.094 217.823 388.099C217.823 388.104 217.833 388.115 217.844 388.13C217.865 388.156 217.896 388.188 217.932 388.224C217.974 388.26 218.021 388.307 218.073 388.349L217.922 388.495Z",
    fill: "#7E4747"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M215.047 399.089C214.932 398.531 214.823 397.943 214.719 397.323L215.682 396.38C215.891 396.594 216.125 396.714 216.375 396.714L217.38 396.802L215.047 399.089Z",
    fill: "#855F34"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M211.604 400.38L214.719 397.323C214.823 397.943 214.932 398.531 215.047 399.089L213.958 400.156C213.281 400.25 212.474 400.339 211.604 400.38Z",
    fill: "#9B5867"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M218.526 387.906C218.526 387.807 218.516 387.677 218.495 387.542C218.464 387.38 218.417 387.214 218.339 387.094C218.307 387.042 218.271 387 218.234 386.969C218.203 386.943 218.177 386.922 218.146 386.906C218.094 386.88 218.073 386.818 218.099 386.771C218.12 386.734 218.156 386.714 218.193 386.714C218.208 386.714 218.224 386.714 218.24 386.724C218.271 386.74 218.302 386.76 218.333 386.781C218.406 386.833 218.469 386.906 218.516 386.984C218.583 387.089 218.63 387.208 218.661 387.328C218.698 387.458 218.719 387.594 218.729 387.708L218.526 387.906Z",
    fill: "#7E4747"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M202.245 382.422C202.24 382.406 202.234 382.385 202.24 382.37C202.24 382.385 202.245 382.401 202.245 382.422Z",
    fill: "#63392A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M208.208 398.031C207.359 397.573 206.573 396.854 205.885 396.073C205.802 395.979 205.719 395.885 205.641 395.786C205.896 395.266 206.047 394.557 206.047 393.781C206.047 392.38 205.547 391.208 204.88 390.917C204.99 390.901 205.104 390.88 205.224 390.854C206.151 390.682 207.24 390.375 207.807 389.896C208.599 389.24 209.833 389.125 210.437 389.109C210.609 389.115 210.828 389.125 211.073 389.156C211.141 389.167 211.214 389.172 211.286 389.188C211.875 389.276 212.568 389.474 213.073 389.896C213.62 390.354 214.641 390.656 215.542 390.833L214.766 391.594C214.49 391.646 214.24 391.901 214.062 392.286L208.208 398.031Z",
    fill: "#202B3F"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M216.552 375.219H215.51C215.396 375.214 215.276 375.214 215.156 375.214C215.031 375.214 214.906 375.214 214.781 375.219H213.255C213.859 375.172 214.479 375.135 215.094 375.135C215.37 375.135 215.646 375.146 215.922 375.161C216.135 375.172 216.344 375.193 216.552 375.219Z",
    fill: "#855F34"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M218.568 384.057C218.505 384.057 218.437 384.052 218.365 384.036C218.234 384.016 218.057 383.964 217.849 383.896C217.635 383.823 217.38 383.729 217.094 383.62C215.818 383.146 213.875 382.422 211.708 382.224L218.365 375.693C218.167 375.625 217.953 375.563 217.724 375.5C217.021 375.313 216.271 375.234 215.51 375.219H216.552C216.932 375.26 217.302 375.328 217.661 375.422C217.661 375.427 217.667 375.427 217.667 375.427C218.448 375.635 219.021 375.88 219.453 376.135C219.604 376.594 219.724 377.182 219.724 377.901C219.729 379.771 219.281 383.224 219.281 383.224C219.281 383.224 219.312 384.057 218.568 384.057ZM203.057 384.057C203.026 384.057 203 384.052 202.974 384.052C202.901 384.047 202.839 384.031 202.781 384.01C202.318 383.833 202.344 383.224 202.344 383.224C202.344 383.224 202.302 382.911 202.245 382.422C202.245 382.401 202.24 382.385 202.24 382.37C202.104 381.224 201.896 379.188 201.896 377.901C201.901 376.823 202.172 376.026 202.406 375.552C202.552 375.505 202.708 375.464 202.87 375.422C202.906 375.417 202.948 375.406 202.99 375.401C203.479 375.302 204.125 375.266 204.865 375.266C206.401 375.266 208.323 375.411 210.052 375.417C210.083 375.417 210.115 375.417 210.146 375.417C210.203 375.417 210.26 375.417 210.318 375.417C211.198 375.401 212.208 375.297 213.255 375.219H214.781C214.651 375.219 214.526 375.224 214.396 375.229L206.562 382.911C205.646 383.193 204.854 383.5 204.25 383.724C203.948 383.833 203.693 383.927 203.49 383.984C203.401 384.005 203.323 384.026 203.26 384.036C203.187 384.052 203.12 384.057 203.057 384.057Z",
    fill: "#A09FAD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M206.047 395.875C206.656 395.875 207.146 394.911 207.146 393.729C207.146 392.547 206.656 391.583 206.047 391.583L203.729 391.885V396.172L206.047 395.875Z",
    fill: "#40516D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M204.547 396.714C205.375 396.714 206.047 395.401 206.047 393.781C206.047 392.161 205.375 390.844 204.547 390.844L202.266 391.047V396.911L204.547 396.714Z",
    fill: "#313F56"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M200.766 393.979C200.766 395.599 201.437 396.911 202.266 396.911C203.094 396.911 203.766 395.599 203.766 393.979C203.766 392.359 203.094 391.047 202.266 391.047C201.437 391.047 200.766 392.359 200.766 393.979Z",
    fill: "#4C5D78"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M214.875 395.875C214.271 395.875 213.776 394.911 213.776 393.729C213.776 392.547 214.271 391.583 214.875 391.583L217.198 391.885V396.172L214.875 395.875Z",
    fill: "#40516D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M216.375 396.714C215.547 396.714 214.875 395.401 214.875 393.781C214.875 392.161 215.547 390.844 216.375 390.844L218.656 391.047V396.911L216.375 396.714Z",
    fill: "#313F56"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M220.156 393.979C220.156 395.599 219.484 396.911 218.656 396.911C217.828 396.911 217.156 395.599 217.156 393.979C217.156 392.359 217.828 391.047 218.656 391.047C219.484 391.047 220.156 392.359 220.156 393.979Z",
    fill: "#4C5D78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 404,
    width: 14,
    height: 12
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "9c052bdd04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M222.667 404H235.911V415.823H222.667V404Z",
    fill: "white"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M235.875 415.823C235.062 412.609 234.01 409.396 232.927 408.193C230.745 405.766 224.292 404.135 224.292 404.135C224.292 404.135 223.818 410.359 223.49 415.823H235.875Z",
    fill: "#E1901B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 414,
    width: 5,
    height: 2
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "8a4acffdc8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M222.667 414.667H226.667V415.823H222.667V414.667Z",
    fill: "white"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M225.583 415.823C225.469 415.729 225.396 415.677 225.396 415.677L223.542 414.979C223.526 415.26 223.505 415.542 223.49 415.823H225.583Z",
    fill: "#BE741A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 404,
    width: 15,
    height: 12
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "71da00fd68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M183.911 404H197.333V415.823H183.911V404Z",
    fill: "white"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M196.344 415.823C196.016 410.354 195.536 404.104 195.536 404.104C195.536 404.104 189.089 405.734 186.901 408.161C185.818 409.37 184.766 412.599 183.948 415.823H196.344Z",
    fill: "#E1901B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_37"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 414,
    width: 5,
    height: 2
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "93028c6e5c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M193.333 414.667H197.333V415.823H193.333V414.667Z",
    fill: "white"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M196.344 415.823C196.323 415.531 196.307 415.245 196.292 414.953L194.432 415.651C194.432 415.651 194.349 415.714 194.214 415.823H196.344Z",
    fill: "#BE741A"
  }))))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M195.161 408.448C195.109 407.63 195.042 406.813 194.943 405.995C194.932 405.88 194.823 405.802 194.708 405.813C194.594 405.828 194.51 405.927 194.526 406.042C194.62 406.849 194.687 407.661 194.74 408.474C194.75 408.589 194.849 408.672 194.964 408.667C195.083 408.656 195.172 408.557 195.161 408.448Z",
    fill: "#AA7128"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M216.474 406.167C217.531 405.115 218.146 403.797 218.505 402.557C218.375 402.484 218.245 402.411 218.12 402.339C217.781 403.563 217.193 404.859 216.172 405.875C214.792 407.245 212.849 407.87 210.38 407.729C210.13 407.74 204.693 407.87 203.448 402.083C203.323 402.151 203.193 402.214 203.062 402.281C204.443 408.302 210.333 408.146 210.38 408.146C210.609 408.156 210.839 408.167 211.063 408.167C213.318 408.167 215.135 407.49 216.474 406.167Z",
    fill: "#AA7128"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 400,
    width: 35,
    height: 16
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "256a9623c6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M193.333 400H228V415.823H193.333V400Z",
    fill: "white"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M226.776 415.823C226.776 410.276 226.609 404.901 226.193 404.542C225.396 403.854 219.443 402.651 217.865 401.161C216.292 399.667 215.906 400.641 215.906 400.641C215.427 401.005 212.505 401.245 210.292 401.255V401.276C208.104 401.26 206.068 401.104 205.594 400.745C205.594 400.745 205.208 399.771 203.63 401.26C202.057 402.75 195.245 403.875 194.448 404.563C194.036 404.917 193.87 410.281 193.87 415.823H226.776Z",
    fill: "#F9AB26"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 400,
    width: 6,
    height: 16
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "47ab0192c3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M208 400H213.333V415.823H208V400Z",
    fill: "white"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M212.276 415.823L212.224 401.208H208.146V415.823H212.276Z",
    fill: "#F2512F"
  }))))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M219.964 402.437C219.526 404.401 219.026 406.354 218.51 408.312C218.411 408.687 218.641 409.073 219.021 409.167C219.406 409.266 219.797 409.042 219.896 408.667C220.417 406.703 220.922 404.729 221.365 402.74C221.448 402.359 221.203 401.984 220.818 401.901C220.432 401.818 220.047 402.057 219.964 402.437Z",
    fill: "#0F1822"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M201.13 402.323C201.13 402.323 205.943 411.714 208.25 412.87C208.714 413.099 209.453 413.297 210.323 413.318C211.187 413.297 211.932 413.099 212.396 412.87C214.698 411.714 219.792 402.25 219.792 402.25C219.792 402.25 216.401 399.729 216.026 399.802C215.646 399.87 209.875 401.182 205.76 399.724C205.76 399.724 204.437 399.88 201.13 402.323Z",
    fill: "#212B3F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M215.094 374.531C214.151 374.531 213.219 374.609 212.318 374.688C211.536 374.755 210.797 374.813 210.146 374.813C209.26 374.813 208.302 374.776 207.38 374.734C206.484 374.698 205.635 374.661 204.865 374.661C203.911 374.661 203.234 374.719 202.724 374.839C199.896 375.5 199.276 377.354 199.25 377.432C197.562 382.865 200.401 401.615 200.526 402.411L200.536 402.505L200.583 402.594C200.594 402.615 201.812 404.984 203.297 407.469C206.37 412.604 207.573 413.208 207.969 413.406C208.516 413.682 209.083 413.792 210.047 413.813H210.073C210.141 413.813 210.203 413.807 210.266 413.807C210.328 413.807 210.391 413.813 210.453 413.813H210.484C211.354 413.792 212.208 413.604 212.818 413.297C213.219 413.099 214.422 412.495 217.495 407.359C218.979 404.88 220.198 402.51 220.208 402.484L220.255 402.396L220.266 402.297C220.38 401.469 223 382.146 221.292 377.469C221.219 377.026 220.76 375.625 217.823 374.844C217.036 374.635 216.146 374.531 215.094 374.531ZM215.094 375.135C215.974 375.135 216.844 375.208 217.661 375.427C220.641 376.219 220.693 377.615 220.693 377.615C222.417 382.068 219.656 402.214 219.656 402.214C219.656 402.214 214.844 411.604 212.542 412.76C212.078 412.995 211.333 413.193 210.469 413.214C210.401 413.208 210.333 413.203 210.266 413.203C210.198 413.203 210.13 413.208 210.062 413.214C209.193 413.193 208.714 413.099 208.25 412.87C205.943 411.714 201.13 402.323 201.13 402.323C201.13 402.323 198.172 382.974 199.839 377.615C199.839 377.615 200.349 376.016 202.87 375.427C203.375 375.307 204.068 375.266 204.865 375.266C206.427 375.266 208.396 375.417 210.146 375.417C211.568 375.417 213.349 375.135 215.094 375.135Z",
    fill: "#212B3F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M214.719 397.323C214.677 397.057 214.635 396.786 214.594 396.51C214.781 396.313 214.964 396.115 215.135 395.906L215.354 395.938C215.453 396.109 215.562 396.26 215.682 396.38L214.719 397.323Z",
    fill: "#A1815B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M209.12 400.37C208.167 400.302 207.203 400.161 206.302 399.901L207.031 399.182C207.698 399.604 208.411 400.021 209.12 400.37Z",
    fill: "#B78C8C"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M210.443 400.411C210.005 400.411 209.562 400.396 209.12 400.37C208.411 400.021 207.698 399.604 207.031 399.182L208.208 398.031C208.703 398.297 209.219 398.479 209.74 398.531C209.74 398.531 209.964 398.599 210.344 398.599C210.375 398.599 210.406 398.599 210.438 398.599C210.474 398.599 210.505 398.599 210.536 398.599C210.917 398.599 211.135 398.531 211.135 398.531C212.391 398.406 213.583 397.557 214.594 396.51C214.635 396.786 214.677 397.057 214.719 397.323L211.604 400.38C211.229 400.401 210.839 400.411 210.443 400.411Z",
    fill: "#B27E87"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M219.875 392.266C219.604 391.526 219.156 391.047 218.656 391.047L217.385 390.938C217.406 390.818 217.422 390.703 217.438 390.589C217.438 390.589 217.505 390.615 217.62 390.615C217.917 390.615 218.531 390.427 218.995 389.047C219.208 388.432 219.328 387.729 219.328 387.12L221.219 385.266C221.151 387.203 221.016 389.292 220.844 391.318L219.875 392.266Z",
    fill: "#A1815B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M217.385 390.938L216.917 390.896C217.047 390.365 217.177 389.786 217.313 389.193C217.313 389.276 217.323 389.359 217.339 389.443C217.365 389.573 217.406 389.698 217.458 389.797C217.484 389.844 217.51 389.891 217.542 389.927C217.557 389.943 217.578 389.958 217.599 389.974C217.625 389.99 217.656 390 217.693 390C217.714 390 217.74 389.995 217.76 389.984C217.813 389.958 217.833 389.896 217.807 389.844C217.786 389.807 217.75 389.786 217.714 389.786C217.708 389.786 217.703 389.786 217.698 389.792C217.698 389.786 217.698 389.786 217.693 389.781C217.677 389.76 217.656 389.724 217.635 389.682C217.604 389.615 217.573 389.531 217.552 389.443C217.531 389.354 217.521 389.266 217.521 389.193C217.521 389.151 217.526 389.115 217.531 389.089C217.536 389.073 217.542 389.063 217.552 389.052C217.557 389.047 217.563 389.042 217.573 389.036C217.589 389.031 217.609 389.026 217.646 389.021C217.677 389.016 217.714 389.016 217.755 389.016C217.807 389.016 217.859 389.016 217.917 389.016C217.974 389.016 218.036 389.016 218.099 389.005C218.161 388.995 218.224 388.979 218.281 388.953C218.318 388.938 218.344 388.917 218.37 388.885C218.391 388.854 218.406 388.813 218.401 388.776C218.401 388.755 218.401 388.729 218.391 388.714C218.38 388.672 218.359 388.641 218.333 388.609C218.292 388.552 218.24 388.5 218.182 388.448C218.146 388.417 218.109 388.385 218.073 388.349L218.526 387.906C218.526 387.927 218.526 387.948 218.526 387.964C218.526 388.005 218.526 388.042 218.526 388.063C218.526 388.073 218.526 388.083 218.526 388.089C218.526 388.094 218.521 388.094 218.521 388.094V388.099C218.521 388.156 218.563 388.203 218.62 388.208C218.625 388.208 218.625 388.208 218.63 388.208C218.682 388.208 218.729 388.167 218.734 388.115C218.734 388.109 218.74 388.052 218.74 387.964C218.74 387.896 218.734 387.807 218.729 387.708L218.943 387.5C218.953 387.552 218.958 387.599 218.964 387.635C218.969 387.656 218.969 387.677 218.969 387.693C218.974 387.698 218.974 387.703 218.974 387.703C218.974 387.708 218.974 387.708 218.974 387.708C218.979 387.76 219.026 387.802 219.078 387.802C219.083 387.802 219.089 387.802 219.089 387.802C219.151 387.792 219.188 387.74 219.182 387.688C219.182 387.682 219.161 387.526 219.125 387.318L219.328 387.12C219.328 387.729 219.208 388.432 218.995 389.047C218.531 390.427 217.917 390.615 217.62 390.615C217.505 390.615 217.438 390.589 217.438 390.589C217.422 390.703 217.406 390.818 217.385 390.938ZM216.01 390.917C215.859 390.896 215.703 390.865 215.542 390.833L216.234 390.156C216.156 390.427 216.078 390.682 216.01 390.917ZM217.599 388.818L217.922 388.495C217.979 388.547 218.036 388.594 218.083 388.641C218.12 388.677 218.151 388.714 218.172 388.74C218.177 388.75 218.188 388.76 218.188 388.766C218.156 388.781 218.115 388.797 218.068 388.802C218.021 388.807 217.974 388.807 217.917 388.807C217.865 388.807 217.807 388.807 217.755 388.807C217.714 388.807 217.672 388.807 217.63 388.813C217.62 388.813 217.609 388.818 217.599 388.818Z",
    fill: "#B78C8C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M216.031 390.922C216.026 390.922 216.016 390.917 216.01 390.917C216.078 390.682 216.156 390.427 216.234 390.156L217.318 389.094C217.313 389.125 217.313 389.156 217.313 389.193C217.177 389.786 217.047 390.365 216.917 390.896L216.375 390.844C216.255 390.844 216.141 390.87 216.031 390.922Z",
    fill: "#4A4E63"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M217.693 390C217.656 390 217.625 389.99 217.599 389.974C217.578 389.958 217.557 389.943 217.542 389.927C217.51 389.891 217.484 389.844 217.458 389.797C217.406 389.698 217.365 389.573 217.339 389.443C217.323 389.359 217.312 389.276 217.312 389.193C217.312 389.156 217.313 389.125 217.318 389.094L217.599 388.818C217.609 388.818 217.62 388.813 217.63 388.813C217.672 388.807 217.714 388.807 217.755 388.807C217.807 388.807 217.865 388.807 217.917 388.807C217.974 388.807 218.021 388.807 218.068 388.802C218.115 388.797 218.156 388.781 218.188 388.766C218.188 388.76 218.177 388.75 218.172 388.74C218.151 388.714 218.12 388.677 218.083 388.641C218.036 388.594 217.979 388.547 217.922 388.495L218.073 388.349C218.109 388.385 218.146 388.417 218.182 388.448C218.24 388.5 218.292 388.552 218.333 388.609C218.359 388.641 218.38 388.672 218.391 388.714C218.401 388.729 218.401 388.755 218.401 388.776C218.406 388.813 218.391 388.854 218.37 388.885C218.344 388.917 218.318 388.938 218.281 388.953C218.224 388.979 218.161 388.995 218.099 389.005C218.036 389.016 217.974 389.016 217.917 389.016C217.859 389.016 217.807 389.016 217.755 389.016C217.714 389.016 217.677 389.016 217.646 389.021C217.609 389.026 217.589 389.031 217.573 389.036C217.562 389.042 217.557 389.047 217.552 389.052C217.542 389.063 217.536 389.073 217.531 389.089C217.526 389.115 217.521 389.151 217.521 389.193C217.521 389.266 217.531 389.354 217.552 389.443C217.573 389.531 217.604 389.615 217.635 389.682C217.656 389.724 217.677 389.76 217.693 389.781C217.698 389.786 217.698 389.786 217.698 389.792C217.703 389.786 217.708 389.786 217.714 389.786C217.75 389.786 217.786 389.807 217.807 389.844C217.833 389.896 217.813 389.958 217.76 389.984C217.74 389.995 217.714 390 217.693 390ZM219.078 387.802C219.026 387.802 218.979 387.76 218.974 387.708C218.974 387.708 218.974 387.708 218.974 387.703C218.974 387.703 218.974 387.698 218.969 387.693C218.969 387.677 218.969 387.656 218.964 387.635C218.958 387.599 218.953 387.552 218.943 387.5L219.125 387.318C219.161 387.526 219.182 387.682 219.182 387.688C219.187 387.74 219.151 387.792 219.089 387.802C219.089 387.802 219.083 387.802 219.078 387.802Z",
    fill: "#9B6E6A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M218.63 388.208C218.625 388.208 218.625 388.208 218.62 388.208C218.562 388.203 218.521 388.156 218.521 388.099V388.094C218.521 388.094 218.526 388.094 218.526 388.089C218.526 388.083 218.526 388.073 218.526 388.063C218.526 388.042 218.526 388.005 218.526 387.964C218.526 387.948 218.526 387.927 218.526 387.906L218.729 387.708C218.734 387.807 218.74 387.896 218.74 387.964C218.74 388.052 218.734 388.109 218.734 388.115C218.729 388.167 218.682 388.208 218.63 388.208Z",
    fill: "#9B6E6A"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M210.536 398.599C210.505 398.599 210.474 398.599 210.437 398.599C210.406 398.599 210.375 398.599 210.344 398.599C209.964 398.599 209.74 398.531 209.74 398.531C209.219 398.479 208.703 398.297 208.208 398.031L214.062 392.286C213.885 392.667 213.776 393.172 213.776 393.729C213.776 394.911 214.271 395.875 214.875 395.875L215.135 395.906C214.964 396.115 214.781 396.313 214.594 396.51C213.583 397.557 212.391 398.406 211.135 398.531C211.135 398.531 210.917 398.599 210.536 398.599ZM215.344 391.646L214.875 391.583C214.839 391.583 214.802 391.589 214.766 391.594L215.542 390.833C215.703 390.865 215.859 390.896 216.01 390.917C216.016 390.917 216.026 390.922 216.031 390.922C215.771 391.042 215.531 391.297 215.344 391.646Z",
    fill: "#4A4E63"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M215.354 395.938L215.135 395.906L214.875 395.875C214.271 395.875 213.776 394.911 213.776 393.729C213.776 393.172 213.885 392.667 214.063 392.286L214.766 391.594C214.802 391.589 214.839 391.583 214.875 391.583L215.344 391.646C215.052 392.182 214.875 392.938 214.875 393.781C214.875 394.63 215.057 395.401 215.354 395.938Z",
    fill: "#6C738B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M215.682 396.38C215.562 396.26 215.453 396.109 215.354 395.938C215.057 395.401 214.875 394.63 214.875 393.781C214.875 392.937 215.052 392.182 215.344 391.646C215.531 391.297 215.771 391.042 216.031 390.922C216.141 390.87 216.255 390.844 216.375 390.844L216.917 390.896L217.385 390.938L218.656 391.047C217.828 391.047 217.156 392.359 217.156 393.979C217.156 394.286 217.182 394.589 217.224 394.865L215.682 396.38Z",
    fill: "#5C6278"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M217.224 394.865C217.182 394.589 217.156 394.286 217.156 393.979C217.156 392.359 217.828 391.047 218.656 391.047C219.156 391.047 219.604 391.526 219.875 392.266L217.224 394.865Z",
    fill: "#767F94"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M204.151 407.698C203.349 406.385 202.604 405.068 202.057 404.063L206.302 399.901C207.203 400.161 208.167 400.302 209.12 400.37C209.563 400.396 210.005 400.411 210.443 400.411C210.839 400.411 211.229 400.401 211.604 400.38L204.151 407.698Z",
    fill: "#4A4E63"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M204.078 407.766C203.292 406.443 202.568 405.104 202.036 404.089L202.057 404.062C202.604 405.068 203.349 406.385 204.151 407.698L204.078 407.766Z",
    fill: "#4A4E63"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M200.083 393.635C199.943 392.349 199.818 390.995 199.708 389.641L201.635 387.75C201.687 388.141 201.781 388.542 201.906 388.917C202.312 390.109 202.854 390.474 203.198 390.573L202.76 391.005L202.266 391.047C201.641 391.047 201.109 391.792 200.88 392.849L200.083 393.635Z",
    fill: "#A1815B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M203.198 390.573C202.854 390.474 202.313 390.109 201.906 388.917C201.781 388.542 201.688 388.141 201.635 387.75L201.807 387.583C201.797 387.646 201.792 387.682 201.792 387.688C201.786 387.74 201.828 387.792 201.885 387.802C201.891 387.802 201.891 387.802 201.896 387.802C201.948 387.802 201.995 387.76 202 387.708C202.005 387.682 202.026 387.526 202.063 387.333L202.635 386.766C202.641 386.771 202.641 386.776 202.641 386.781C202.568 386.833 202.505 386.906 202.458 386.984C202.359 387.141 202.302 387.328 202.276 387.505C202.245 387.682 202.24 387.849 202.24 387.964C202.24 388.052 202.24 388.109 202.24 388.115C202.245 388.167 202.292 388.208 202.349 388.208H202.354C202.411 388.203 202.458 388.156 202.453 388.099C202.453 388.094 202.448 388.042 202.448 387.964C202.448 387.823 202.458 387.594 202.516 387.38C202.547 387.276 202.583 387.172 202.635 387.089C202.667 387.042 202.703 387 202.74 386.969C202.849 387.177 202.948 387.417 203.026 387.62C203.068 387.734 203.099 387.839 203.125 387.917C203.135 387.958 203.146 387.995 203.151 388.026C203.156 388.052 203.156 388.078 203.156 388.083V388.089C203.156 388.089 203.151 388.104 203.135 388.125C203.115 388.156 203.068 388.203 203.01 388.255C202.927 388.333 202.823 388.417 202.74 388.495C202.698 388.536 202.661 388.578 202.63 388.625C202.615 388.646 202.599 388.667 202.589 388.693C202.578 388.719 202.573 388.745 202.573 388.776C202.573 388.813 202.583 388.854 202.604 388.885C202.63 388.917 202.656 388.938 202.693 388.953C202.75 388.979 202.813 388.995 202.875 389.005C202.938 389.016 203 389.016 203.057 389.016C203.115 389.016 203.167 389.016 203.219 389.016C203.255 389.016 203.292 389.016 203.323 389.021C203.344 389.021 203.359 389.026 203.375 389.026C203.401 389.036 203.411 389.042 203.422 389.052C203.432 389.057 203.438 389.068 203.443 389.094C203.448 389.115 203.453 389.151 203.453 389.193C203.453 389.255 203.443 389.328 203.427 389.401C203.406 389.516 203.37 389.625 203.328 389.703C203.307 389.745 203.292 389.771 203.276 389.786C203.276 389.786 203.276 389.786 203.276 389.792C203.271 389.786 203.266 389.786 203.26 389.786C203.224 389.786 203.188 389.807 203.167 389.844C203.141 389.896 203.161 389.958 203.214 389.984C203.234 389.995 203.26 390 203.286 390C203.307 390 203.328 389.995 203.349 389.99C203.38 389.974 203.406 389.953 203.427 389.932C203.464 389.891 203.495 389.844 203.521 389.786C203.563 389.703 203.599 389.604 203.625 389.5C203.646 389.401 203.667 389.292 203.667 389.193C203.667 389.141 203.661 389.089 203.646 389.042C203.635 388.99 203.609 388.948 203.578 388.911C203.552 388.885 203.526 388.87 203.495 388.854C203.453 388.833 203.406 388.823 203.359 388.813C203.313 388.807 203.266 388.807 203.219 388.807C203.167 388.807 203.109 388.807 203.057 388.807C203.005 388.807 202.953 388.807 202.906 388.802C202.859 388.797 202.818 388.781 202.786 388.766C202.792 388.755 202.802 388.74 202.818 388.719C202.849 388.682 202.891 388.635 202.948 388.589C203.026 388.516 203.12 388.443 203.198 388.365C203.234 388.328 203.271 388.292 203.302 388.25C203.318 388.234 203.328 388.214 203.344 388.193C203.354 388.167 203.365 388.146 203.365 388.12C203.37 388.104 203.37 388.094 203.37 388.083C203.37 388.057 203.365 388.031 203.359 388.005C203.349 387.948 203.333 387.885 203.313 387.807C203.229 387.547 203.078 387.161 202.911 386.839C202.87 386.76 202.833 386.688 202.792 386.615L203.297 386.12C203.333 386.281 203.365 386.422 203.391 386.531C203.573 387.573 203.792 388.75 204.021 389.771L203.198 390.573ZM204.734 389.068C204.448 388.005 204.12 386.74 203.844 385.583L206.563 382.911C207.802 382.536 209.266 382.203 210.813 382.177C211.115 382.182 211.411 382.198 211.708 382.224L207.667 386.188C207.385 386.052 207.125 386 206.891 386C206.078 386 205.594 386.625 205.594 386.625C205.818 386.51 206.016 386.438 206.198 386.385C206.198 386.568 206.24 387.026 206.75 387.026C206.776 387.026 206.797 387.026 206.818 387.026L204.734 389.068ZM206.719 384.036C206.479 384.036 206.271 384.052 206.146 384.073C205.625 384.177 205.047 384.807 205.047 384.807C205.047 384.807 205.854 384.625 206.146 384.578C206.161 384.573 206.182 384.573 206.208 384.573C206.365 384.573 206.646 384.63 206.938 384.688C207.234 384.75 207.547 384.807 207.771 384.807C207.844 384.807 207.911 384.802 207.958 384.786C208.344 384.672 208.38 384.365 208.38 384.365C208.5 384.156 207.458 384.036 206.719 384.036Z",
    fill: "#B78C8C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M203.391 386.531C203.365 386.422 203.333 386.281 203.297 386.12L203.313 386.104C203.339 386.245 203.365 386.385 203.391 386.531Z",
    fill: "#494769"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M204.021 389.771C203.792 388.75 203.573 387.573 203.391 386.531C203.365 386.385 203.339 386.245 203.312 386.104L203.844 385.583C204.12 386.74 204.448 388.005 204.734 389.068L204.021 389.771Z",
    fill: "#4A4E63"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M205.047 384.807C205.047 384.807 205.625 384.177 206.146 384.073C206.271 384.052 206.479 384.036 206.719 384.036C207.458 384.036 208.5 384.156 208.38 384.365C208.38 384.365 208.344 384.672 207.958 384.786C207.911 384.802 207.844 384.807 207.771 384.807C207.547 384.807 207.234 384.75 206.938 384.688C206.646 384.63 206.365 384.573 206.208 384.573C206.182 384.573 206.161 384.573 206.146 384.578C205.854 384.625 205.047 384.807 205.047 384.807Z",
    fill: "#494769"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M205.594 386.625C205.594 386.625 206.078 386 206.891 386C207.125 386 207.385 386.052 207.667 386.188L207.427 386.427C207.432 386.359 207.432 386.313 207.432 386.313C207.333 386.255 207.167 386.234 206.984 386.234C206.62 386.234 206.203 386.313 206.203 386.313C206.203 386.313 206.203 386.344 206.198 386.385C206.016 386.438 205.818 386.51 205.594 386.625Z",
    fill: "#494769"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M206.75 387.026C206.24 387.026 206.198 386.568 206.198 386.385C206.203 386.344 206.203 386.313 206.203 386.313C206.203 386.313 206.62 386.234 206.984 386.234C207.167 386.234 207.333 386.255 207.432 386.313C207.432 386.313 207.432 386.359 207.427 386.427L206.818 387.026C206.797 387.026 206.776 387.026 206.75 387.026Z",
    fill: "#494769"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M203.286 390C203.26 390 203.234 389.995 203.214 389.984C203.161 389.958 203.141 389.896 203.167 389.844C203.187 389.807 203.224 389.786 203.26 389.786C203.266 389.786 203.271 389.786 203.276 389.792C203.276 389.786 203.276 389.786 203.276 389.786C203.292 389.771 203.307 389.745 203.328 389.703C203.37 389.625 203.406 389.516 203.427 389.401C203.443 389.328 203.453 389.255 203.453 389.193C203.453 389.151 203.448 389.115 203.443 389.094C203.437 389.068 203.432 389.057 203.422 389.052C203.411 389.042 203.401 389.036 203.375 389.026C203.359 389.026 203.344 389.021 203.323 389.021C203.292 389.016 203.255 389.016 203.219 389.016C203.167 389.016 203.115 389.016 203.057 389.016C203 389.016 202.937 389.016 202.875 389.005C202.812 388.995 202.75 388.979 202.693 388.953C202.656 388.938 202.63 388.917 202.604 388.885C202.583 388.854 202.573 388.813 202.573 388.776C202.573 388.745 202.578 388.719 202.589 388.693C202.599 388.667 202.615 388.646 202.63 388.625C202.661 388.578 202.698 388.536 202.74 388.495C202.823 388.417 202.927 388.333 203.01 388.255C203.068 388.203 203.115 388.156 203.135 388.125C203.151 388.104 203.156 388.089 203.156 388.089V388.083C203.156 388.078 203.156 388.052 203.151 388.026C203.146 387.995 203.135 387.958 203.125 387.917C203.099 387.839 203.068 387.734 203.026 387.62C202.948 387.417 202.849 387.177 202.74 386.969C202.771 386.943 202.797 386.922 202.828 386.906C202.88 386.88 202.901 386.818 202.875 386.771C202.859 386.734 202.818 386.714 202.781 386.714C202.766 386.714 202.75 386.714 202.734 386.724C202.703 386.74 202.672 386.76 202.641 386.781C202.641 386.776 202.641 386.771 202.635 386.766L202.792 386.615C202.833 386.688 202.87 386.76 202.911 386.839C203.078 387.161 203.229 387.547 203.312 387.807C203.333 387.885 203.349 387.948 203.359 388.005C203.365 388.031 203.37 388.057 203.37 388.083C203.37 388.094 203.37 388.104 203.365 388.12C203.365 388.146 203.354 388.167 203.344 388.193C203.328 388.214 203.318 388.234 203.302 388.25C203.271 388.292 203.234 388.328 203.198 388.365C203.12 388.443 203.026 388.516 202.948 388.589C202.891 388.635 202.849 388.682 202.818 388.719C202.802 388.74 202.792 388.755 202.786 388.766C202.818 388.781 202.859 388.797 202.906 388.802C202.953 388.807 203.005 388.807 203.057 388.807C203.109 388.807 203.167 388.807 203.219 388.807C203.266 388.807 203.312 388.807 203.359 388.813C203.406 388.823 203.453 388.833 203.495 388.854C203.526 388.87 203.552 388.885 203.578 388.911C203.609 388.948 203.635 388.99 203.646 389.042C203.661 389.089 203.667 389.141 203.667 389.193C203.667 389.292 203.646 389.401 203.625 389.5C203.599 389.604 203.562 389.703 203.521 389.786C203.495 389.844 203.464 389.891 203.427 389.932C203.406 389.953 203.38 389.974 203.349 389.99C203.328 389.995 203.307 390 203.286 390ZM201.896 387.802C201.891 387.802 201.891 387.802 201.885 387.802C201.828 387.792 201.786 387.74 201.792 387.688C201.792 387.682 201.797 387.646 201.807 387.583L202.062 387.333C202.026 387.526 202.005 387.682 202 387.708C201.995 387.76 201.948 387.802 201.896 387.802Z",
    fill: "#9B6E6A"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M202.349 388.208C202.292 388.208 202.245 388.167 202.24 388.115C202.24 388.109 202.24 388.052 202.24 387.964C202.24 387.849 202.245 387.682 202.276 387.505C202.302 387.328 202.359 387.141 202.458 386.984C202.505 386.906 202.568 386.833 202.641 386.781C202.672 386.76 202.703 386.74 202.734 386.724C202.75 386.714 202.766 386.714 202.781 386.714C202.818 386.714 202.859 386.734 202.875 386.771C202.901 386.818 202.88 386.88 202.828 386.906C202.797 386.922 202.771 386.943 202.74 386.969C202.703 387 202.667 387.042 202.635 387.089C202.583 387.172 202.547 387.276 202.516 387.38C202.458 387.594 202.448 387.823 202.448 387.964C202.448 388.042 202.453 388.094 202.453 388.099C202.458 388.156 202.411 388.203 202.354 388.208H202.349Z",
    fill: "#9B6E6A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M215.51 375.219H214.781C214.906 375.214 215.031 375.214 215.156 375.214C215.276 375.214 215.396 375.214 215.51 375.219Z",
    fill: "#A1815B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M206.562 382.911L214.396 375.229C214.526 375.224 214.651 375.219 214.781 375.219H215.51C216.271 375.234 217.021 375.313 217.724 375.5C217.953 375.563 218.167 375.625 218.365 375.693L211.708 382.224C211.411 382.198 211.115 382.182 210.813 382.177C209.266 382.203 207.802 382.536 206.562 382.911Z",
    fill: "#B8B6C0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M202.63 391.135C202.51 391.078 202.391 391.047 202.266 391.047L202.76 391.005L202.63 391.135Z",
    fill: "#5C6278"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M200.88 392.849C201.109 391.792 201.641 391.047 202.266 391.047C202.391 391.047 202.51 391.078 202.63 391.135L200.88 392.849Z",
    fill: "#767F94"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M216.943 400.26C216.51 399.99 216.167 399.797 216.042 399.797C216.036 399.797 216.031 399.802 216.026 399.802C215.953 399.813 215.672 399.875 215.24 399.953C215.172 399.677 215.109 399.391 215.047 399.089L217.38 396.802L218.521 396.901C218.563 396.911 218.609 396.911 218.656 396.911C219.469 396.911 220.13 395.651 220.156 394.078L220.641 393.599C220.526 394.797 220.406 395.938 220.292 396.974L216.943 400.26Z",
    fill: "#A1815B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M213.958 400.156L215.047 399.089C215.109 399.391 215.172 399.677 215.24 399.953C214.896 400.016 214.464 400.089 213.958 400.156Z",
    fill: "#B27E87"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M218.521 396.901L217.38 396.802L217.802 396.385C218.005 396.672 218.255 396.854 218.521 396.901Z",
    fill: "#5C6278"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M218.656 396.911C218.609 396.911 218.562 396.911 218.521 396.901C218.255 396.854 218.005 396.672 217.802 396.385L220.156 394.078C220.13 395.651 219.469 396.911 218.656 396.911Z",
    fill: "#767F94"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M206.208 410.792C205.802 410.245 205.375 409.63 204.958 408.984L213.958 400.156C214.464 400.089 214.896 400.016 215.24 399.953C215.672 399.875 215.953 399.813 216.026 399.802C216.031 399.802 216.036 399.797 216.042 399.797C216.167 399.797 216.51 399.99 216.943 400.26L206.208 410.792Z",
    fill: "#4A4E63"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M206.12 410.88C205.714 410.339 205.292 409.719 204.88 409.068L204.958 408.984C205.375 409.63 205.802 410.245 206.208 410.792L206.12 410.88Z",
    fill: "#4A4E63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 412,
    width: 6,
    height: 4
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "c1e409a964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M196 412H201.333V415.823H196V412Z",
    fill: "white"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M200.427 415.823C200.641 415.495 200.766 415.109 200.766 414.693C200.766 413.516 199.797 412.562 198.599 412.562C197.401 412.562 196.432 413.516 196.432 414.693C196.432 415.109 196.557 415.495 196.771 415.823H200.427Z",
    fill: "#212B3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M197.672 415.823H199.526C199.865 415.552 200.083 415.151 200.083 414.693C200.083 413.885 199.417 413.234 198.599 413.234C197.776 413.234 197.115 413.885 197.115 414.693C197.115 415.151 197.333 415.552 197.672 415.823Z",
    fill: "#35435C"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_41"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 402,
    width: 6,
    height: 14
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "783289fc26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M194.667 402.667H200V415.823H194.667V402.667Z",
    fill: "white"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M199.328 414.307L196.432 403.844C196.432 403.844 196.214 403.115 195.396 403.313C195.109 403.385 194.573 403.62 194.776 404.318L197.75 415.193C197.75 415.193 198.01 415.807 198.807 415.547C199.094 415.453 199.594 414.953 199.328 414.307Z",
    fill: "#4E5F7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M199.328 414.307L199.323 414.281C198.953 414.938 198.229 414.505 198.229 414.505L195.13 403.411C194.875 403.542 194.63 403.807 194.776 404.318L197.75 415.193C197.75 415.193 198.01 415.807 198.807 415.547C199.094 415.453 199.594 414.953 199.328 414.307Z",
    fill: "#3E4F6A"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "worker8"
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.156 337.063C114.766 347.167 120.552 361.823 116.193 365.109C105.693 373.031 107.766 384.026 112.042 389.01C116.542 394.25 136.172 393.125 139.766 379.484C140.807 375.531 143.917 370.896 147.125 368.438C153.578 363.479 170.172 361.448 174.099 353.339C176.625 348.115 176.333 340.63 163.01 339.094C152.776 337.922 148.156 340.859 141.141 336.849C136.354 334.109 141.729 323.25 128.917 324.427C122.583 325 118.734 330.438 117.156 337.063Z",
    fill: "#93C6B6"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M149.432 363.172C152.885 358.552 146.943 340.943 146.943 340.943L123.776 340.135C123.776 340.135 117.844 358.635 121.443 363.172C125.755 368.615 145.307 368.693 149.432 363.172Z",
    fill: "#361F16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 361,
    width: 44,
    height: 17
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "4d6625deb6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M113.516 361.333H156.516V377.76H113.516V361.333Z",
    fill: "white"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M142.698 362.219H127.328C119.302 365.01 113.594 371.792 113.547 377.755H156.479C156.432 371.792 150.724 365.01 142.698 362.219Z",
    fill: "#2F3031"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_43"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 361,
    width: 23,
    height: 17
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "84ad09e390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M134.667 361.333H156.516V377.76H134.667V361.333Z",
    fill: "white"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M142.698 362.219H134.896V377.755H156.479C156.432 371.792 150.724 365.01 142.698 362.219Z",
    fill: "#2F3031"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 361,
    width: 17,
    height: 17
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "cde3de8e94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M126.667 361.333H142.667V377.76H126.667V361.333Z",
    fill: "white"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M135.062 363.661L127.698 361.891L133.125 377.75H136.807L142.234 361.891L135.062 363.661Z",
    fill: "#F8EEF1"
  }))))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M128.547 355.802V362.646C128.578 362.667 128.599 362.682 128.599 362.682C130.25 363.859 131.844 365.031 133.385 366.208C133.453 366.266 133.521 366.318 133.594 366.365C133.964 366.62 134.38 366.766 134.823 366.766C135.266 366.766 135.687 366.62 136.057 366.365C136.125 366.318 136.193 366.266 136.26 366.208C137.776 365.057 139.339 363.901 140.953 362.75V355.802H128.547Z",
    fill: "#D8B884"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 361,
    width: 12,
    height: 17
  }, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "6c726df03b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M122.667 361.333H133.333V377.76H122.667V361.333Z",
    fill: "white"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M123.104 363.995L127.995 369.823L126.328 371.464L130.927 377.755H133.089L127.661 361.906C126.042 362.453 124.516 363.161 123.104 363.995Z",
    fill: "#171717"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 361,
    width: 12,
    height: 17
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "6d933474f1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M136 361.333H148V377.76H136V361.333Z",
    fill: "white"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M146.766 363.995L141.875 369.823L143.536 371.464L138.938 377.755H136.781L142.203 361.906C143.823 362.453 145.354 363.161 146.766 363.995Z",
    fill: "#171717"
  }))))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M135.453 369.318C135.453 369.557 135.255 369.755 135.016 369.755C134.771 369.755 134.578 369.557 134.578 369.318C134.578 369.078 134.771 368.88 135.016 368.88C135.255 368.88 135.453 369.078 135.453 369.318Z",
    fill: "#440E13"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M135.453 371.026C135.453 371.266 135.255 371.464 135.016 371.464C134.771 371.464 134.578 371.266 134.578 371.026C134.578 370.786 134.771 370.589 135.016 370.589C135.255 370.589 135.453 370.786 135.453 371.026Z",
    fill: "#440E13"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M135.453 372.734C135.453 372.974 135.255 373.172 135.016 373.172C134.771 373.172 134.578 372.974 134.578 372.734C134.578 372.495 134.771 372.297 135.016 372.297C135.255 372.297 135.453 372.495 135.453 372.734Z",
    fill: "#440E13"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M135.453 374.443C135.453 374.682 135.255 374.88 135.016 374.88C134.771 374.88 134.578 374.682 134.578 374.443C134.578 374.203 134.771 374.005 135.016 374.005C135.255 374.005 135.453 374.203 135.453 374.443Z",
    fill: "#440E13"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M135.453 376.151C135.453 376.391 135.255 376.589 135.016 376.589C134.771 376.589 134.578 376.391 134.578 376.151C134.578 375.911 134.771 375.714 135.016 375.714C135.255 375.714 135.453 375.911 135.453 376.151Z",
    fill: "#D1CDCA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M135.453 376.151C135.453 376.391 135.255 376.589 135.016 376.589C134.771 376.589 134.578 376.391 134.578 376.151C134.578 375.911 134.771 375.714 135.016 375.714C135.255 375.714 135.453 375.911 135.453 376.151Z",
    fill: "#440E13"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M144.417 336.464C138.333 336.464 132.25 336.464 126.172 336.464C125.38 336.464 124.792 337.068 124.859 337.818C125.328 343.26 125.875 349.635 126.344 355.078C126.349 355.115 126.354 355.146 126.359 355.182C126.802 358.802 130.625 361.635 135.271 361.635C140.005 361.635 143.927 358.698 144.25 354.974C144.25 354.948 144.255 354.922 144.26 354.891C144.693 349.87 145.297 342.839 145.729 337.818C145.797 337.068 145.208 336.464 144.417 336.464Z",
    fill: "#F7CF91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_47"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 328,
    width: 29,
    height: 36
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "7e7b530e05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M121.333 328.76H149.333V364H121.333V328.76Z",
    fill: "white"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M135.333 328.76C129.271 328.76 124.167 332.333 122.635 337.193C122.333 338.167 122.052 361.911 122.052 362.964C122.052 365.438 123.583 345.036 125.109 346.911C123.568 341.208 133.875 339.932 135.365 336.677C135.365 336.677 132.052 343.193 146.625 343.729C146.641 343.729 146.656 343.729 146.672 343.724C146.208 345.693 148.422 361.073 148.677 362.964C148.677 362.964 148.49 342.547 148.49 340.24C148.49 333.901 142.599 328.76 135.333 328.76Z",
    fill: "#361F16"
  }))))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M147.729 345.823C147.729 345.885 147.729 345.948 147.729 346.01H148.99C148.99 345.948 148.995 345.885 148.995 345.823C148.995 337.484 142.828 330.719 135.219 330.719C127.609 330.719 121.443 337.484 121.443 345.823C121.443 346.083 121.448 346.339 121.458 346.594H122.724C122.714 346.339 122.708 346.083 122.708 345.823C122.708 338.245 128.307 332.104 135.219 332.104C142.13 332.104 147.729 338.245 147.729 345.823Z",
    fill: "#56BAAF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M147.339 350.682C146.823 356.448 142.484 360.979 137.135 361.193V362.375C143.078 362.156 147.896 357.099 148.417 350.682H147.339Z",
    fill: "#56BAAF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M146.484 343.208L145.87 353.495C148.349 353.51 150.443 351.417 150.609 348.667C150.771 345.922 148.948 343.542 146.484 343.208Z",
    fill: "#359490"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M146.203 353.094C146.172 353.615 145.766 354.01 145.286 353.974C144.813 353.943 144.453 353.49 144.484 352.969L145.047 343.526C145.078 343.005 145.49 342.609 145.964 342.646C146.443 342.682 146.802 343.13 146.771 343.651L146.203 353.094Z",
    fill: "#93DACE"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M124.099 343.208L124.714 353.495C122.234 353.51 120.141 351.417 119.979 348.667C119.812 345.922 121.641 343.542 124.099 343.208Z",
    fill: "#359490"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M124.38 353.094C124.411 353.615 124.823 354.01 125.302 353.974C125.776 353.943 126.135 353.49 126.104 352.969L125.542 343.526C125.51 343.005 125.099 342.609 124.625 342.646C124.146 342.682 123.786 343.13 123.818 343.651L124.38 353.094Z",
    fill: "#93DACE"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M139.187 361.615C139.187 362.161 138.755 362.604 138.219 362.604H135.786C135.25 362.604 134.818 362.161 134.818 361.615C134.818 361.073 135.25 360.625 135.786 360.625H138.219C138.755 360.625 139.187 361.073 139.187 361.615Z",
    fill: "#93DACE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker7"
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M418.01 164.755C413.427 166.854 408.042 166.031 403.12 165.922C398.193 165.807 391.219 166.203 389.823 172.266C389.292 174.589 389.901 177.188 391.417 179.031C393.01 180.979 395.583 182.234 396.24 184.682C396.76 186.62 395.849 188.635 394.688 190.193C392.818 192.688 390.276 194.552 388.339 196.995C386.401 199.432 385.094 202.854 386.286 205.844C387.484 208.854 390.708 210.349 393.688 211.297C399.99 213.297 407.094 214.12 412.781 210.896C416.151 208.984 418.823 205.766 422.49 204.563C427.234 203.005 432.438 205.172 437.422 204.771C443.359 204.286 448.719 199.781 450.411 193.849C452.099 187.917 450.021 180.922 445.37 176.896C443.193 175.01 440.563 173.766 438.458 171.792C436.802 170.245 435.516 168.266 434.745 166.099C433.932 163.807 433.563 161.099 431.677 159.63C429.745 158.125 426.995 158.63 424.953 159.854C422.911 161.073 421.26 162.906 419.219 164.12C418.823 164.359 418.422 164.568 418.01 164.755Z",
    fill: "#F97575"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 201,
    width: 7,
    height: 7
  }, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "ea38be266e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M401.401 201.333H408V207.125H401.401V201.333Z",
    fill: "white"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M406.927 207.12H402.646V202.224H406.927V207.12Z",
    fill: "#E99567"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_49"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 201,
    width: 6,
    height: 7
  }, _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "0776c3d186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M429.333 201.333H434.667V207.125H429.333V201.333Z",
    fill: "white"
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M433.979 207.12H429.698V202.224H433.979V207.12Z",
    fill: "#E99567"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_50"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 428,
    y: 184,
    width: 8,
    height: 22
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "99938956b3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M428 184H435.401V205.333H428V184Z",
    fill: "white"
  })))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M431.214 184.396C431.214 184.396 434.151 185.302 434.578 187.625C434.578 187.625 435.349 201.276 435.26 203.167C435.26 203.167 431.464 205.484 428.911 203.682C428.911 203.682 429.479 187.099 431.214 184.396Z",
    fill: "#A6BEC0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_51"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 184,
    width: 7,
    height: 22
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "a82578dbf2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M401.401 184H408V205.333H401.401V184Z",
    fill: "white"
  })))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M405.573 184.396C405.573 184.396 402.635 185.302 402.208 187.625C402.208 187.625 401.437 201.276 401.526 203.167C401.526 203.167 405.323 205.484 407.875 203.682C407.875 203.682 407.307 187.099 405.573 184.396Z",
    fill: "#A6BEC0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_52"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 404,
    y: 181,
    width: 28,
    height: 27
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "ddb7399231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M404 181.333H432V207.125H404V181.333Z",
    fill: "white"
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M431.911 185.589C431.911 185.589 431.589 184.401 430.901 184.24C430.901 184.24 423.87 181.411 418.312 181.411C412.75 181.411 405.724 184.24 405.724 184.24C405.036 184.401 404.714 185.589 404.714 185.589C404.714 185.589 406.245 198.464 407.573 202.031C407.573 202.031 407.984 205.458 407.812 207.12H428.812C428.641 205.458 429.052 202.031 429.052 202.031C430.375 198.464 431.911 185.589 431.911 185.589Z",
    fill: "#C3DBDD"
  }))))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M413.604 175.635C413.604 175.635 414.818 179.927 413.687 182.359C413.687 182.359 417.729 185.625 422.906 182.708C422.906 182.708 421.88 178.266 422.786 175.635H413.604Z",
    fill: "#D38256"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M411.823 170.948C411.823 170.948 411.208 169.495 410.464 170.781C410.464 170.781 409.771 172.214 411.141 173.333C411.141 173.333 411.719 173.932 411.823 174.115C411.823 174.115 412.479 174.776 412.786 174.115L411.823 170.948Z",
    fill: "#D38256"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M425.104 170.948C425.104 170.948 425.719 169.495 426.464 170.781C426.464 170.781 427.151 172.214 425.786 173.333C425.786 173.333 425.208 173.932 425.104 174.115C425.104 174.115 424.448 174.776 424.135 174.115L425.104 170.948Z",
    fill: "#F5C085"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M425.104 170.948C425.104 170.948 425.719 169.495 426.464 170.781C426.464 170.781 427.151 172.214 425.786 173.333C425.786 173.333 425.208 173.932 425.104 174.115C425.104 174.115 424.448 174.776 424.135 174.115L425.104 170.948Z",
    fill: "#D38256"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M425.214 171.068C425.214 165.625 422.229 161.885 418.526 161.828C418.51 161.828 418.495 161.828 418.49 161.828C418.479 161.828 418.464 161.828 418.448 161.828C414.745 161.885 411.766 165.625 411.766 171.068C411.766 171.068 413.286 180.182 418.448 180.302C418.464 180.302 418.479 180.302 418.49 180.302C418.495 180.302 418.51 180.302 418.526 180.302C423.693 180.182 425.214 171.068 425.214 171.068Z",
    fill: "#E99567"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M411.766 170.839C411.766 170.839 411.974 172.099 412.104 172.573C412.104 172.573 412.828 171.651 412.786 170.839C412.786 170.839 413.391 165.812 414.589 165.078C414.589 165.078 418.255 167.484 422.63 165.297C422.63 165.297 423.318 165.812 423.318 166.323C423.318 166.839 424.297 171.448 424.854 171.76L425.385 170.5C425.385 170.5 425.911 166.156 425.385 164.609C425.385 164.609 426.359 160.958 424.646 159.672C423.453 158.771 415.979 158.125 411.536 163.104C411.536 163.104 409.615 164.583 411.766 170.839Z",
    fill: "#412B1F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M424.833 182.333C424.792 182.01 422.875 179.859 422.51 179.776C422.51 179.776 419.615 183.146 418.297 183.891C416.979 183.146 414.089 179.776 414.089 179.776C413.724 179.859 411.802 182.01 411.766 182.333C411.729 182.656 412.714 186.594 412.755 186.906C412.797 187.224 413.073 187.078 413.073 187.078C414.479 186.135 417.51 184.76 417.927 184.563C418.156 184.453 418.255 184.271 418.297 184.125C418.344 184.271 418.443 184.453 418.667 184.563C419.083 184.76 422.12 186.135 423.526 187.078C423.526 187.078 423.802 187.224 423.844 186.906C423.885 186.594 424.87 182.656 424.833 182.333Z",
    fill: "#E6E7E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_53"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 405,
    y: 182,
    width: 26,
    height: 26
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "ca6f76ae8b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M405.333 182.667H430.667V207.125H405.333V182.667Z",
    fill: "white"
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M430.495 195.526C429.813 194.88 428.172 193.349 427.219 192.646C427.219 192.646 428.26 184.917 427.698 183.115C427.276 182.984 426.828 182.849 426.354 182.714C426.354 182.719 425.479 191.547 424.938 192.464C424.938 192.464 420.224 192.906 418.313 192.734C416.396 192.906 411.688 192.464 411.688 192.464C411.141 191.547 410.271 182.719 410.271 182.714C409.797 182.849 409.349 182.984 408.927 183.115C408.365 184.917 409.406 192.646 409.406 192.646C408.453 193.349 406.813 194.88 406.13 195.526C406.578 198.214 407.078 200.74 407.552 202.031C407.552 202.031 407.958 205.458 407.786 207.12H428.833C428.667 205.458 429.073 202.031 429.073 202.031C429.547 200.74 430.047 198.214 430.495 195.526Z",
    fill: "#B31D2F"
  }))))), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M411.458 193.292C411.458 193.688 411.141 194.005 410.745 194.005C410.354 194.005 410.031 193.688 410.031 193.292C410.031 192.896 410.354 192.578 410.745 192.578C411.141 192.578 411.458 192.896 411.458 193.292Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M426.641 193.292C426.641 193.688 426.323 194.005 425.927 194.005C425.531 194.005 425.214 193.688 425.214 193.292C425.214 192.896 425.531 192.578 425.927 192.578C426.323 192.578 426.641 192.896 426.641 193.292Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M427.036 199.286C427.036 199.516 426.849 199.703 426.62 199.703H421.438C421.208 199.703 421.016 199.516 421.016 199.286V196.755C421.016 196.521 421.208 196.333 421.438 196.333H426.62C426.849 196.333 427.036 196.521 427.036 196.755V199.286Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M424.625 196.901H423.432V194.917H424.625V196.901Z",
    fill: "#284469"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M424.229 196.557C424.229 196.672 424.141 196.76 424.026 196.76C423.917 196.76 423.828 196.672 423.828 196.557C423.828 196.448 423.917 196.359 424.026 196.359C424.141 196.359 424.229 196.448 424.229 196.557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_54"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 336,
    y: 357,
    width: 68,
    height: 59
  }, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "1a67122b95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M336.333 357.333H404V416H336.333V357.333Z",
    fill: "white"
  })))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M345.474 369.396C343.453 369.391 341.302 369.229 339.563 370.339C336.943 372.005 336.339 376 337.26 379.141C338.177 382.281 340.234 384.849 342 387.536C343.76 390.219 345.318 393.365 344.99 396.641C344.776 398.786 343.766 400.781 343.688 402.937C343.578 405.891 345.276 408.651 347.474 410.406C349.672 412.161 352.318 413.089 354.917 413.99C358.469 415.219 362.229 416.464 365.859 415.562C372.073 414.026 375.953 406.76 382.115 404.995C386.276 403.802 390.807 405.349 394.948 404.057C399.406 402.672 402.62 398.047 403.479 393.099C404.339 388.151 403.13 382.99 401 378.516C398.87 374.042 395.865 370.141 392.88 366.281C390.391 363.068 387.734 359.714 384.094 358.286C379.734 356.583 374.781 357.865 370.583 359.51C367.807 360.604 365.526 362.677 363.021 364.302C360.339 366.047 357.286 367.318 354.266 368.172C351.396 368.979 348.438 369.401 345.474 369.396Z",
    fill: "#B3E5F8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_55"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 353,
    y: 354,
    width: 35,
    height: 36
  }, _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "b2413e605b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M353.573 354.667H387.573V389.333H353.573V354.667Z",
    fill: "white"
  })))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M382.401 367.672C381.312 361.01 376.432 355.984 370.578 355.984C364.714 355.984 359.833 361.01 358.75 367.672C356.005 371.24 354.323 375.427 354.323 378.328C354.323 384.37 361.599 389.266 370.578 389.266C379.552 389.266 386.823 384.37 386.823 378.328C386.823 375.427 385.141 371.24 382.401 367.672Z",
    fill: "#593016"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_56"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 353,
    y: 385,
    width: 15,
    height: 20
  }, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "093bc1fcb2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M353.573 385.333H368V404.729H353.573V385.333Z",
    fill: "white"
  })))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M364.828 404.724L367.063 392.865C367.406 390.776 364.823 386.443 364.823 386.443C362.724 386.099 355.734 387.526 354.953 394.25L353.578 404.724H364.828Z",
    fill: "#2B4556"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_57"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 373,
    y: 385,
    width: 15,
    height: 20
  }, _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "db85f0e8bb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M373.333 385.333H387.573V404.729H373.333V385.333Z",
    fill: "white"
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M376.323 404.724H387.573L386.198 394.25C385.417 387.526 378.427 386.099 376.328 386.443C376.328 386.443 373.745 390.776 374.089 392.865L376.323 404.724Z",
    fill: "#2B4556"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_58"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 380,
    y: 401,
    width: 8,
    height: 4
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "f91b5c613b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M380 401.333H387.573V404.729H380V401.333Z",
    fill: "white"
  })))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M385.5 404.724L387.453 404.089L387.151 401.49L380.661 403.516V404.724H385.5Z",
    fill: "#7D8081"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_59"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 353,
    y: 401,
    width: 9,
    height: 4
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "a00040fad4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M353.573 401.333H361.333V404.729H353.573V401.333Z",
    fill: "white"
  })))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M360.479 404.724V403.516L353.995 401.49L353.688 404.089L355.641 404.724H360.479Z",
    fill: "#7D8081"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 358,
    y: 385,
    width: 26,
    height: 20
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "b99a5c0c4f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M358.667 385.333H384V404.729H358.667V385.333Z",
    fill: "white"
  })))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M382.391 404.724L382.792 395.766C382.792 390.104 378.177 385.516 372.49 385.516H369.109C363.422 385.516 358.807 390.104 358.807 395.766L359.083 404.724H382.391Z",
    fill: "#304C60"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_61"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 369,
    y: 388,
    width: 3,
    height: 17
  }, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "1d796c79b8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M369.333 388H372V404.729H369.333V388Z",
    fill: "white"
  })))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M371.448 404.724V389.266H370.359V404.724H371.448Z",
    fill: "#1D303C"
  }))))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M374.859 388.12L370.802 391.443L366.74 388.12V379.589H374.859V388.12Z",
    fill: "#BE8166"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M369.786 392.698L364.969 388.797L366.74 386.396L370.802 389.266V391.443L369.786 392.698Z",
    fill: "#213544"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M371.813 392.698L376.63 388.797L374.859 386.396L370.802 389.266V391.443L371.813 392.698Z",
    fill: "#213544"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M382.182 369.531C381.646 369.161 380.917 369.229 380.219 369.63C376 369.63 373.464 359.797 373.464 359.797C373.49 364.125 367.943 367.26 363.979 367.37C367.099 366.714 368.505 357.089 367.042 361.526C365.583 365.958 360.938 366.625 360.917 366.63C360.88 367.078 360.859 367.542 360.859 368.031C360.859 368.557 360.885 369.094 360.932 369.63C360.234 369.229 359.505 369.161 358.969 369.531C358.047 370.167 358.042 371.849 358.958 373.286C359.776 374.578 361.052 375.229 361.974 374.901C363.599 380.057 366.839 384.458 370.578 384.458C374.313 384.458 377.552 380.057 379.177 374.901C380.099 375.229 381.375 374.578 382.193 373.286C383.109 371.849 383.104 370.167 382.182 369.531Z",
    fill: "#E39573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 362,
    y: 351,
    width: 17,
    height: 9
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "a1fe14fb5c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M362.667 351.729H378.667V360H362.667V351.729Z",
    fill: "white"
  })))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M378.464 358.844H362.682V351.74H378.464V358.844Z",
    fill: "#304C60"
  }))))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M372.797 354.802H371.068V353.078H370.083V354.802H368.349V355.781H370.083V357.505H371.068V355.781H372.797V354.802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker5"
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M433.656 312.161C439.411 325.214 437.104 338.594 430.104 345.802C423.104 353.01 403.266 367.161 386.844 341.417C370.422 315.672 406.578 292.161 422.818 302.099C432.865 308.24 433.656 312.161 433.656 312.161Z",
    fill: "#93C6B6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M406.125 338.391L400.062 345.922V341.26L405.563 332.12L406.125 338.391Z",
    fill: "#BDBFA7"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M396.521 347.688V345.271L400.063 341.536L400.313 345.609L396.521 347.688Z",
    fill: "#CA886B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_63"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 404,
    y: 330,
    width: 16,
    height: 20
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "39a627aa3a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M404 330.667H420V349.542H404V330.667Z",
    fill: "white"
  })))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M419.625 349.51V333.714C419.625 332.182 418.365 330.943 416.807 330.943H407.865C406.307 330.943 405.042 332.182 405.042 333.714V349.51H419.625Z",
    fill: "#BDBFA7"
  }))))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M409.641 332.651C409.641 334.083 410.818 335.281 412.271 335.281H412.333C413.786 335.281 414.964 334.083 414.964 332.651V327.188C414.964 325.76 413.786 324.599 412.333 324.599H412.271C410.818 324.599 409.641 325.76 409.641 327.188V332.651Z",
    fill: "#C28468"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M419.594 338.75L426.51 346.214V341.625L419.219 332.286L419.594 338.75Z",
    fill: "#BDBFA7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 422,
    y: 340,
    width: 5,
    height: 10
  }, _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "1f0ea8e46d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M422.667 340H426.667V349.542H422.667V340Z",
    fill: "white"
  })))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M426.411 349.51V340.505H423.047L424.01 349.51H426.411Z",
    fill: "#E39573"
  }))))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M399.776 315.734C399.776 307.693 405.385 301.172 412.302 301.172C419.219 301.172 424.828 307.693 424.828 315.734C424.828 323.776 419.219 330.292 412.302 330.292C405.385 330.292 399.776 323.776 399.776 315.734Z",
    fill: "#E39573"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M422.208 316.422C422.208 317.578 423.167 318.521 424.344 318.521C425.526 318.521 426.479 317.578 426.479 316.422V314.984C426.479 313.823 425.526 312.885 424.344 312.885C423.167 312.885 422.208 313.823 422.208 314.984V316.422Z",
    fill: "#E39573"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M397.708 316.422C397.708 317.578 398.667 318.521 399.844 318.521C401.026 318.521 401.979 317.578 401.979 316.422V314.984C401.979 313.823 401.026 312.885 399.844 312.885C398.667 312.885 397.708 313.823 397.708 314.984V316.422Z",
    fill: "#E39573"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M398.552 340.323C398.953 339.823 400.099 340.052 401.115 340.833L402.167 341.646C403.182 342.427 403.687 343.464 403.286 343.964C403.187 344.089 403.036 344.167 402.854 344.203C402.776 344.5 402.635 344.781 402.432 345.036C401.641 346.036 400.172 346.214 399.151 345.432L398.099 344.625C397.083 343.844 396.901 342.401 397.698 341.401C397.901 341.146 398.146 340.948 398.422 340.802C398.411 340.615 398.453 340.453 398.552 340.323Z",
    fill: "#9EA08E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_65"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 421,
    y: 340,
    width: 7,
    height: 6
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "f5d0af56c9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M421.333 340H427.839V345.333H421.333V340Z",
    fill: "white"
  })))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M421.823 341.625C421.823 340.99 422.87 340.474 424.161 340.474H425.5C426.786 340.474 427.833 340.99 427.833 341.625C427.833 341.786 427.766 341.943 427.641 342.078C427.766 342.359 427.833 342.667 427.833 342.99C427.833 344.26 426.786 345.286 425.5 345.286H424.161C422.87 345.286 421.823 344.26 421.823 342.99C421.823 342.667 421.891 342.359 422.016 342.078C421.891 341.943 421.823 341.786 421.823 341.625Z",
    fill: "#9EA08E"
  }))))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M423.214 316.26H425.271V305.083H419.479C419.479 305.083 423.562 307.109 423.214 316.26Z",
    fill: "#0C0D0D"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M401.943 316.26H399.891V305.083H405.677C405.677 305.083 401.594 307.109 401.943 316.26Z",
    fill: "#0C0D0D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_66"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 386,
    y: 322,
    width: 18,
    height: 14
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "7f7a73ec27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M386.839 322.667H404V336H386.839V322.667Z",
    fill: "white"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M386.875 323.948C386.932 323.797 387.062 323.682 387.224 323.646C387.255 323.641 387.286 323.635 387.323 323.635L402.641 323.193C402.917 323.182 403.146 323.396 403.156 323.667C403.161 323.932 402.948 324.161 402.672 324.167L387.849 324.594L387.953 328.177L394.135 327.995C394.271 327.995 394.396 328.047 394.49 328.13C394.583 328.214 394.641 328.339 394.646 328.469L394.844 335.031C394.849 335.302 394.635 335.526 394.359 335.531C394.089 335.542 393.859 335.328 393.849 335.063L393.667 328.99L387.49 329.167C387.453 329.167 387.422 329.167 387.385 329.161C387.161 329.12 386.984 328.927 386.974 328.693L386.839 324.135C386.839 324.068 386.849 324.005 386.875 323.948Z",
    fill: "#8E8F8F"
  }))))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M388.526 324.609C388.552 325.458 389.271 326.125 390.135 326.099L400.573 325.802C401.437 325.776 402.115 325.068 402.089 324.219L402.057 323.172C402.031 322.323 401.312 321.656 400.448 321.682L390.01 321.984C389.146 322.01 388.469 322.719 388.495 323.568L388.526 324.609Z",
    fill: "#F6D790"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M388.641 322.833C388.896 322.339 389.453 322 390.01 321.984L400.448 321.682C400.547 321.677 400.641 321.688 400.734 321.698C401.052 322.099 401.427 322.505 401.495 323.026C401.521 323.229 401.536 323.599 401.307 323.698C401.052 323.807 400.807 323.448 400.677 323.307C400.505 323.13 400.276 323.068 400.031 323.026C399.573 322.943 399.109 323.151 398.849 323.521C398.63 323.839 398.562 324.234 398.339 324.547C398.141 324.833 397.849 324.995 397.51 325.078C397.312 325.125 397.052 325.193 396.875 325.047C396.719 324.927 396.693 324.693 396.661 324.51C396.625 324.276 396.37 323.948 396.167 323.828C395.943 323.693 395.677 323.703 395.432 323.776C394.708 324.01 394.151 324.146 393.891 324.927C393.891 325.042 393.859 325.146 393.802 325.234C393.708 325.38 393.542 325.479 393.354 325.484C393.047 325.495 392.797 325.26 392.786 324.964C392.776 324.661 393.104 324.052 392.38 323.552C392.333 323.521 392.281 323.49 392.219 323.469C391.958 323.37 391.661 323.354 391.411 323.495C390.974 323.75 390.797 324.234 390.594 324.667C390.292 325.333 389.745 325.13 389.255 324.781C388.943 324.563 388.844 324.245 388.771 323.896C388.698 323.563 388.469 323.167 388.641 322.833Z",
    fill: "#86C633"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M399.016 325.229C399.021 325.37 399.135 325.474 399.276 325.474C399.417 325.469 399.526 325.354 399.521 325.219C399.516 325.078 399.401 324.969 399.26 324.974C399.12 324.979 399.01 325.094 399.016 325.229Z",
    fill: "#86C633"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M391.693 324.245C391.698 324.385 391.813 324.49 391.953 324.49C392.094 324.484 392.203 324.37 392.198 324.229C392.193 324.094 392.078 323.984 391.938 323.99C391.797 323.995 391.688 324.109 391.693 324.245Z",
    fill: "#86C633"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_67"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 392,
    y: 332,
    width: 4,
    height: 18
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "3dbdf34604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M392 332H396V349.542H392V332Z",
    fill: "white"
  })))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M395.995 349.51L395.25 332.661C395.24 332.344 395.068 332.094 394.87 332.099L393.651 332.135C393.448 332.141 393.292 332.401 393.302 332.719L394.047 349.51H395.995Z",
    fill: "#F6863A"
  }))))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M396.38 344.464C397.479 345.063 397.875 346.422 397.266 347.5C396.661 348.578 395.276 348.969 394.182 348.37L393.604 348.068C392.505 347.469 392.109 346.109 392.719 345.031C393.323 343.953 394.708 343.563 395.802 344.161L396.38 344.464Z",
    fill: "#CA886B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M397.109 344.005C397.115 344.474 396.839 344.865 396.484 344.885L393.589 345.031C393.24 345.047 392.948 344.682 392.943 344.214C392.937 343.745 393.214 343.354 393.568 343.339L396.464 343.193C396.812 343.172 397.104 343.536 397.109 344.005Z",
    fill: "#CA886B"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M398.979 308.839C398.979 311.026 405.109 312.802 412.672 312.802C420.24 312.802 426.37 311.026 426.37 308.839C426.37 306.651 420.24 304.875 412.672 304.875C405.109 304.875 398.979 306.651 398.979 308.839Z",
    fill: "#356DA7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_68"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 398,
    y: 296,
    width: 29,
    height: 14
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "e3253596dd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M398.667 296.542H426.667V309.333H398.667V296.542Z",
    fill: "white"
  })))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M398.979 308.839C399.073 304.833 399.552 300.047 402.458 298.625C404.844 297.453 409.245 296.552 412.604 296.552C416.797 296.552 420.547 297.375 423.057 299.286C425.021 300.781 426.292 305.641 426.37 308.839H398.979Z",
    fill: "#4082CC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "worker4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_69"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 394,
    y: 228,
    width: 69,
    height: 55
  }, _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "c0d697bdb4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M394.667 228H462.589V282.667H394.667V228Z",
    fill: "white"
  })))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M402.099 232.448C400.792 233.594 399.646 235.036 398.714 236.839C392.693 248.458 392.589 270.714 406.818 276.719C412.865 279.276 420.219 280.339 426.661 281.505C436.318 283.255 444.24 281.792 451.073 274.266C456.495 268.292 462.099 260.344 462.417 252.026C462.589 247.516 460.87 242.755 457.203 240.073C454.177 237.865 450.292 237.292 446.625 236.484C434.115 233.729 413.755 222.255 402.099 232.448Z",
    fill: "#76E297"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_70"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 409,
    y: 265,
    width: 7,
    height: 17
  }, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "85118bf452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M409.464 265.333H416V281.609H409.464V265.333Z",
    fill: "white"
  })))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M415.026 281.62L414.333 266.651C414.333 266.651 410.578 267.323 410.349 269.417L409.479 281.62H415.026Z",
    fill: "#DAD1DD"
  }))))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M435.828 250.458C435.828 250.458 436.167 255.99 433.141 254.536L434.427 249.979L435.828 250.458Z",
    fill: "#130C0C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_71"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 413,
    y: 264,
    width: 26,
    height: 18
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "c21f89e690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M413.333 264H438.667V281.609H413.333V264Z",
    fill: "white"
  })))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M437.641 281.62L437.62 266.651C434.104 265.552 430.083 265.12 426.49 264.995C420.964 264.807 414.333 266.651 414.333 266.651L414.203 281.62H437.641Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_72"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 418,
    y: 265,
    width: 17,
    height: 17
  }, _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "4a90364004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M418.667 265.333H434.667V281.609H418.667V265.333Z",
    fill: "white"
  })))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M423.599 281.505L419.99 277.693L421.495 275.417L419.135 275.635L419.323 272.427L423.599 275.901L429.109 275.729L432.859 266.005L434.24 275.474H432.099L432.859 277.12C432.859 277.12 426.708 281.505 423.599 281.505Z",
    fill: "#99A9BD"
  }))))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M421.495 264.839C421.552 265.177 423.161 277.146 425.198 280.13C425.198 280.13 430.724 269.849 431.927 265.354C431.927 265.354 431.891 265.333 431.818 265.292C427.964 264.625 424.24 264.651 421.495 264.839Z",
    fill: "#91ACAF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_73"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 428,
    y: 280,
    width: 8,
    height: 2
  }, _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "7a2ed80823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M428 280H436V281.609H428V280Z",
    fill: "white"
  })))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M429.74 281.62C430.031 281.167 431.203 280.891 432.5 280.932C433.411 281.031 434.161 281.292 434.469 281.62H434.865C434.823 281.516 434.792 281.406 434.771 281.297C434.161 280.953 433.057 280.74 431.922 280.786C431.901 280.786 431.88 280.786 431.865 280.792C430.854 280.766 429.927 280.932 429.432 281.229C429.391 281.365 429.354 281.495 429.312 281.62H429.74Z",
    fill: "#11293B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_74"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 280,
    width: 6,
    height: 2
  }, _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "b9bb931a7c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M429.333 280H434.667V281.609H429.333V280Z",
    fill: "white"
  })))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M434.474 281.62H434.469C434.161 281.292 433.411 281.031 432.5 280.932C432.417 280.927 432.328 280.927 432.245 280.927C431.146 280.927 430.177 281.156 429.818 281.521L429.849 281.396C430.234 281.047 431.182 280.828 432.255 280.828C432.339 280.828 432.422 280.828 432.51 280.833C433.401 280.938 434.146 281.188 434.458 281.51L434.474 281.62Z",
    fill: "#0B1922"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_75"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 428,
    y: 277,
    width: 8,
    height: 5
  }, _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "3a8d588c5c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M428 277.333H436V281.609H428V277.333Z",
    fill: "white"
  })))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M429.792 281.62L429.984 280.854C430.26 279.677 431.021 279.109 432.208 279.151C433.599 279.109 434.208 279.969 434.37 280.969L434.474 281.62H435.089L434.948 280.745C434.719 279.339 433.401 278.385 432 278.615L431.958 278.625C430.786 278.599 429.719 279.391 429.427 280.583L429.172 281.62H429.792Z",
    fill: "#949595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M429.792 281.62L429.984 280.854C430.26 279.677 431.021 279.109 432.208 279.151C433.599 279.109 434.208 279.969 434.37 280.969L434.474 281.62H435.089L434.948 280.745C434.719 279.339 433.354 278.422 432 278.615C432 278.615 431.995 278.615 431.99 278.615C431.812 278.609 430.083 278.609 429.427 280.583L429.172 281.62H429.792Z",
    fill: "#11293B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_76"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 278,
    width: 5,
    height: 4
  }, _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "a4b32e0864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M429.333 278.667H433.333V281.609H429.333V278.667Z",
    fill: "white"
  })))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M429.984 280.854C430.255 279.719 430.974 279.146 432.089 279.146C432.13 279.146 432.167 279.151 432.208 279.151C432.219 279.151 432.229 279.151 432.24 279.151C432.245 279.151 432.25 279.151 432.25 279.151H432.208C432.167 279.151 432.13 279.146 432.089 279.146C430.974 279.146 430.255 279.719 429.984 280.854Z",
    fill: "#CFD2D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_77"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 280,
    width: 2,
    height: 2
  }, _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "c06a40a615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M429.333 280H430.667V281.609H429.333V280Z",
    fill: "white"
  })))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M429.792 281.62L429.984 280.854L429.943 281.01L429.818 281.521L429.792 281.62Z",
    fill: "#797D81"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_78"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 278,
    width: 5,
    height: 4
  }, _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "d7d03fabeb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M429.333 278.667H433.333V281.609H429.333V278.667Z",
    fill: "white"
  })))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M429.792 281.62H429.49L429.682 280.844C429.958 279.714 430.677 279.141 431.786 279.141C431.828 279.141 431.87 279.141 431.911 279.146C431.953 279.141 431.995 279.141 432.036 279.141C432.104 279.141 432.172 279.146 432.24 279.151C432.229 279.151 432.219 279.151 432.208 279.151C432.167 279.151 432.13 279.146 432.089 279.146C430.974 279.146 430.255 279.719 429.984 280.854L429.792 281.62Z",
    fill: "#0F2230"
  }))))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M434.948 280.745C434.745 279.484 433.625 278.615 432.422 278.589C432.401 278.589 432.38 278.583 432.354 278.583C432.375 278.583 432.401 278.583 432.422 278.583C433.417 278.583 434.318 279.167 434.734 280.057C434.833 280.271 434.906 280.5 434.948 280.745Z",
    fill: "#797D81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_79"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 432,
    y: 277,
    width: 4,
    height: 5
  }, _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "bbac4a3dbf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M432 277.333H436V281.609H432V277.333Z",
    fill: "white"
  })))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M435.089 281.62H434.792L434.651 280.734C434.464 279.573 433.531 278.719 432.422 278.589C433.625 278.615 434.745 279.484 434.948 280.745L435.089 281.62Z",
    fill: "#0F2230"
  }))))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M432.406 278.859L431.854 278.708C433.109 274.141 434.573 266.917 433.484 265.745C433.385 265.63 433.26 265.599 433.094 265.63L432.849 265.24C433.214 265.161 433.563 264.995 433.901 265.354C435.578 267.115 432.734 277.667 432.406 278.859Z",
    fill: "#11293B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M420.437 264.812C420.406 264.875 417.042 271.432 419.969 281.125L419.427 281.292C416.427 271.359 419.901 264.609 419.937 264.542C419.937 264.542 420.24 264.172 420.437 264.812Z",
    fill: "#11293B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M425.167 280.448L425.177 280.438L425.198 279.703C423.12 275.813 421.547 264.474 421.547 264.474L420.188 264.677C419.766 265.927 418.5 275.526 418.5 275.526C419.495 275.099 421.495 274.703 421.495 274.703C421.187 275.255 420.052 277.094 420.052 277.094C421.188 278.484 423.057 280.214 424.188 281.208C424.453 280.891 424.807 280.693 425.167 280.448Z",
    fill: "#E0EBEB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_80"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 422,
    y: 264,
    width: 13,
    height: 18
  }, _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "c29ffa9809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M422.667 264H434.667V281.609H422.667V264Z",
    fill: "white"
  })))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M431.875 264.995C431.875 264.995 426.573 279.943 423.599 281.505C423.599 281.505 427.609 280.417 431.672 277.047L430.818 274.151L432.995 274.432C432.995 274.432 433.563 267.995 433.328 265.354L431.875 264.995Z",
    fill: "#E0EBEB"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_81"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 417,
    y: 278,
    width: 6,
    height: 4
  }, _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "c105249a35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M417.333 278.667H422.667V281.609H417.333V278.667Z",
    fill: "white"
  })))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M422.453 281.62C422.276 280.615 421.401 279.844 420.349 279.844C419.297 279.844 418.422 280.615 418.245 281.62H422.453Z",
    fill: "#B8BBC1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_82"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 418,
    y: 280,
    width: 5,
    height: 2
  }, _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "1c0242e758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M418.667 280H422.667V281.609H418.667V280Z",
    fill: "white"
  })))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M421.958 281.62C421.786 280.885 421.135 280.339 420.349 280.339C419.563 280.339 418.911 280.885 418.74 281.62H421.958Z",
    fill: "#CFD2D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M421.5 281.62C421.339 281.13 420.885 280.776 420.349 280.776C419.807 280.776 419.359 281.13 419.198 281.62H421.5Z",
    fill: "#E9EAEB"
  }))))), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M413.531 247.995C414.036 249.865 415.422 251.115 416.635 250.786C417.839 250.453 418.411 248.667 417.896 246.797C417.396 244.927 416.005 243.677 414.797 244.01C413.589 244.339 413.016 246.125 413.531 247.995Z",
    fill: "#EAAA80"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M413.531 247.995C414.036 249.865 415.422 251.115 416.635 250.786C417.839 250.453 418.411 248.667 417.896 246.797C417.396 244.927 416.005 243.677 414.797 244.01C413.589 244.339 413.016 246.125 413.531 247.995Z",
    fill: "#98563E"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M412.781 236.109C412.781 236.109 411.781 238.906 412.781 239.995C412.781 239.995 412.005 241.854 413.016 243.177C413.016 243.177 412.432 244.568 413.344 245.385C413.344 245.385 413.047 248.234 415.714 247.839C418.38 247.448 417.401 237.005 417.401 237.005L412.781 236.109Z",
    fill: "#130C0C"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M429.26 265.354V258.474H423.01L422.312 265.354C422.312 265.354 425.339 266.807 429.26 265.354Z",
    fill: "#9D5A41"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M422.859 259.964L422.589 262.646C424.214 262.75 427.151 262.901 429.26 262.281V258.474H426.943L423.01 259.495L422.859 259.964Z",
    fill: "#824735"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M435.828 240.703C434.74 230.203 424.979 230.849 424.974 230.849C424.974 230.849 417.24 229.698 416.151 240.203C416.151 240.203 411.224 261.443 424.156 261.427C424.156 261.427 435.943 262.234 435.828 240.703Z",
    fill: "#B66C4A"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M431.672 242.438C431.5 243.552 432.599 244.526 432.599 244.526C433.219 245.177 433.385 247.286 433.385 247.286L434.182 244.771L434.646 238.438L431.094 234.87L416.729 237.141C416.469 238.031 416.271 239.047 416.151 240.203C416.151 240.203 416.146 240.214 416.146 240.229C417.5 241.677 419.328 240.344 419.328 240.344C420.438 241.703 422.729 240.224 422.729 240.224C423.88 241.625 426.656 239.641 426.656 239.641C428.318 240.547 429.703 238.635 429.703 238.635C429.161 240.224 430.901 240.729 430.901 240.729C430.641 241.729 431.672 242.438 431.672 242.438Z",
    fill: "#8E523E"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M438.49 248.354C437.74 250.146 436.203 251.208 435.047 250.719C433.896 250.234 433.557 248.391 434.297 246.604C435.042 244.813 436.583 243.75 437.74 244.234C438.891 244.719 439.229 246.563 438.49 248.354Z",
    fill: "#B66C4A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M435.859 250.099C435.313 250.099 435.292 249.224 435.292 249.224C436.365 248.755 435.292 248.078 435.292 248.078C435.63 245.516 436.844 245.385 437.078 245.385C437.104 245.385 437.12 245.385 437.12 245.385C438.219 245.641 437.938 247.016 437.938 247.016L436.391 249.896C436.172 250.042 436 250.099 435.859 250.099Z",
    fill: "#995A42"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M437.938 247.016C437.948 246.932 437.953 246.844 437.953 246.76C437.953 246.677 437.953 246.594 437.943 246.51C437.938 246.469 437.932 246.427 437.927 246.385C437.917 246.344 437.911 246.302 437.901 246.266C437.885 246.182 437.854 246.104 437.823 246.031L437.766 245.922C437.75 245.885 437.719 245.854 437.698 245.823C437.677 245.786 437.651 245.76 437.62 245.729C437.594 245.703 437.568 245.672 437.536 245.651L437.438 245.578L437.333 245.526C437.26 245.49 437.177 245.479 437.104 245.453H437.115C437.052 245.453 436.979 245.464 436.917 245.479C436.849 245.495 436.781 245.516 436.719 245.542C436.656 245.568 436.594 245.604 436.536 245.635C436.479 245.677 436.417 245.714 436.365 245.76C436.318 245.807 436.26 245.849 436.214 245.906C436.172 245.958 436.12 246.005 436.078 246.068L435.958 246.24L435.854 246.427C435.818 246.49 435.792 246.557 435.766 246.625C435.734 246.688 435.708 246.755 435.682 246.823L435.615 247.026C435.594 247.099 435.568 247.161 435.552 247.234L435.5 247.448C435.484 247.516 435.464 247.589 435.453 247.661L435.38 248.089L435.339 248C435.396 248.042 435.448 248.083 435.5 248.13C435.552 248.172 435.604 248.224 435.646 248.276C435.693 248.328 435.734 248.385 435.771 248.448C435.786 248.479 435.807 248.51 435.818 248.547C435.828 248.589 435.839 248.62 435.844 248.661C435.844 248.703 435.849 248.74 435.839 248.781C435.828 248.818 435.823 248.859 435.802 248.891C435.786 248.927 435.766 248.958 435.745 248.99L435.667 249.068C435.646 249.099 435.615 249.115 435.583 249.135L435.5 249.193L435.313 249.281L435.354 249.224C435.354 249.359 435.375 249.5 435.411 249.63C435.427 249.667 435.432 249.698 435.448 249.729C435.464 249.76 435.474 249.792 435.49 249.823C435.51 249.849 435.521 249.885 435.547 249.906C435.568 249.932 435.589 249.964 435.615 249.979C435.641 249.995 435.667 250.026 435.698 250.031C435.729 250.042 435.76 250.063 435.792 250.063L435.896 250.073L435.995 250.057C436.031 250.057 436.063 250.042 436.099 250.031L436.198 249.995L436.391 249.896L436.208 250.016L436.109 250.063C436.073 250.078 436.042 250.094 436.005 250.099L435.896 250.125C435.859 250.125 435.823 250.12 435.781 250.12C435.745 250.12 435.708 250.104 435.672 250.094C435.635 250.083 435.604 250.057 435.568 250.036C435.536 250.021 435.51 249.984 435.484 249.958C435.453 249.932 435.438 249.901 435.411 249.87C435.391 249.839 435.375 249.802 435.359 249.771C435.339 249.734 435.333 249.698 435.318 249.667C435.266 249.521 435.24 249.375 435.229 249.224L435.224 249.188L435.266 249.167L435.432 249.078L435.505 249.021C435.526 249.005 435.552 248.99 435.573 248.964L435.63 248.901C435.641 248.88 435.651 248.854 435.667 248.833C435.682 248.807 435.677 248.781 435.688 248.755C435.693 248.734 435.682 248.708 435.682 248.682C435.682 248.656 435.672 248.63 435.667 248.604C435.656 248.578 435.641 248.552 435.63 248.526C435.599 248.479 435.563 248.432 435.521 248.385C435.484 248.344 435.438 248.302 435.391 248.26C435.344 248.224 435.292 248.182 435.245 248.156L435.193 248.125L435.203 248.068L435.271 247.625C435.281 247.552 435.302 247.479 435.318 247.406L435.37 247.188C435.385 247.115 435.411 247.042 435.432 246.969L435.505 246.755C435.531 246.688 435.568 246.615 435.594 246.547C435.625 246.479 435.651 246.406 435.693 246.344L435.802 246.141L435.938 245.958C435.979 245.896 436.042 245.844 436.089 245.781C436.141 245.724 436.203 245.682 436.26 245.63C436.318 245.578 436.385 245.542 436.453 245.495C436.521 245.464 436.589 245.417 436.661 245.396C436.734 245.365 436.813 245.349 436.885 245.333C436.964 245.323 437.042 245.313 437.125 245.318H437.13L437.135 245.323C437.219 245.354 437.307 245.37 437.385 245.417L437.5 245.479L437.604 245.563C437.646 245.589 437.672 245.625 437.698 245.656C437.729 245.693 437.76 245.724 437.781 245.76C437.802 245.802 437.833 245.839 437.849 245.875L437.901 246C437.927 246.083 437.953 246.167 437.964 246.25C437.974 246.292 437.974 246.333 437.979 246.38C437.984 246.422 437.99 246.464 437.99 246.505C437.995 246.677 437.979 246.849 437.938 247.016Z",
    fill: "#5F4131"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M436.99 247.161C436.953 247.068 436.896 246.964 436.807 246.865C436.719 246.766 436.599 246.677 436.453 246.63C436.385 246.615 436.307 246.594 436.234 246.594C436.167 246.594 436.089 246.589 436.026 246.604C435.901 246.62 435.792 246.661 435.698 246.698C435.661 246.844 435.604 246.99 435.542 247.135L435.568 247.167C435.568 247.167 435.589 247.151 435.635 247.12C435.672 247.094 435.74 247.036 435.813 246.99C435.958 246.896 436.182 246.792 436.417 246.818C436.526 246.833 436.635 246.88 436.729 246.948C436.813 247.026 436.891 247.109 436.943 247.188C437.052 247.354 437.089 247.479 437.089 247.479C437.089 247.479 437.068 247.344 436.99 247.161Z",
    fill: "#5F4131"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M438.469 244.865C438.469 244.865 437.422 243.667 435.703 244.688C435.703 244.688 434.375 246.344 434.255 247.479L433.385 247.286C433.385 247.286 433.734 244.844 433.141 244.12C433.141 244.12 432.599 243.49 432.562 242.245C432.562 242.245 431.672 241.896 431.786 240.536C431.786 240.536 430.292 239.156 430.672 237.302C430.672 237.302 428.505 239.141 426.708 238.13C426.708 238.13 424.911 239.917 423.021 238.438C423.021 238.438 420.901 240.354 419.703 238.891C419.703 238.891 416.745 240.589 415.229 238.891C415.229 238.891 412.937 239.604 412.937 237.042C412.937 237.042 411.24 235.875 413.016 233.005C413.016 233.005 412.781 228.422 415.714 228.656C415.714 228.656 417.547 226.313 420.146 227.641C420.146 227.641 422.672 225.703 423.599 227.104C423.599 227.104 425.943 224.885 427.281 226.594C427.281 226.594 429.302 224.62 430.63 227.255C430.63 227.255 433.161 226.323 433.906 228.266C433.906 228.266 436.312 227.724 436.312 230.286C436.312 230.286 438.88 230.813 437.687 232.917C437.687 232.917 440.13 233.51 439.552 235.839C439.552 235.839 440.557 236.771 439.474 239.141C439.474 239.141 440.943 240.615 439.401 242.203C439.401 242.203 439.818 244.344 438.469 244.865Z",
    fill: "#271511"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_83"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 436,
    y: 265,
    width: 10,
    height: 17
  }, _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "438a7b3544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M436 265.333H445.464V281.609H436V265.333Z",
    fill: "white"
  })))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M445.458 281.62C444.901 277.047 443.771 271.703 443.219 269.255C443.219 269.255 442.615 267.786 441.047 267.422C439.411 267.047 437.62 266.651 437.62 266.651L436.547 281.62H445.458Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_84"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 440,
    y: 268,
    width: 6,
    height: 14
  }, _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "778b136587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M440 268H445.464V281.609H440V268Z",
    fill: "white"
  })))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M445.458 281.62H441.286C442.755 279.714 443.682 275.911 442.781 268.547C442.828 268.604 442.875 268.667 442.911 268.724C443.125 269.021 443.219 269.25 443.219 269.255C443.771 271.703 444.901 277.047 445.458 281.62Z",
    fill: "#DFDCE0"
  }))))), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M434.255 247.479L434.031 247.427L433.385 247.286C433.385 247.286 433.484 246.568 433.484 245.797C433.484 245.146 433.411 244.448 433.141 244.12C433.141 244.12 432.599 243.49 432.563 242.245C432.563 242.245 431.776 241.938 431.776 240.771C431.776 240.698 431.781 240.62 431.786 240.536C431.786 240.536 430.615 239.453 430.615 237.917C430.609 237.719 430.63 237.516 430.672 237.302C430.672 237.302 429.344 238.432 427.901 238.432C427.5 238.432 427.099 238.349 426.708 238.13C426.708 238.13 425.813 239.021 424.615 239.021C424.12 239.021 423.578 238.87 423.026 238.443C423.021 238.443 423.021 238.443 423.021 238.438C423.021 238.438 421.911 239.443 420.844 239.443C420.438 239.443 420.036 239.297 419.703 238.901C419.703 238.896 419.703 238.896 419.703 238.896V238.891C419.703 238.891 418.385 239.646 417.063 239.646C416.406 239.646 415.75 239.458 415.245 238.911C415.24 238.906 415.234 238.896 415.229 238.891C415.229 238.891 414.938 238.984 414.563 238.984H414.557C413.88 238.984 412.938 238.688 412.938 237.042C412.938 237.042 411.943 236.359 412.276 234.745C412.719 235.656 413.547 236.469 415.073 236.469C415.438 236.469 415.849 236.422 416.302 236.318C416.302 236.318 418.901 235.318 420.448 235.318C421.245 235.318 421.76 235.583 421.495 236.391C421.495 236.391 421.208 237.068 421.745 237.068C422 237.068 422.443 236.917 423.188 236.469C423.188 236.469 425.974 234.188 427.339 234.188C427.677 234.188 427.927 234.328 428.026 234.672C428.026 234.672 427.401 236.276 428.068 236.276C428.182 236.276 428.339 236.224 428.547 236.109C429.609 235.516 432.021 233.99 433.219 233.99C433.594 233.99 433.844 234.135 433.906 234.505C433.906 234.505 438.161 237.047 436.286 244.411C436.12 244.469 435.943 244.547 435.755 244.656C435.755 244.656 435.755 244.656 435.75 244.656C435.734 244.667 435.719 244.677 435.703 244.682C435.703 244.688 435.703 244.688 435.703 244.688C435.703 244.688 434.375 246.344 434.255 247.479Z",
    fill: "#1F110F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_85"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 82,
    width: 70,
    height: 50
  }, _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "e414ee3b5f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M159.292 82.3333H228.292V131.313H159.292V82.3333Z",
    fill: "white"
  })))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M197.026 128.911C193.865 128.885 190.385 128.563 187.151 128.682C183.714 128.818 180.427 129.958 177.052 130.495C171.109 131.318 165.672 127.359 162.495 122.656C160.161 119.328 159.292 115.167 159.755 111.135C159.844 109.792 160.396 108.604 160.901 107.406C161.568 105.802 162.318 104.224 163.406 102.844C166.984 98.5208 172.042 95.8021 176.312 92.2448C176.729 91.9115 177.016 91.4844 177.26 91.0156C178.594 88.2813 179.974 85.3021 182.901 83.9531C187.667 81.3177 193.911 82.0781 197.984 85.6927C199 86.6146 199.849 87.6927 200.875 88.5938C203.844 91.3385 206.776 94.6771 210.906 95.5469C215.271 95.9219 217.542 92.6875 222.224 94.1615C226.755 95.349 228.292 100.599 228.094 104.786C227.755 108.578 226.229 112.188 224.182 115.37C217.552 124.849 208.557 129.12 197.026 128.911Z",
    fill: "#76E297"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_86"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 111,
    width: 9,
    height: 8
  }, _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "67793e6fb1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M212 111.667H220.667V118.333H212V111.667Z",
    fill: "white"
  })))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M212.922 115.495C212.922 115.495 213.448 115.281 213.729 114.609C214.005 113.938 215.193 112.974 215.891 112.771C215.891 112.771 216.865 112.417 217.063 112.271C217.063 112.271 217.495 112.594 217.047 112.906C216.594 113.219 215.385 113.802 215.292 114.078C215.292 114.078 215.771 113.932 216.104 113.901C216.432 113.875 219.349 112.083 219.521 112.115C219.693 112.141 219.74 112.052 219.813 112.292C219.813 112.292 220.385 112.255 220.266 112.76C220.266 112.76 220.646 113.042 220.057 113.5C220.057 113.5 220.458 113.771 219.88 114.188C219.302 114.609 215.984 117.625 214.453 117.698L212.922 115.495Z",
    fill: "#F79375"
  }))))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M197.302 99.7761C197.302 99.7761 198.854 100.333 200.333 102.865C201.813 105.391 203.948 117.698 203.948 117.698L212.813 115.24C212.813 115.24 213.969 116.167 214.953 118.427C214.953 118.427 202.385 124.729 201.234 123.911C200.089 123.099 194.745 106.865 194.745 106.865C194.745 106.865 195.755 101.906 197.302 99.7761Z",
    fill: "#CBDAF2"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M196.51 105.563C196.401 104.552 196.255 100.958 196.073 100.708C196.073 100.708 192.849 100.016 192.578 99.4427C192.167 98.5677 191.578 95.9323 191.422 93.349C191.385 92.7031 186.719 89.8802 186.719 89.8802C186.719 89.8802 186.818 96.0625 185.396 98.8594C185.396 98.8594 180.604 99.5521 179.526 100.625C179.245 100.901 179.021 101.443 178.875 102.151L196.51 105.563Z",
    fill: "#E4846C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M192.391 98.9479C192.021 97.8542 191.599 95.7813 191.448 93.6927L187.542 91.0677H186.708C186.687 91.8021 186.641 92.8073 186.536 93.8854C187.391 95.75 189.74 100.161 192.391 98.9479Z",
    fill: "#D26758"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_87"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 127,
    width: 21,
    height: 4
  }, _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "3472b1e222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M178.667 127.667H198.667V130.896H178.667V127.667Z",
    fill: "white"
  })))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M198.438 130.901L198.563 129.073C198.563 129.073 191.922 129.604 179.87 128.385L179.885 130.901H198.438Z",
    fill: "#272938"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_88"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 98,
    width: 23,
    height: 33
  }, _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "5d7950c24a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M177.333 98.3333H200V130.896H177.333V98.3333Z",
    fill: "white"
  })))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M179.495 130.901H198.932L198.563 103.865C198.563 103.865 199.193 99.6771 195.813 99.1563L192.219 98.3802C192.255 98.7083 192.359 99.6823 192.391 100.016C192.391 100.016 191.255 101.219 190.807 101.281C190.422 101.333 187.203 99.8021 185.859 99.1511C185.63 98.7552 185.505 98.5469 185.505 98.5469C184.458 98.5938 178.521 99.9792 177.781 101.057C177.781 101.057 176.891 110.219 180.453 120.068C180.453 120.068 179.865 125.151 179.495 130.901Z",
    fill: "#CBDAF2"
  }))))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M190.323 101.604C190.323 101.604 187.323 106.104 187.547 108.807C187.547 108.807 187.396 109.563 187.094 109.943C186.786 110.323 191.286 109.182 190.958 101.604H190.323Z",
    fill: "#B72431"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M195.661 86.0208C195.661 86.0208 196.068 88.9219 195.521 91.7448C195.198 93.4167 193.448 95.8386 192.385 96.2969C192.385 96.2969 192.089 96.4636 191.047 96.2917C189.766 96.0833 187.453 94.1719 186.823 91.6667C186.823 91.6667 186.115 91.8646 185.719 90.6927C185.323 89.5156 185.672 87.7344 186.911 88.8333C186.911 88.8333 186.505 83.7448 188.797 83.4323C191.089 83.1198 195.464 82.3438 195.661 86.0208Z",
    fill: "#F79375"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M186.099 82.2031C183.615 84.3177 185.01 89.5625 186.161 91.8854C186.818 93.2188 186.323 94.5885 186.458 94.5677C186.573 93.6146 186.839 92.5938 186.87 91.8333C186.854 91.776 186.839 91.7188 186.823 91.6667C186.823 91.6667 186.302 91.9479 185.74 90.5469C185.339 89.5573 185.807 87.776 186.786 88.875C186.891 89.026 187.01 89.1667 187.12 89.2344C187.375 89.3906 188.146 88.0885 187.865 86.9896C187.865 86.9896 187.74 85.7865 188.266 84.6094C188.266 84.6094 190.74 85.9271 192.917 86.0104C192.917 86.0104 194.661 86.0417 195.536 85.2083L195.745 86.8281C195.745 86.8281 196.151 85.5208 196.073 83.9219C196.073 83.9219 195.745 81.3125 193.932 80.7344C192.151 80.1719 189.859 79 186.099 82.2031Z",
    fill: "#371D15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_89"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 101,
    width: 10,
    height: 30
  }, _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "0ff4550f85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M172.667 101H181.333V130.896H172.667V101Z",
    fill: "white"
  })))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M178.328 130.901L178.151 123.016C178.151 123.016 180.875 107.589 180.396 105.266C179.922 102.943 177.781 101.057 177.781 101.057C177.781 101.057 175.193 101.49 174.37 106.865C173.552 112.245 172.677 120.406 172.677 122.036L173.37 130.901H178.328Z",
    fill: "#CBDAF2"
  }))))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M190.745 101.177L186.078 96.8489C186.078 96.8489 185.354 96.5729 184.964 97.7864C184.964 97.7864 184.219 98.5729 184.521 98.8281C184.828 99.0781 190.745 101.604 190.745 101.604C190.745 101.604 190.964 101.63 190.745 101.177Z",
    fill: "#B72431"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M192.068 97.6042L190.745 101.177V101.604C190.745 101.604 193.63 100.063 192.714 98.3802C192.714 98.3802 192.766 97.6406 192.068 97.6042Z",
    fill: "#B72431"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M190.25 100.828C190.25 100.828 190.432 101.339 190.25 101.422C190.25 101.422 190.005 101.781 190.328 101.859C190.651 101.932 191.453 101.766 191.281 101.266C191.109 100.771 191.234 100.646 190.844 100.693C190.844 100.693 190.505 100.682 190.25 100.828Z",
    fill: "#B72431"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M190.875 101.604C190.875 101.604 190.234 108.125 194.427 109.714C194.427 109.714 194.682 109.688 194.427 109.109C194.427 109.109 194.49 104.594 191.167 101.469L190.875 101.604Z",
    fill: "#B72431"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M195.359 82.5573H186.151L187.078 73.6615H194.797L195.359 82.5573Z",
    fill: "#CBDAF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_90"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 66,
    width: 19,
    height: 11
  }, _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "fda25589bd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M181.333 66.8958H200V77H181.333V66.8958Z",
    fill: "white"
  })))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M185.109 75.8854C185.109 75.8854 187.26 76.4948 189.542 75.0781C189.542 75.0781 191.266 76.0886 192.969 75.0781C192.969 75.0781 196.505 76.9479 198.083 75.0781C199.661 73.2083 198.755 67.599 190.813 67.2448C182.87 66.8906 182.516 72.4011 182.667 72.9583C182.823 73.5104 183.125 75.2292 185.109 75.8854Z",
    fill: "#CBDAF2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "worker2"
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M344.693 109.948C338.391 117.802 336.109 131.292 344.693 140.083C353.271 148.875 367.51 145.422 377.568 146.99C387.62 148.557 400.016 148.557 402.552 134.745C405.099 120.938 399.057 117.484 381.88 107.745C364.708 98.0104 356.781 94.875 344.693 109.948Z",
    fill: "#04ACEB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_91"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 354,
    y: 134,
    width: 6,
    height: 7
  }, _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "d18a2c089f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M354.667 134.667H360V140.49H354.667V134.667Z",
    fill: "white"
  })))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M359.266 140.495H354.979V135.703H359.266V140.495Z",
    fill: "#E99567"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_92"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 381,
    y: 134,
    width: 6,
    height: 7
  }, _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "c5af7a3d75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M381.333 134.667H386.667V140.49H381.333V134.667Z",
    fill: "white"
  })))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M386.349 140.495H382.062V135.703H386.349V140.495Z",
    fill: "#E99567"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_93"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 380,
    y: 117,
    width: 8,
    height: 22
  }, _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "a983606999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M380 117.333H387.745V138.667H380V117.333Z",
    fill: "white"
  })))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M383.583 118.26C383.583 118.26 386.521 119.151 386.948 121.417C386.948 121.417 387.719 134.781 387.635 136.63C387.635 136.63 383.833 138.896 381.276 137.13C381.276 137.13 381.844 120.906 383.583 118.26Z",
    fill: "#18314E"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_94"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 353,
    y: 117,
    width: 9,
    height: 22
  }, _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "bda1dfe47e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M353.745 117.333H361.333V138.667H353.745V117.333Z",
    fill: "white"
  })))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M357.906 118.26C357.906 118.26 354.969 119.151 354.542 121.417C354.542 121.417 353.771 134.781 353.854 136.63C353.854 136.63 357.656 138.896 360.214 137.13C360.214 137.13 359.646 120.906 357.906 118.26Z",
    fill: "#18314E"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_95"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 356,
    y: 114,
    width: 30,
    height: 27
  }, _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "d526abdb8a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M356 114.667H385.333V140.49H356V114.667Z",
    fill: "white"
  })))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M384.281 119.432C384.281 119.432 383.958 118.266 383.271 118.109C383.271 118.109 376.229 115.339 370.667 115.339C365.099 115.339 358.057 118.109 358.057 118.109C357.37 118.266 357.047 119.432 357.047 119.432C357.047 119.432 358.583 132.026 359.911 135.521C359.911 135.521 360.323 138.87 360.151 140.495H381.177C381.005 138.87 381.417 135.521 381.417 135.521C382.745 132.026 384.281 119.432 384.281 119.432Z",
    fill: "#1C4069"
  }))))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M365.948 109.688C365.948 109.688 367.167 113.885 366.036 116.266C366.036 116.266 370.083 119.464 375.266 116.604C375.266 116.604 374.234 112.26 375.146 109.688H365.948Z",
    fill: "#D38256"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M364.167 105.099C364.167 105.099 363.552 103.677 362.807 104.938C362.807 104.938 362.109 106.339 363.484 107.438C363.484 107.438 364.062 108.021 364.167 108.198C364.167 108.198 364.823 108.844 365.135 108.198L364.167 105.099Z",
    fill: "#D38256"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M377.469 105.099C377.469 105.099 378.078 103.677 378.828 104.938C378.828 104.938 379.51 106.339 378.146 107.438C378.146 107.438 377.568 108.021 377.469 108.198C377.469 108.198 376.807 108.844 376.495 108.198L377.469 105.099Z",
    fill: "#F5C085"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M377.469 105.099C377.469 105.099 378.078 103.677 378.828 104.938C378.828 104.938 379.51 106.339 378.146 107.438C378.146 107.438 377.568 108.021 377.469 108.198C377.469 108.198 376.807 108.844 376.495 108.198L377.469 105.099Z",
    fill: "#D38256"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M377.573 105.219C377.573 99.8906 374.589 96.2344 370.875 96.1771C370.865 96.1771 370.849 96.1771 370.844 96.1771C370.828 96.1771 370.818 96.1771 370.802 96.1771C367.094 96.2344 364.109 99.8906 364.109 105.219C364.109 105.219 365.63 114.135 370.802 114.255C370.818 114.255 370.828 114.255 370.844 114.255C370.849 114.255 370.865 114.255 370.875 114.255C376.052 114.135 377.573 105.219 377.573 105.219Z",
    fill: "#E99567"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M364.109 104.99C364.109 104.99 364.318 106.229 364.453 106.693C364.453 106.693 365.177 105.792 365.135 104.99C365.135 104.99 365.734 100.073 366.938 99.3594C366.938 99.3594 370.609 101.714 374.984 99.5677C374.984 99.5677 375.677 100.073 375.677 100.578C375.677 101.083 376.656 105.589 377.219 105.896L377.75 104.661C377.75 104.661 378.276 100.411 377.75 98.8958C377.75 98.8958 378.724 95.3229 377.005 94.0625C375.813 93.1875 368.328 92.5521 363.88 97.4271C363.88 97.4271 361.953 98.875 364.109 104.99Z",
    fill: "#412B1F"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M377.193 116.245C377.151 115.927 375.229 113.818 374.87 113.74C374.87 113.74 371.969 117.036 370.651 117.766C369.333 117.036 366.432 113.74 366.432 113.74C366.073 113.818 364.151 115.927 364.109 116.245C364.073 116.563 365.057 120.411 365.099 120.719C365.141 121.026 365.417 120.885 365.417 120.885C366.828 119.964 369.865 118.62 370.281 118.422C370.51 118.313 370.609 118.135 370.651 117.995C370.693 118.135 370.792 118.313 371.021 118.422C371.438 118.62 374.474 119.964 375.885 120.885C375.885 120.885 376.161 121.026 376.203 120.719C376.245 120.411 377.229 116.563 377.193 116.245Z",
    fill: "#316595"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M363.099 99.651C363.099 99.651 363.099 95.901 363.88 94.1615C363.88 94.1615 370.844 89.4896 377.75 94.1927C377.75 94.1927 378.755 97.7969 378.021 99.651C378.021 99.651 371.307 101.609 363.099 99.651Z",
    fill: "#1C4069"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M363.609 99.7656C363.609 99.7656 365.25 101.839 370.844 101.781C370.844 101.781 375.604 101.958 377.193 99.8542C377.193 99.8542 372.156 95.1146 363.609 99.7656Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M375.521 106.052C375.495 106.12 375.302 106.24 374.734 106.24C374.172 106.24 373.589 106.12 373.578 106.12L373.542 106.115C373.089 106.068 372.464 105.021 372.094 104.172C372.557 104.016 373.125 103.938 373.802 103.938C374.625 103.938 375.302 104.063 375.307 104.063L375.328 104.068C375.339 104.068 375.375 104.089 375.422 104.161C375.677 104.568 375.693 105.573 375.521 106.052ZM368.25 106.115L368.214 106.12C368.208 106.12 367.625 106.24 367.062 106.24C366.495 106.24 366.297 106.12 366.276 106.052C366.104 105.573 366.12 104.568 366.375 104.161C366.417 104.089 366.453 104.068 366.469 104.068L366.484 104.063C366.495 104.063 367.167 103.938 367.995 103.938C368.667 103.938 369.24 104.016 369.698 104.172C369.333 105.021 368.703 106.068 368.25 106.115ZM376.01 103.807C375.828 103.51 375.594 103.417 375.427 103.391C375.344 103.375 374.656 103.26 373.802 103.26C372.937 103.26 372.214 103.38 371.641 103.615C370.984 103.38 370.417 103.516 370.151 103.609C369.573 103.38 368.854 103.26 367.995 103.26C367.141 103.26 366.453 103.375 366.365 103.391C366.203 103.417 365.969 103.51 365.781 103.807C365.406 104.406 365.385 105.625 365.62 106.276C365.771 106.703 366.26 106.917 367.062 106.917C367.646 106.917 368.229 106.807 368.339 106.786C369.359 106.667 370.167 104.865 370.422 104.24C370.594 104.182 370.953 104.099 371.375 104.24C371.63 104.875 372.437 106.667 373.453 106.786C373.562 106.807 374.151 106.917 374.734 106.917C375.536 106.917 376.021 106.703 376.172 106.276C376.406 105.625 376.385 104.406 376.01 103.807Z",
    fill: "#12222B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "worker1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_96"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 76,
    width: 68,
    height: 52
  }, _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "e02d9dffc1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M248 76.3958H316V127.396H248V76.3958Z",
    fill: "white"
  })))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M248.953 85.7552C247.927 88.1511 247.74 90.8177 248.839 93.3906C251.693 100.063 258.427 98.5781 263.984 100.922C267.214 102.292 269.484 105.234 271.146 108.297C272.807 111.359 274.026 114.667 275.974 117.557C279.615 122.953 285.823 126.578 292.359 127.125C295.016 127.349 297.75 127.078 300.182 126C302.609 124.922 304.708 122.99 305.651 120.526C306.526 118.224 306.406 115.542 306.88 113.125C307.813 108.344 310.24 104.333 312.505 100.089C314.807 95.7813 316.74 90.8959 315.667 86.1406C314.568 81.2709 310.073 77.349 305.047 76.8854C299.932 76.4115 295.161 79.1458 290.245 80.6146C284.615 82.3021 278.49 82.3177 272.849 80.6719C268.505 79.4063 264.229 77.1511 259.729 77.6563C255.161 78.1667 250.755 81.5365 248.953 85.7552Z",
    fill: "#B3E5F8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_97"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask98_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 267,
    y: 102,
    width: 38,
    height: 13
  }, _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "acdfbd9c10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M267.172 102.667H304.172V114.896H267.172V102.667Z",
    fill: "white"
  })))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M303.604 105.323C300.099 104.495 296.589 103.661 293.083 102.828C293.031 102.813 292.979 102.813 292.932 102.823C292.906 102.818 292.885 102.818 292.859 102.818H278.474C278.448 102.818 278.427 102.818 278.401 102.823C278.354 102.813 278.302 102.813 278.25 102.828C274.745 103.661 271.234 104.495 267.729 105.323C267.422 105.401 267.167 105.667 267.167 105.917C267.167 106.891 267.167 107.859 267.167 108.828C267.167 109.703 267.167 110.578 267.167 111.448V114.521C267.167 114.708 267.536 114.865 267.99 114.865H303.349C303.797 114.865 304.167 114.708 304.167 114.521V111.448C304.167 110.578 304.167 109.703 304.167 108.828C304.167 107.859 304.167 106.891 304.167 105.917C304.167 105.667 303.911 105.401 303.604 105.323Z",
    fill: "#EF7339"
  }))))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M294.464 103C294.198 102.943 293.932 102.885 293.667 102.828C293.609 102.813 293.557 102.813 293.505 102.823C293.479 102.818 293.453 102.818 293.427 102.818H277.911C277.88 102.818 277.854 102.818 277.828 102.823C277.781 102.813 277.724 102.813 277.667 102.828C277.401 102.885 277.135 102.943 276.87 103.005C276.865 103.182 276.859 103.365 276.859 103.547C276.859 109.797 280.802 114.328 285.667 114.328C290.531 114.328 294.474 109.797 294.474 103.547C294.474 103.365 294.474 103.182 294.464 103Z",
    fill: "#2C292B"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M292.792 103C292.578 102.943 292.359 102.885 292.146 102.828C292.099 102.813 292.057 102.813 292.016 102.823C291.995 102.818 291.969 102.818 291.948 102.818H279.385C279.365 102.818 279.344 102.818 279.323 102.823C279.281 102.813 279.234 102.813 279.188 102.828C278.974 102.885 278.76 102.943 278.542 103.005C278.536 103.182 278.536 103.365 278.536 103.547C278.536 109.797 281.729 114.328 285.667 114.328C289.604 114.328 292.802 109.797 292.802 103.547C292.802 103.365 292.797 103.182 292.792 103Z",
    fill: "#C08266"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M278.547 92.1094C278.547 92.7448 277.984 93.2604 277.297 93.2604H275.365C274.672 93.2604 274.109 92.7448 274.109 92.1094V89.1302C274.109 88.4948 274.672 87.9792 275.365 87.9792H277.297C277.984 87.9792 278.547 88.4948 278.547 89.1302V92.1094Z",
    fill: "#E19873"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M297.219 92.1094C297.219 92.7448 296.661 93.2604 295.969 93.2604H294.036C293.344 93.2604 292.786 92.7448 292.786 92.1094V89.1302C292.786 88.4948 293.344 87.9792 294.036 87.9792H295.969C296.661 87.9792 297.219 88.4948 297.219 89.1302V92.1094Z",
    fill: "#E19873"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M280.547 107.438H290.786V98.1927H280.547V107.438Z",
    fill: "#C08266"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M296.047 76.4896C295.943 76.2448 295.828 76 295.698 75.7708C294.609 73.8229 292.656 72.5208 290.427 72.5208H280.906C277.49 72.5208 274.719 75.5729 274.719 79.3386V93.9688C275.188 95.9219 277.49 96.4844 280.906 96.4844H290.427C293.844 96.4844 296.615 96.4844 296.615 93.9688V81.5833C297.557 80.875 298.292 80.0625 298.849 79.3438C300.646 77.0208 297.552 78.9271 296.047 76.4896Z",
    fill: "#4A3935"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M285.104 82.151C279.938 79.8646 277.453 81.4635 276.391 82.7188C276.349 82.974 276.333 83.2344 276.333 83.4948V96.651C276.333 99.4479 278.693 101.719 281.609 101.719H289.724C292.641 101.719 295.005 99.4479 295.005 96.651V83.4948C295.005 83.1927 294.974 82.901 294.922 82.6146C292.594 83.7188 289.396 84.0469 285.104 82.151Z",
    fill: "#E19873"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M273.578 91.9479C273.578 92.7031 272.964 93.3229 272.214 93.3229H271.453C270.698 93.3229 270.083 92.7031 270.083 91.9479V88.0521C270.083 87.2917 270.698 86.6771 271.453 86.6771H272.214C272.964 86.6771 273.578 87.2917 273.578 88.0521V91.9479Z",
    fill: "#B35C2D"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M297.755 91.9479C297.755 92.7031 298.37 93.3229 299.12 93.3229H299.88C300.635 93.3229 301.245 92.7031 301.245 91.9479V88.0521C301.245 87.2917 300.635 86.6771 299.88 86.6771H299.12C298.37 86.6771 297.755 87.2917 297.755 88.0521V91.9479Z",
    fill: "#B35C2D"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M300.672 86.7031C300.458 87.0417 300.016 87.1406 299.677 86.9323L297.755 85.724C297.422 85.5104 297.318 85.0625 297.526 84.724C297.74 84.3854 298.182 84.2813 298.521 84.4948L300.443 85.7031C300.776 85.9115 300.88 86.3594 300.672 86.7031Z",
    fill: "#2C292B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M300.146 90.5C299.745 90.5 299.422 90.0885 299.417 89.5729L299.396 86.651C299.391 86.1354 299.714 85.7135 300.109 85.7135C300.505 85.7083 300.833 86.125 300.839 86.6354L300.859 89.5625C300.865 90.0781 300.542 90.4948 300.146 90.5Z",
    fill: "#2C292B"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M270.635 86.7031C270.844 87.0417 271.292 87.1406 271.63 86.9323L273.547 85.724C273.885 85.5104 273.99 85.0625 273.781 84.724C273.568 84.3854 273.125 84.2813 272.786 84.4948L270.865 85.7031C270.526 85.9115 270.422 86.3594 270.635 86.7031Z",
    fill: "#2C292B"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M271.161 90.5C271.557 90.5 271.885 90.0885 271.891 89.5729L271.911 86.651C271.911 86.1354 271.594 85.7135 271.198 85.7135C270.797 85.7083 270.474 86.125 270.469 86.6354L270.448 89.5625C270.443 90.0781 270.76 90.4948 271.161 90.5Z",
    fill: "#2C292B"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M298.854 78.0261V77.9531C298.859 77.8386 298.844 77.7292 298.823 77.625C298.802 77.5 298.781 77.3698 298.745 77.2344C298.224 75.1927 297.224 73.375 295.885 71.8854C295.771 71.2917 295.401 70.6406 294.776 70.1458C289.458 65.9271 281.891 65.9271 276.573 70.1458C275.958 70.6354 275.589 71.2761 275.469 71.8646C274.12 73.3542 273.109 75.1823 272.589 77.2344C272.552 77.3698 272.531 77.5 272.51 77.625C272.49 77.724 272.479 77.8386 272.479 77.9531V78.0313C272.479 78.0833 272.479 78.1302 272.479 78.1823L272.583 88.0365C272.589 88.5729 272.875 89.0052 273.219 89C273.562 89 273.833 88.5625 273.828 88.0261L273.719 77.9375C273.719 77.9115 273.719 77.8854 273.719 77.8594C273.802 77.6979 273.88 77.5208 273.958 77.3438C274.542 75.9063 275.266 74.5781 276.13 73.4323C276.786 73.7188 277.698 73.4636 278.437 72.8854C282.661 69.5313 288.682 69.5313 292.911 72.8854C293.646 73.4636 294.552 73.7188 295.208 73.4375C296.068 74.5833 296.792 75.9115 297.375 77.3438C297.453 77.5208 297.531 77.6979 297.615 77.8594C297.615 77.8854 297.615 77.9115 297.615 77.9375L297.505 88.0261C297.5 88.5625 297.771 89 298.115 89C298.458 89.0052 298.745 88.5729 298.75 88.0365L298.854 78.1875C298.854 78.1354 298.854 78.0833 298.854 78.0261Z",
    fill: "#2C292B"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M299.776 85.9896C299.089 85.3489 298.229 84.9114 297.286 84.776V95.2239C298.229 95.0833 299.089 94.651 299.776 94.0052V85.9896Z",
    fill: "#EF7339"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M297.755 94.2812C297.755 95.0781 297.115 95.7239 296.323 95.7239C295.536 95.7239 294.896 95.0781 294.896 94.2812V85.7187C294.896 84.9219 295.536 84.276 296.323 84.276C297.115 84.276 297.755 84.9219 297.755 85.7187V94.2812Z",
    fill: "#2C292B"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M298.156 94.2812C298.156 95.0781 297.885 95.7239 297.547 95.7239C297.208 95.7239 296.938 95.0781 296.938 94.2812V85.7187C296.938 84.9219 297.208 84.276 297.547 84.276C297.885 84.276 298.156 84.9219 298.156 85.7187V94.2812Z",
    fill: "#EF7339"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M271.557 85.9896C272.245 85.3489 273.104 84.9114 274.042 84.776V95.2239C273.104 95.0833 272.245 94.651 271.557 94.0052V85.9896Z",
    fill: "#EF7339"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M273.578 94.2812C273.578 95.0781 274.219 95.7239 275.01 95.7239C275.797 95.7239 276.438 95.0781 276.438 94.2812V85.7187C276.438 84.9219 275.797 84.276 275.01 84.276C274.219 84.276 273.578 84.9219 273.578 85.7187V94.2812Z",
    fill: "#2C292B"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M273.177 94.2812C273.177 95.0781 273.448 95.7239 273.786 95.7239C274.125 95.7239 274.396 95.0781 274.396 94.2812V85.7187C274.396 84.9219 274.125 84.276 273.786 84.276C273.448 84.276 273.177 84.9219 273.177 85.7187V94.2812Z",
    fill: "#EF7339"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M299.88 93.3229H299.776V90.3698C299.88 90.4531 300.005 90.5 300.141 90.5C300.141 90.5 300.141 90.5 300.146 90.5C300.542 90.4948 300.859 90.0833 300.859 89.5729C300.859 89.5677 300.859 89.5677 300.859 89.5625L300.839 87.0729C301.094 87.3229 301.245 87.6719 301.245 88.0521V91.9479C301.245 92.7031 300.635 93.3229 299.88 93.3229Z",
    fill: "#924D27"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M300.781 86.2813C300.667 85.9479 300.411 85.7136 300.115 85.7136H300.109C299.948 85.7136 299.797 85.7865 299.677 85.9011C299.401 85.6563 299.099 85.4479 298.776 85.2708L298.786 84.6615L300.443 85.7031C300.651 85.8333 300.766 86.0521 300.781 86.2813Z",
    fill: "#252326"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M298.776 85.2708C298.552 85.151 298.312 85.0469 298.068 84.9635C298.01 84.75 297.932 84.5729 297.839 84.4479C297.932 84.4062 298.036 84.3854 298.141 84.3854C298.271 84.3854 298.401 84.4167 298.521 84.4948L298.786 84.6614L298.776 85.2708Z",
    fill: "#252326"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M300.141 90.5C300.005 90.5 299.88 90.4531 299.776 90.3698V85.9896C299.745 85.9635 299.708 85.9323 299.677 85.901C299.797 85.7864 299.948 85.7135 300.109 85.7135H300.115C300.411 85.7135 300.667 85.9479 300.781 86.2812C300.818 86.3906 300.833 86.5104 300.839 86.6354V87.0729L300.859 89.5625C300.859 89.5677 300.859 89.5677 300.859 89.5729C300.859 90.0833 300.542 90.4948 300.146 90.5C300.141 90.5 300.141 90.5 300.141 90.5Z",
    fill: "#252326"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M298.068 95.0364C298.125 94.8177 298.156 94.5573 298.156 94.2812V85.7187C298.156 85.4427 298.125 85.1823 298.068 84.9635C298.703 85.1771 299.281 85.5312 299.776 85.9896V94.0052C299.281 94.4687 298.703 94.8229 298.068 95.0364Z",
    fill: "#C16235"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M296.323 95.7239C295.729 95.7239 295.219 95.3542 295.005 94.8333C294.932 94.6614 294.896 94.4792 294.896 94.2812V85.7187C294.896 84.9219 295.536 84.276 296.323 84.276C296.646 84.276 296.943 84.3854 297.182 84.5625C297.031 84.8281 296.938 85.2448 296.938 85.7187V94.2812C296.938 94.7552 297.031 95.1719 297.182 95.4375C296.943 95.6146 296.646 95.7239 296.323 95.7239Z",
    fill: "#252326"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M297.547 95.7239C297.411 95.7239 297.281 95.6146 297.182 95.4375C297.031 95.1719 296.938 94.7552 296.938 94.2812V85.7187C296.938 84.9219 297.208 84.276 297.547 84.276C297.885 84.276 298.156 84.9219 298.156 85.7187V94.2812C298.156 94.5573 298.125 94.8177 298.068 95.0364C297.958 95.4479 297.766 95.7239 297.547 95.7239Z",
    fill: "#C16235"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M295.411 85.5469H294.266V89H295.411C295.943 89 296.375 88.5677 296.375 88.0365V86.5104C296.375 85.9792 295.943 85.5469 295.411 85.5469Z",
    fill: "#272526"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M295.411 85.5469H294.266V89H295.411C295.943 89 296.375 88.5677 296.375 88.0365V86.5104C296.375 85.9792 295.943 85.5469 295.411 85.5469Z",
    fill: "#272526"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M294.745 86.0104H294.266V88.5364H294.745C295.13 88.5364 295.448 88.2187 295.448 87.8281V86.7187C295.448 86.3281 295.13 86.0104 294.745 86.0104Z",
    fill: "#322F33"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M275.922 85.5469H277.063V89H275.922C275.391 89 274.958 88.5677 274.958 88.0365V86.5104C274.958 85.9792 275.391 85.5469 275.922 85.5469Z",
    fill: "#272526"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M275.922 85.5469H277.063V89H275.922C275.391 89 274.958 88.5677 274.958 88.0365V86.5104C274.958 85.9792 275.391 85.5469 275.922 85.5469Z",
    fill: "#272526"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M276.589 86.0104H277.062V88.5364H276.589C276.198 88.5364 275.885 88.2187 275.885 87.8281V86.7187C275.885 86.3281 276.198 86.0104 276.589 86.0104Z",
    fill: "#322F33"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M294.818 85.7969C294.818 84.8906 294.042 84.151 293.089 84.151H278.12C277.167 84.151 276.385 84.8906 276.385 85.7969L276.391 88.7656C276.391 88.8437 276.385 88.9219 276.385 89C276.385 89.0833 276.391 89.1667 276.391 89.2552C276.396 89.3073 276.396 89.3542 276.401 89.4062C276.49 90.5937 276.958 91.7031 277.724 92.526C278.516 93.3802 279.562 93.8542 280.667 93.8542C282.12 93.8542 283.464 93.026 284.255 91.6406L284.266 91.6198C284.625 90.9948 285.255 90.2969 285.604 90.2708C285.953 90.2969 286.583 90.9948 286.943 91.6198L286.953 91.6406C287.745 93.026 289.083 93.8542 290.542 93.8542C291.646 93.8542 292.687 93.3802 293.484 92.526C294.25 91.7031 294.719 90.5937 294.802 89.4062C294.812 89.3594 294.812 89.3073 294.812 89.2552C294.818 89.1667 294.818 89.0833 294.818 89C294.818 88.9219 294.818 88.8437 294.812 88.7656L294.818 85.7969Z",
    fill: "#272526"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M294.135 88.7761L294.141 85.7969C294.141 85.2656 293.667 84.8333 293.089 84.8333H278.12C277.536 84.8333 277.062 85.2656 277.062 85.7969L277.068 88.7761C277.068 88.8542 277.062 88.9271 277.062 89C277.062 89.0781 277.068 89.1563 277.073 89.2396C277.073 89.2761 277.073 89.3073 277.078 89.3333C277.224 91.4792 278.771 93.1719 280.667 93.1719C281.927 93.1719 283.036 92.4219 283.677 91.2813C283.693 91.25 284.641 89.6094 285.604 89.5886C286.568 89.6094 287.51 91.25 287.531 91.2813C288.172 92.4219 289.281 93.1719 290.542 93.1719C292.432 93.1719 293.984 91.4792 294.13 89.3333C294.135 89.3073 294.135 89.2761 294.135 89.2396C294.141 89.1563 294.141 89.0781 294.141 89C294.141 88.9271 294.141 88.8542 294.135 88.7761Z",
    fill: "#CFD2D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.6a747c4cfbda2a92a9a627bcbe39cb1e.svg";
export { ForwardRef as ReactComponent };